export const TelPhoneIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 14.5832H10.0083M6.83333 18.3332H13.1667C14.1001 18.3332 14.5668 18.3332 14.9233 18.1515C15.2369 17.9917 15.4919 17.7368 15.6517 17.4232C15.8333 17.0666 15.8333 16.5999 15.8333 15.6665V4.33317C15.8333 3.39975 15.8333 2.93304 15.6517 2.57652C15.4919 2.26292 15.2369 2.00795 14.9233 1.84816C14.5668 1.6665 14.1001 1.6665 13.1667 1.6665H6.83333C5.89991 1.6665 5.4332 1.6665 5.07668 1.84816C4.76308 2.00795 4.50811 2.26292 4.34832 2.57652C4.16667 2.93304 4.16667 3.39975 4.16667 4.33317V15.6665C4.16667 16.5999 4.16667 17.0666 4.34832 17.4232C4.50811 17.7368 4.76308 17.9917 5.07668 18.1515C5.4332 18.3332 5.89991 18.3332 6.83333 18.3332ZM10.4167 14.5832C10.4167 14.8133 10.2301 14.9998 10 14.9998C9.76988 14.9998 9.58333 14.8133 9.58333 14.5832C9.58333 14.3531 9.76988 14.1665 10 14.1665C10.2301 14.1665 10.4167 14.3531 10.4167 14.5832Z"
        stroke="#A9A29D"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SuccessIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99992 1.33325C4.31992 1.33325 1.33325 4.31992 1.33325 7.99992C1.33325 11.6799 4.31992 14.6666 7.99992 14.6666C11.6799 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.6799 1.33325 7.99992 1.33325ZM10.6866 6.79993L7.57324 9.90658C7.47991 10.0066 7.35324 10.0533 7.21991 10.0533C7.09324 10.0533 6.96658 10.0066 6.86658 9.90658L5.31325 8.35327C5.11992 8.15994 5.11992 7.8399 5.31325 7.64657C5.50659 7.45323 5.82658 7.45323 6.01992 7.64657L7.21991 8.8466L9.97992 6.09326C10.1733 5.89326 10.4933 5.89326 10.6866 6.09326C10.8799 6.2866 10.8799 6.59993 10.6866 6.79993Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export const InfoBilingIcon = ({ className }: any) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.3">
        <path
          d="M19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19C6 11.8203 11.8203 6 19 6Z"
          stroke="#FB6011"
          strokeWidth="2"
        />
      </g>
      <g opacity="0.1">
        <path
          d="M19 1C28.9411 1 37 9.05887 37 19C37 28.9411 28.9411 37 19 37C9.05887 37 1 28.9411 1 19C1 9.05887 9.05887 1 19 1Z"
          stroke="#FB6011"
          strokeWidth="2"
        />
      </g>
      <path
        d="M18.9998 22.3337V19.0003M18.9998 15.667H19.0082M27.3332 19.0003C27.3332 23.6027 23.6022 27.3337 18.9998 27.3337C14.3975 27.3337 10.6665 23.6027 10.6665 19.0003C10.6665 14.398 14.3975 10.667 18.9998 10.667C23.6022 10.667 27.3332 14.398 27.3332 19.0003Z"
        stroke="#FB6011"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarnOutlineIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 15.1663C4.04798 15.1663 0.833313 11.9517 0.833313 7.99967C0.833313 4.04767 4.04798 0.833008 7.99998 0.833008C11.952 0.833008 15.1666 4.04767 15.1666 7.99967C15.1666 11.9517 11.952 15.1663 7.99998 15.1663ZM7.99998 1.83301C4.59931 1.83301 1.83331 4.59901 1.83331 7.99967C1.83331 11.4003 4.59931 14.1663 7.99998 14.1663C11.4006 14.1663 14.1666 11.4003 14.1666 7.99967C14.1666 4.59901 11.4006 1.83301 7.99998 1.83301ZM8.67999 10.333C8.67999 9.96501 8.38199 9.66634 8.01333 9.66634H8.00665C7.63865 9.66634 7.34324 9.96501 7.34324 10.333C7.34324 10.701 7.64533 10.9997 8.01333 10.9997C8.38133 10.9997 8.67999 10.701 8.67999 10.333ZM8.49998 8.04704V4.99967C8.49998 4.72367 8.27598 4.49967 7.99998 4.49967C7.72398 4.49967 7.49998 4.72367 7.49998 4.99967V8.04704C7.49998 8.32304 7.72398 8.54704 7.99998 8.54704C8.27598 8.54704 8.49998 8.32304 8.49998 8.04704Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FrameIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5001 17.5H10.8334V5C10.8334 3.61929 11.9527 2.5 13.3334 2.5H17.5001C17.9603 2.5 18.3334 2.8731 18.3334 3.33333V16.6667C18.3334 17.1269 17.9603 17.5 17.5001 17.5ZM9.16675 17.5H2.50008C2.03985 17.5 1.66675 17.1269 1.66675 16.6667V3.33333C1.66675 2.8731 2.03985 2.5 2.50008 2.5H6.66675C8.04746 2.5 9.16675 3.61929 9.16675 5V17.5ZM9.16675 17.5H10.8334V19.1667H9.16675V17.5Z"
        fill="#FB6011"
      />
    </svg>
  );
};

export const PriceDetailsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 16.3125C2.17725 16.3125 2.10442 16.2982 2.03467 16.2697C1.82467 16.1827 1.6875 15.9773 1.6875 15.75V4.5C1.6875 2.6865 2.6865 1.6875 4.5 1.6875H13.5C15.3135 1.6875 16.3125 2.6865 16.3125 4.5V11.25C16.3125 13.0635 15.3135 14.0625 13.5 14.0625H4.73328L2.64825 16.1475C2.54025 16.2555 2.39625 16.3125 2.25 16.3125ZM4.5 2.8125C3.31725 2.8125 2.8125 3.31725 2.8125 4.5V14.3917L4.10248 13.1017C4.20823 12.996 4.35075 12.9368 4.5 12.9368H13.5C14.6827 12.9368 15.1875 12.432 15.1875 11.2493V4.49927C15.1875 3.31652 14.6827 2.81177 13.5 2.81177H4.5V2.8125Z"
        fill="#FB6011"
      />
      <path
        d="M6.9375 6.39825C6.9375 6.80775 7.0755 7.20748 7.32225 7.52023C7.5705 7.83898 7.9245 8.06994 8.3205 8.17044L9.40574 8.4397C9.71849 8.5192 9.9375 8.79892 9.9375 9.12067C9.9375 9.30667 9.864 9.48219 9.7305 9.61569C9.59775 9.74844 9.42225 9.82196 9.23625 9.82196H8.76375C8.40675 9.82196 8.10675 9.55347 8.06625 9.19647C8.03175 8.88747 7.746 8.66396 7.4445 8.70071C7.13625 8.73521 6.91426 9.01345 6.94876 9.32245C7.03951 10.1332 7.64851 10.7692 8.42251 10.9155V11.1345C8.42251 11.445 8.67451 11.697 8.98501 11.697C9.29551 11.697 9.54751 11.445 9.54751 11.1345V10.9162C9.91576 10.8524 10.2563 10.6807 10.5263 10.4107C10.872 10.065 11.0625 9.60668 11.0625 9.11993C11.0625 8.28293 10.4948 7.554 9.6795 7.34775L8.59426 7.07849C8.43976 7.03949 8.307 6.95321 8.208 6.82571C8.11425 6.70721 8.0625 6.555 8.0625 6.39825C8.0625 6.01125 8.37675 5.69696 8.76375 5.69696H9.23625C9.59325 5.69696 9.89325 5.96545 9.93375 6.32245C9.96825 6.63145 10.2533 6.85571 10.5555 6.81821C10.8638 6.78371 11.0857 6.50547 11.0512 6.19647C10.959 5.37597 10.335 4.73692 9.54751 4.60117V4.38446C9.54751 4.07396 9.29551 3.82196 8.98501 3.82196C8.67451 3.82196 8.42251 4.07396 8.42251 4.38446V4.60648C7.57801 4.76698 6.9375 5.508 6.9375 6.39825Z"
        fill="#FB6011"
      />
    </svg>
  );
};

export const CurrencyDollarIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 13.3333C5 15.1743 6.49238 16.6667 8.33333 16.6667H11.6667C13.5076 16.6667 15 15.1743 15 13.3333C15 11.4924 13.5076 10 11.6667 10H8.33333C6.49238 10 5 8.50762 5 6.66667C5 4.82572 6.49238 3.33334 8.33333 3.33334H11.6667C13.5076 3.33334 15 4.82572 15 6.66667M10 1.66667V18.3333"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeaderboardIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      viewBox="3.5 2 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4h8v2.5c0 3.3-1.8 5.7-4 5.7s-4-2.4-4-5.7V4Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M8.3 6H5.5v1.1c0 2.1 1.4 3.8 3.2 4.1M15.7 6h2.8v1.1c0 2.1-1.4 3.8-3.2 4.1"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M12 12.2V16m-3.2 4h6.4M10 16h4l.8 4H9.2l.8-4Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarningIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99992 1.83301C4.31792 1.83301 1.33325 4.81767 1.33325 8.49967C1.33325 12.1817 4.31792 15.1663 7.99992 15.1663C11.6819 15.1663 14.6666 12.1817 14.6666 8.49967C14.6666 4.81767 11.6819 1.83301 7.99992 1.83301ZM7.49992 5.49967C7.49992 5.22367 7.72392 4.99967 7.99992 4.99967C8.27592 4.99967 8.49992 5.22367 8.49992 5.49967V8.54704C8.49992 8.82304 8.27592 9.04704 7.99992 9.04704C7.72392 9.04704 7.49992 8.82304 7.49992 8.54704V5.49967ZM8.01327 11.4997C7.64527 11.4997 7.34318 11.201 7.34318 10.833C7.34318 10.465 7.63859 10.1663 8.00659 10.1663H8.01327C8.38193 10.1663 8.67993 10.465 8.67993 10.833C8.67993 11.201 8.38127 11.4997 8.01327 11.4997Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const WarnRedIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00008 1.16699C3.77833 1.16699 1.16675 3.77858 1.16675 7.00033C1.16675 10.2221 3.77833 12.8337 7.00008 12.8337C10.2218 12.8337 12.8334 10.2221 12.8334 7.00033C12.8334 3.77858 10.2218 1.16699 7.00008 1.16699ZM6.56258 4.37533C6.56258 4.13383 6.75858 3.93783 7.00008 3.93783C7.24158 3.93783 7.43758 4.13383 7.43758 4.37533V7.04177C7.43758 7.28327 7.24158 7.47927 7.00008 7.47927C6.75858 7.47927 6.56258 7.28327 6.56258 7.04177V4.37533ZM7.01176 9.62533C6.68976 9.62533 6.42544 9.36399 6.42544 9.04199C6.42544 8.71999 6.68392 8.45866 7.00592 8.45866H7.01176C7.33434 8.45866 7.59509 8.71999 7.59509 9.04199C7.59509 9.36399 7.33376 9.62533 7.01176 9.62533Z"
        fill="#D43710"
      />
    </svg>
  );
};

export const WarnIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      style={{ flexShrink: 0 }}
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74967 0.333252C3.06767 0.333252 0.0830078 3.31792 0.0830078 6.99992C0.0830078 10.6819 3.06767 13.6666 6.74967 13.6666C10.4317 13.6666 13.4163 10.6819 13.4163 6.99992C13.4163 3.31792 10.4317 0.333252 6.74967 0.333252ZM6.24967 3.99992C6.24967 3.72392 6.47367 3.49992 6.74967 3.49992C7.02567 3.49992 7.24967 3.72392 7.24967 3.99992V7.04728C7.24967 7.32328 7.02567 7.54728 6.74967 7.54728C6.47367 7.54728 6.24967 7.32328 6.24967 7.04728V3.99992ZM6.76302 9.99992C6.39502 9.99992 6.09294 9.70125 6.09294 9.33325C6.09294 8.96525 6.38835 8.66658 6.75635 8.66658H6.76302C7.13169 8.66658 7.42969 8.96525 7.42969 9.33325C7.42969 9.70125 7.13102 9.99992 6.76302 9.99992Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StarIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.56111 2.68106L8.69396 4.96598C8.77912 5.13806 8.94362 5.25707 9.13437 5.28449L11.7494 5.66246C12.2289 5.73188 12.4203 6.31989 12.0732 6.65705L10.1826 8.49165C10.0444 8.62581 9.98134 8.81889 10.014 9.00847L10.4462 11.5191C10.5337 12.0284 9.99883 12.4169 9.54033 12.1771L7.27237 10.9901C7.10203 10.9008 6.89901 10.9008 6.72926 10.9901L4.46301 12.176C4.00393 12.4163 3.46724 12.0272 3.55532 11.5168L3.98763 9.00847C4.02029 8.81889 3.95726 8.62581 3.81901 8.49165L1.92844 6.65705C1.58078 6.31989 1.77207 5.73188 2.25215 5.66246L4.86725 5.28449C5.05742 5.25707 5.22192 5.13806 5.30767 4.96598L6.44052 2.68106C6.6686 2.21731 7.33128 2.21731 7.56111 2.68106Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HalfStarIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.87491C9.01436 3.8749 9.02539 3.87926 9.03125 3.88272C9.03364 3.88417 9.03601 3.88544 9.03809 3.8876L9.0498 3.90518L10.5059 6.84268C10.7252 7.28574 11.1484 7.59055 11.6367 7.66104V7.66202L14.998 8.14639L12.5693 10.5048C12.2145 10.8493 12.0516 11.3466 12.1357 11.8349L12.6914 15.0624C12.6945 15.0804 12.6916 15.0871 12.6904 15.0898C12.6881 15.0953 12.6822 15.104 12.6709 15.1122C12.6597 15.1204 12.6492 15.1242 12.6426 15.1249C12.639 15.1252 12.6308 15.1256 12.6143 15.1171L9.69824 13.5907C9.47943 13.4761 9.23909 13.4186 8.99902 13.4189C8.76066 13.4191 8.52221 13.4767 8.30469 13.5907L5.39062 15.1151C5.37398 15.1239 5.36538 15.1233 5.36133 15.123C5.35432 15.1223 5.34266 15.1197 5.33105 15.1112C5.31955 15.1029 5.31395 15.0934 5.31152 15.0878C5.31034 15.0851 5.30737 15.0779 5.31055 15.0595L5.86621 11.8349C5.95036 11.3465 5.78754 10.8493 5.43262 10.5048L3.00293 8.14639L6.36523 7.66202C6.85348 7.59155 7.27524 7.28557 7.49512 6.84464L7.49609 6.84268L8.95312 3.90518L8.9541 3.90323C8.95875 3.89379 8.96201 3.88863 8.96387 3.88663C8.96584 3.88452 8.96838 3.88312 8.9707 3.88174C8.97597 3.8787 8.98601 3.87495 9 3.87491Z"
        stroke="#FB6011"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.65195 14.2551C8.76082 14.1979 8.88034 14.1692 8.99997 14.169V3.12491C8.71346 3.125 8.42728 3.27406 8.2807 3.5721L6.82419 6.50984C6.71394 6.73109 6.50243 6.88411 6.25793 6.91936L2.89566 7.40532C2.27841 7.49457 2.03246 8.25058 2.47946 8.68408L4.91019 11.0428C5.08794 11.2153 5.16898 11.4636 5.12698 11.7073L4.57117 14.9323C4.45792 15.5886 5.14794 16.0888 5.73819 15.7798L8.65195 14.2551Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BuildingIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2548"
      width="64"
      height="64"
    >
      <path
        d="M896 864h-32V256c0-103.168-56.832-160-160-160h-384C216.832 96 160 152.832 160 256v608H128a32 32 0 0 0 0 64h768a32 32 0 0 0 0-64z m-320 0h-128V746.666667c0-25.130667 6.869333-32 32-32h64c25.130667 0 32 6.869333 32 32v117.333333z m64 0V746.666667c0-60.117333-35.882667-96-96-96h-64c-60.117333 0-96 35.882667-96 96v117.333333H224V256c0-67.285333 28.714667-96 96-96h384c67.285333 0 96 28.714667 96 96v608H640z m32-309.333333a32 32 0 0 1-32 32h-42.666667a32 32 0 0 1 0-64h42.666667a32 32 0 0 1 32 32z m-213.333333 0a32 32 0 0 1-32 32H384a32 32 0 0 1 0-64h42.666667a32 32 0 0 1 32 32z m213.333333-128a32 32 0 0 1-32 32h-42.666667a32 32 0 0 1 0-64h42.666667a32 32 0 0 1 32 32z m-213.333333 0a32 32 0 0 1-32 32H384a32 32 0 0 1 0-64h42.666667a32 32 0 0 1 32 32z m213.333333-128a32 32 0 0 1-32 32h-42.666667a32 32 0 0 1 0-64h42.666667a32 32 0 0 1 32 32z m-213.333333 0a32 32 0 0 1-32 32H384a32 32 0 0 1 0-64h42.666667a32 32 0 0 1 32 32z"
        p-id="2549"
      ></path>
    </svg>
  );
};

export const DollarIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      viewBox="0 0 1066 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2832"
      width="64"
      height="64"
    >
      <path
        d="M524.629333 53.333333C271.701333 53.333333 65.962667 259.072 65.962667 512s205.738667 458.666667 458.666666 458.666667 458.666667-205.738667 458.666667-458.666667-205.738667-458.666667-458.666667-458.666667z m0 853.333334c-217.642667 0-394.666667-177.024-394.666666-394.666667s177.024-394.666667 394.666666-394.666667 394.666667 177.024 394.666667 394.666667-177.024 394.666667-394.666667 394.666667z m42.069334-417.194667l-68.608-17.024a47.829333 47.829333 0 0 1 11.562666-94.293333h29.866667c24.405333 0 44.842667 18.346667 47.616 42.666666a32 32 0 1 0 63.616-7.125333 111.658667 111.658667 0 0 0-95.104-98.090667V298.666667a32 32 0 0 0-64 0v17.237333a111.786667 111.786667 0 0 0-93.866667 110.037333c0 25.045333 8.405333 49.536 23.552 68.650667 15.189333 19.584 36.864 33.749333 61.184 39.893333l68.608 17.024c21.376 5.418667 36.309333 24.533333 36.309334 46.464 0 12.714667-4.992 24.704-14.08 33.792-9.088 9.088-21.077333 14.08-33.792 14.08h-29.866667c-24.405333 0-44.842667-18.346667-47.616-42.666666a32 32 0 1 0-63.616 7.125333 111.658667 111.658667 0 0 0 93.184 97.834667V725.333333a32 32 0 0 0 64 0v-16.981333a111.146667 111.146667 0 0 0 95.786667-110.293333 111.957333 111.957333 0 0 0-84.736-108.586667z"
        p-id="2833"
      ></path>
    </svg>
  );
};

export const CardIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {' '}
      <path
        d="M16 0.25H4C1.582 0.25 0.25 1.582 0.25 4V12C0.25 14.418 1.582 15.75 4 15.75H16C18.418 15.75 19.75 14.418 19.75 12V4C19.75 1.582 18.418 0.25 16 0.25ZM18.25 12C18.25 13.577 17.577 14.25 16 14.25H4C2.423 14.25 1.75 13.577 1.75 12V6.75H18.25V12ZM18.25 5.25H1.75V4C1.75 2.423 2.423 1.75 4 1.75H16C17.577 1.75 18.25 2.423 18.25 4V5.25ZM4.25 11C4.25 10.586 4.586 10.25 5 10.25H8C8.414 10.25 8.75 10.586 8.75 11C8.75 11.414 8.414 11.75 8 11.75H5C4.586 11.75 4.25 11.414 4.25 11Z"
        fill="#25314C"
      />
    </svg>
  );
};

export const CloseIcon = ({ className, onClick }: any) => {
  return (
    <svg
      className={className}
      style={{ transform: 'scale(1.5)' }}
      onClick={onClick}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2352"
      width="64"
      height="64"
    >
      <path
        d="M790.613333 745.386667a32 32 0 0 1-45.226666 45.269333L512 557.269333l-233.386667 233.386667a31.914667 31.914667 0 0 1-45.226666 0 32 32 0 0 1 0-45.269333L466.773333 512 233.386667 278.613333A32 32 0 1 1 278.656 233.386667l233.386667 233.386666 233.386666-233.386666a32 32 0 1 1 45.269334 45.269333L557.312 512l233.301333 233.386667z"
        p-id="2353"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const ClockIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      style={{ flexShrink: 0 }}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0.25C5.072 0.25 0.25 5.072 0.25 11C0.25 16.928 5.072 21.75 11 21.75C16.928 21.75 21.75 16.928 21.75 11C21.75 5.072 16.928 0.25 11 0.25ZM11 20.25C5.899 20.25 1.75 16.101 1.75 11C1.75 5.899 5.899 1.75 11 1.75C16.101 1.75 20.25 5.899 20.25 11C20.25 16.101 16.101 20.25 11 20.25ZM14.53 13.47C14.823 13.763 14.823 14.238 14.53 14.531C14.384 14.677 14.192 14.751 14 14.751C13.808 14.751 13.616 14.678 13.47 14.531L10.47 11.531C10.329 11.39 10.25 11.199 10.25 11.001V6.00098C10.25 5.58698 10.586 5.25098 11 5.25098C11.414 5.25098 11.75 5.58698 11.75 6.00098V10.6899L14.53 13.47Z"
        fill="#1C2024"
      />
    </svg>
  );
};

export const ClockBgIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00016 0.333252C3.31816 0.333252 0.333496 3.31792 0.333496 6.99992C0.333496 10.6819 3.31816 13.6666 7.00016 13.6666C10.6822 13.6666 13.6668 10.6819 13.6668 6.99992C13.6668 3.31792 10.6822 0.333252 7.00016 0.333252ZM9.35352 9.35327C9.25618 9.45061 9.12816 9.49992 9.00016 9.49992C8.87216 9.49992 8.74414 9.45127 8.64681 9.35327L6.64681 7.35327C6.55281 7.25927 6.50016 7.13192 6.50016 6.99992V3.66659C6.50016 3.39059 6.72416 3.16659 7.00016 3.16659C7.27616 3.16659 7.50016 3.39059 7.50016 3.66659V6.79256L9.35352 8.64592C9.54885 8.84192 9.54885 9.15794 9.35352 9.35327Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExclamationIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      style={{ flexShrink: 0 }}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21.75C5.072 21.75 0.25 16.928 0.25 11C0.25 5.072 5.072 0.25 11 0.25C16.928 0.25 21.75 5.072 21.75 11C21.75 16.928 16.928 21.75 11 21.75ZM11 1.75C5.899 1.75 1.75 5.899 1.75 11C1.75 16.101 5.899 20.25 11 20.25C16.101 20.25 20.25 16.101 20.25 11C20.25 5.899 16.101 1.75 11 1.75ZM12.02 14.5C12.02 13.948 11.573 13.5 11.02 13.5H11.01C10.458 13.5 10.0149 13.948 10.0149 14.5C10.0149 15.052 10.468 15.5 11.02 15.5C11.572 15.5 12.02 15.052 12.02 14.5ZM11.75 11.071V6.5C11.75 6.086 11.414 5.75 11 5.75C10.586 5.75 10.25 6.086 10.25 6.5V11.071C10.25 11.485 10.586 11.821 11 11.821C11.414 11.821 11.75 11.485 11.75 11.071Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AssetsAnnexIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      style={{ flexShrink: 0 }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3003_5721)">
        <path
          d="M8.16327 40.5952H31.8367C36.3469 40.5952 40 36.9422 40 32.4319V8.75848C40 4.24828 36.3469 0.595215 31.8367 0.595215H8.16327C3.65306 0.595215 0 4.24828 0 8.75848V32.4319C0 36.9422 3.65306 40.5952 8.16327 40.5952Z"
          fill="#32C36C"
        />
        <path
          d="M8.16327 40.5952H31.8367C36.3469 40.5952 40 36.9422 40 32.4319V8.75848C40 4.24828 36.3469 0.595215 31.8367 0.595215H8.16327C3.65306 0.595215 0 4.24828 0 8.75848V32.4319C0 36.9422 3.65306 40.5952 8.16327 40.5952Z"
          fill="url(#paint0_radial_3003_5721)"
          fillOpacity="0.2"
        />
        <path
          d="M26.1224 23.4524C28.3755 23.4524 30.204 21.6238 30.204 19.3707V0.595215H22.0408V19.3707C22.0408 21.6238 23.8693 23.4524 26.1224 23.4524Z"
          fill="#19693A"
        />
        <path
          d="M26.1224 16.9217C27.4735 16.9217 28.5714 18.0197 28.5714 19.3707C28.5714 20.7217 27.4735 21.8197 26.1224 21.8197C24.7714 21.8197 23.6735 20.7217 23.6735 19.3707C23.6735 18.0197 24.7714 16.9217 26.1224 16.9217ZM24.0816 2.22787H25.7143V1.41154H24.0816V0.595215H26.5306V1.41154H28.1633V2.22787H26.5306V3.04419H28.1633V3.86052H26.5306V4.67685H28.1633V5.49317H26.5306V6.3095H28.1633V7.12583H26.5306V7.94215H28.1633V8.75848H26.5306V9.57481H28.1633V10.3911H26.5306V11.2075H28.1633V12.0238H26.5306V12.8401H28.1633V13.6564H26.5306V14.4728H28.1633V15.2891H26.5306V16.1054H28.1633V16.9217H25.7143V16.1054H24.0816V15.2891H25.7143V14.4728H24.0816V13.6564H25.7143V12.8401H24.0816V12.0238H25.7143V11.2075H24.0816V10.3911H25.7143V9.57481H24.0816V8.75848H25.7143V7.94215H24.0816V7.12583H25.7143V6.3095H24.0816V5.49317H25.7143V4.67685H24.0816V3.86052H25.7143V3.04419H24.0816V2.22787ZM26.1224 20.1871C26.5714 20.1871 26.9388 19.8197 26.9388 19.3707C26.9388 18.9217 26.5714 18.5544 26.1224 18.5544C25.6735 18.5544 25.3061 18.9217 25.3061 19.3707C25.3061 19.8197 25.6735 20.1871 26.1224 20.1871Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3003_5721"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 0.595215) rotate(90) scale(28.7163)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_3003_5721">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.595215)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CardAnnexIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      style={{ flexShrink: 0 }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3003_5730)">
        <path
          d="M8.16327 40.5952H31.8367C36.3469 40.5952 40 36.9422 40 32.4319V8.75848C40 4.24828 36.3469 0.595215 31.8367 0.595215H8.16327C3.65306 0.595215 0 4.24828 0 8.75848V32.4319C0 36.9422 3.65306 40.5952 8.16327 40.5952Z"
          fill="#F9CF3D"
        />
        <path
          d="M8.16327 40.5952H31.8367C36.3469 40.5952 40 36.9422 40 32.4319V8.75848C40 4.24828 36.3469 0.595215 31.8367 0.595215H8.16327C3.65306 0.595215 0 4.24828 0 8.75848V32.4319C0 36.9422 3.65306 40.5952 8.16327 40.5952Z"
          fill="url(#paint0_radial_3003_5730)"
          fillOpacity="0.2"
        />
        <path
          d="M26.1224 23.4524C28.3755 23.4524 30.204 21.6238 30.204 19.3707V0.595215H22.0408V19.3707C22.0408 21.6238 23.8693 23.4524 26.1224 23.4524Z"
          fill="#B06700"
        />
        <path
          d="M26.1224 16.9217C27.4735 16.9217 28.5714 18.0197 28.5714 19.3707C28.5714 20.7217 27.4735 21.8197 26.1224 21.8197C24.7714 21.8197 23.6735 20.7217 23.6735 19.3707C23.6735 18.0197 24.7714 16.9217 26.1224 16.9217ZM24.0816 2.22787H25.7143V1.41154H24.0816V0.595215H26.5306V1.41154H28.1633V2.22787H26.5306V3.04419H28.1633V3.86052H26.5306V4.67685H28.1633V5.49317H26.5306V6.3095H28.1633V7.12583H26.5306V7.94215H28.1633V8.75848H26.5306V9.57481H28.1633V10.3911H26.5306V11.2075H28.1633V12.0238H26.5306V12.8401H28.1633V13.6564H26.5306V14.4728H28.1633V15.2891H26.5306V16.1054H28.1633V16.9217H25.7143V16.1054H24.0816V15.2891H25.7143V14.4728H24.0816V13.6564H25.7143V12.8401H24.0816V12.0238H25.7143V11.2075H24.0816V10.3911H25.7143V9.57481H24.0816V8.75848H25.7143V7.94215H24.0816V7.12583H25.7143V6.3095H24.0816V5.49317H25.7143V4.67685H24.0816V3.86052H25.7143V3.04419H24.0816V2.22787ZM26.1224 20.1871C26.5714 20.1871 26.9388 19.8197 26.9388 19.3707C26.9388 18.9217 26.5714 18.5544 26.1224 18.5544C25.6735 18.5544 25.3061 18.9217 25.3061 19.3707C25.3061 19.8197 25.6735 20.1871 26.1224 20.1871Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3003_5730"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 0.595215) rotate(90) scale(28.7163)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_3003_5730">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.595215)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BrandAnnexIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      style={{ flexShrink: 0 }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3003_5739)">
        <path
          d="M8.16327 40.5952H31.8367C36.3469 40.5952 40 36.9422 40 32.4319V8.75848C40 4.24828 36.3469 0.595215 31.8367 0.595215H8.16327C3.65306 0.595215 0 4.24828 0 8.75848V32.4319C0 36.9422 3.65306 40.5952 8.16327 40.5952Z"
          fill="#5A31F0"
        />
        <path
          d="M8.16327 40.5952H31.8367C36.3469 40.5952 40 36.9422 40 32.4319V8.75848C40 4.24828 36.3469 0.595215 31.8367 0.595215H8.16327C3.65306 0.595215 0 4.24828 0 8.75848V32.4319C0 36.9422 3.65306 40.5952 8.16327 40.5952Z"
          fill="url(#paint0_radial_3003_5739)"
          fillOpacity="0.2"
        />
        <path
          d="M26.1224 23.4524C28.3755 23.4524 30.204 21.6238 30.204 19.3707V0.595215H22.0408V19.3707C22.0408 21.6238 23.8693 23.4524 26.1224 23.4524Z"
          fill="#4F15DE"
        />
        <path
          d="M26.1224 16.9217C27.4735 16.9217 28.5714 18.0197 28.5714 19.3707C28.5714 20.7217 27.4735 21.8197 26.1224 21.8197C24.7714 21.8197 23.6735 20.7217 23.6735 19.3707C23.6735 18.0197 24.7714 16.9217 26.1224 16.9217ZM24.0816 2.22787H25.7143V1.41154H24.0816V0.595215H26.5306V1.41154H28.1633V2.22787H26.5306V3.04419H28.1633V3.86052H26.5306V4.67685H28.1633V5.49317H26.5306V6.3095H28.1633V7.12583H26.5306V7.94215H28.1633V8.75848H26.5306V9.57481H28.1633V10.3911H26.5306V11.2075H28.1633V12.0238H26.5306V12.8401H28.1633V13.6564H26.5306V14.4728H28.1633V15.2891H26.5306V16.1054H28.1633V16.9217H25.7143V16.1054H24.0816V15.2891H25.7143V14.4728H24.0816V13.6564H25.7143V12.8401H24.0816V12.0238H25.7143V11.2075H24.0816V10.3911H25.7143V9.57481H24.0816V8.75848H25.7143V7.94215H24.0816V7.12583H25.7143V6.3095H24.0816V5.49317H25.7143V4.67685H24.0816V3.86052H25.7143V3.04419H24.0816V2.22787ZM26.1224 20.1871C26.5714 20.1871 26.9388 19.8197 26.9388 19.3707C26.9388 18.9217 26.5714 18.5544 26.1224 18.5544C25.6735 18.5544 25.3061 18.9217 25.3061 19.3707C25.3061 19.8197 25.6735 20.1871 26.1224 20.1871Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_3003_5739"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20 0.595215) rotate(90) scale(28.7163)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_3003_5739">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.595215)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="null"
        id="svg_1"
        fill="#1C2024"
        d="m9.828367,17.052721c-0.441824,-0.441643 -0.441824,-1.157934 0,-1.599758c0.441824,-0.441643 1.157934,-0.441643 1.599758,0l2.593228,2.593409l0,-16.870006c0,-0.624199 0.506596,-1.130794 1.130794,-1.130794c0.624199,0 1.130794,0.506596 1.130794,1.130794l0,16.870006l2.593228,-2.593409c0.441824,-0.441643 1.158114,-0.441643 1.599758,0c0.441824,0.441824 0.441824,1.158114 0,1.599758l-4.523178,4.523178c-0.104033,0.104033 -0.229054,0.187079 -0.367644,0.244252c-0.138771,0.057354 -0.285141,0.087388 -0.432959,0.087388c-0.147817,0 -0.293826,-0.030034 -0.432416,-0.087388c-0.138771,-0.057173 -0.264154,-0.140219 -0.368187,-0.244252l-4.523178,-4.523178zm14.368689,-6.453127c-0.624199,0 -1.130794,0.506596 -1.130794,1.130794c0,0.624199 0.506596,1.130794 1.130794,1.130794c2.377744,0 3.392383,1.01482 3.392383,3.392383l0,7.53869c0,2.377744 -1.014639,3.392383 -3.392383,3.392383l-18.092711,0c-2.377744,0 -3.392383,-1.014639 -3.392383,-3.392383l0,-7.53869c0,-2.377563 1.014639,-3.392383 3.392383,-3.392383c0.624199,0 1.130794,-0.506596 1.130794,-1.130794c0,-0.624199 -0.506596,-1.130794 -1.130794,-1.130794c-3.645681,0 -5.653972,2.008291 -5.653972,5.653972l0,7.53869c0,3.645681 2.008291,5.653972 5.653972,5.653972l18.092711,0c3.645681,0 5.653972,-2.008291 5.653972,-5.653972l0,-7.53869c0,-3.645681 -2.008291,-5.653972 -5.653972,-5.653972z"
      />
    </svg>
  );
};

export const ContactEmailIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3.83333H4C2.66667 3.83333 2 4.49999 2 5.83333V11.8333C2 13.1667 2.66667 13.8333 4 13.8333H12C13.3333 13.8333 14 13.1667 14 11.8333V5.83333C14 4.49999 13.3333 3.83333 12 3.83333ZM11.9606 6.904L8.68604 9.28532C8.4807 9.43466 8.24 9.50933 8 9.50933C7.76 9.50933 7.51863 9.43466 7.31396 9.286L4.03939 6.904C3.81605 6.742 3.7667 6.42866 3.92936 6.20533C4.09136 5.98266 4.4026 5.932 4.62793 6.09533L7.90267 8.47666C7.96134 8.51866 8.03932 8.51933 8.09798 8.47666L11.3727 6.09533C11.5974 5.932 11.9093 5.98266 12.0713 6.20533C12.234 6.42933 12.1839 6.742 11.9606 6.904Z"
        fill="#09090B"
      />
    </svg>
  );
};

export const WhatAppsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 14.5L0.984084 10.9049C0.376833 9.85258 0.05775 8.65967 0.0583334 7.43642C0.0600834 3.61208 3.17217 0.5 6.99592 0.5C8.8515 0.500583 10.5933 1.22333 11.9035 2.53467C13.2131 3.846 13.9341 5.589 13.9335 7.44283C13.9318 11.2678 10.8197 14.3798 6.99592 14.3798C5.83509 14.3793 4.69117 14.0882 3.67792 13.5352L0 14.5ZM3.84825 12.2793C4.82592 12.8597 5.75925 13.2073 6.99359 13.2079C10.1716 13.2079 12.7604 10.6214 12.7622 7.44167C12.7633 4.2555 10.1868 1.6725 6.99825 1.67133C3.81792 1.67133 1.23083 4.25783 1.22967 7.437C1.22908 8.73492 1.60942 9.70675 2.24817 10.7235L1.66542 12.8515L3.84825 12.2793ZM10.4907 9.09192C10.4475 9.01958 10.332 8.97642 10.1582 8.8895C9.98492 8.80258 9.13267 8.38317 8.97342 8.32542C8.81475 8.26767 8.69925 8.2385 8.58317 8.41233C8.46767 8.58558 8.13517 8.97642 8.03425 9.09192C7.93334 9.20742 7.83184 9.222 7.65859 9.13508C7.48534 9.04817 6.9265 8.86558 6.26442 8.27467C5.74934 7.815 5.40108 7.24742 5.30017 7.07358C5.19925 6.90033 5.28967 6.80642 5.376 6.72008C5.45417 6.6425 5.54925 6.51767 5.63617 6.41617C5.72425 6.31583 5.75284 6.2435 5.81117 6.12742C5.86892 6.01192 5.84034 5.91042 5.79659 5.8235C5.75284 5.73717 5.40634 4.88375 5.26225 4.53667C5.12109 4.19892 4.97817 4.24442 4.872 4.23917L4.5395 4.23333C4.424 4.23333 4.23617 4.2765 4.0775 4.45033C3.91883 4.62417 3.47083 5.043 3.47083 5.89642C3.47083 6.74983 4.09208 7.57408 4.17842 7.68958C4.26533 7.80508 5.4005 9.55625 7.13942 10.307C7.553 10.4855 7.87617 10.5923 8.12759 10.6722C8.54292 10.804 8.92092 10.7853 9.21959 10.741C9.55267 10.6914 10.2451 10.3216 10.3898 9.91675C10.5344 9.51133 10.5344 9.16425 10.4907 9.09192Z"
        fill="#25D366"
      />
    </svg>
  );
};

export const LockIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0625 6.22797V5.25C13.0625 3.28575 11.4643 1.6875 9.5 1.6875C7.53575 1.6875 5.9375 3.28575 5.9375 5.25V6.22797C4.484 6.42072 3.6875 7.3845 3.6875 9V13.5C3.6875 15.3135 4.6865 16.3125 6.5 16.3125H12.5C14.3135 16.3125 15.3125 15.3135 15.3125 13.5V9C15.3125 7.38525 14.516 6.42147 13.0625 6.22797ZM9.5 2.8125C10.844 2.8125 11.9375 3.906 11.9375 5.25V6.1875H7.0625V5.25C7.0625 3.906 8.156 2.8125 9.5 2.8125ZM14.1875 13.5C14.1875 14.6827 13.6827 15.1875 12.5 15.1875H6.5C5.31725 15.1875 4.8125 14.6827 4.8125 13.5V9C4.8125 7.81725 5.31725 7.3125 6.5 7.3125H12.5C13.6827 7.3125 14.1875 7.81725 14.1875 9V13.5ZM10.4525 10.5C10.4525 10.809 10.2935 11.07 10.0625 11.2403V12.75C10.0625 13.0605 9.8105 13.3125 9.5 13.3125C9.1895 13.3125 8.9375 13.0605 8.9375 12.75V11.2214C8.7215 11.0497 8.57367 10.7963 8.57367 10.5C8.57367 9.9825 8.99001 9.5625 9.50751 9.5625H9.51501C10.0325 9.5625 10.4525 9.9825 10.4525 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HelpIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.236 15.1667C4.284 15.1667 1.06934 11.952 1.06934 8.00004C1.06934 4.04804 4.284 0.833374 8.236 0.833374C12.188 0.833374 15.4027 4.04804 15.4027 8.00004C15.4027 11.952 12.188 15.1667 8.236 15.1667ZM8.236 1.83337C4.83534 1.83337 2.06934 4.59937 2.06934 8.00004C2.06934 11.4007 4.83534 14.1667 8.236 14.1667C11.6367 14.1667 14.4027 11.4007 14.4027 8.00004C14.4027 4.59937 11.6367 1.83337 8.236 1.83337ZM8.70996 8.90938C8.72596 8.86138 8.81669 8.67941 9.30469 8.35274C10.0914 7.82541 10.4434 7.07201 10.2974 6.23067C10.1494 5.38067 9.45663 4.68272 8.61263 4.53406C7.99596 4.42472 7.37131 4.59066 6.89665 4.988C6.41731 5.39 6.14274 5.97997 6.14274 6.6073C6.14274 6.8833 6.36674 7.1073 6.64274 7.1073C6.91874 7.1073 7.14274 6.8833 7.14274 6.6073C7.14274 6.27663 7.28739 5.96544 7.53939 5.75411C7.79005 5.54411 8.10997 5.45811 8.43864 5.51811C8.86931 5.59411 9.23666 5.96541 9.31266 6.40141C9.34133 6.56607 9.42871 7.06603 8.74805 7.52136C8.19671 7.89136 7.88336 8.2307 7.7627 8.5907C7.6747 8.8527 7.81596 9.136 8.07796 9.224C8.13063 9.242 8.18399 9.25004 8.23665 9.25004C8.44465 9.25004 8.63929 9.11805 8.70996 8.90938ZM8.91602 11C8.91602 10.632 8.61802 10.3334 8.24935 10.3334H8.24268C7.87468 10.3334 7.57926 10.632 7.57926 11C7.57926 11.368 7.88135 11.6667 8.24935 11.6667C8.61735 11.6667 8.91602 11.368 8.91602 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BookOpenIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9199 7.55465C14.9719 7.62665 15 7.71597 15 7.8053V25.3973C15 25.6973 14.684 25.8786 14.416 25.7452C11.236 24.1586 8.04525 24.1627 4.86525 25.068C4.42525 25.188 3.99872 24.8814 3.99872 24.4414V7.09469C3.99872 6.83736 4.1466 6.59468 4.3786 6.48401C6.56793 5.44135 8.88936 5.14657 11.3054 5.4399C12.8054 5.62124 14.0893 6.41465 14.9199 7.55465ZM28 7.09322V24.4399C28 24.8799 27.5735 25.1867 27.1335 25.0667C23.9548 24.1614 20.764 24.1573 17.5827 25.7439C17.3147 25.8773 16.9987 25.696 16.9987 25.396V7.804C16.9987 7.71467 17.0268 7.62535 17.0788 7.55335C17.9095 6.41335 19.1947 5.61994 20.6921 5.4386C23.1081 5.14527 25.4308 5.43871 27.6188 6.48271C27.8522 6.59338 28 6.83589 28 7.09322ZM23.6667 16C23.6667 15.448 23.2187 15 22.6667 15H20C19.448 15 19 15.448 19 16C19 16.552 19.448 17 20 17H22.6667C23.2187 17 23.6667 16.552 23.6667 16ZM25 12C25 11.448 24.552 11 24 11H20C19.448 11 19 11.448 19 12C19 12.552 19.448 13 20 13H24C24.552 13 25 12.552 25 12Z"
        fill="#292524"
      />
    </svg>
  );
};

export const BookOpenOutlineIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10 7.83333C10 5.96649 10 5.03307 10.3633 4.32003C10.6829 3.69282 11.1928 3.18289 11.82 2.86331C12.5331 2.5 13.4665 2.5 15.3333 2.5H15.6667C16.6001 2.5 17.0668 2.5 17.4233 2.68166C17.7369 2.84144 17.9919 3.09641 18.1517 3.41002C18.3333 3.76654 18.3333 4.23325 18.3333 5.16667V12.3333C18.3333 13.2668 18.3333 13.7335 18.1517 14.09C17.9919 14.4036 17.7369 14.6586 17.4233 14.8183C17.0668 15 16.6001 15 15.6667 15H14.521C13.4774 15 12.9556 15 12.482 15.1438C12.0627 15.2712 11.6726 15.4799 11.3341 15.7582C10.9517 16.0725 10.6622 16.5066 10.0834 17.3749L10 17.5L9.91662 17.3749C9.33775 16.5066 9.04832 16.0725 8.66592 15.7582C8.32738 15.4799 7.9373 15.2712 7.518 15.1438C7.04438 15 6.52259 15 5.47902 15H4.33333C3.39991 15 2.9332 15 2.57668 14.8183C2.26308 14.6586 2.00811 14.4036 1.84832 14.09C1.66667 13.7335 1.66667 13.2668 1.66667 12.3333V5.16667C1.66667 4.23325 1.66667 3.76654 1.84832 3.41002C2.00811 3.09641 2.26308 2.84144 2.57668 2.68166C2.9332 2.5 3.39991 2.5 4.33333 2.5H4.66667C6.53351 2.5 7.46693 2.5 8.17997 2.86331C8.80717 3.18289 9.31711 3.69282 9.63669 4.32003C10 5.03307 10 5.96649 10 7.83333ZM10 17.5V7.83333"
        stroke="#171717"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TopArrowIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99997 7.49977C10.2133 7.49977 10.4267 7.58141 10.5892 7.74391L13.9225 11.0772C14.2483 11.4031 14.2483 11.9298 13.9225 12.2556C13.5967 12.5815 13.0699 12.5815 12.7441 12.2556L9.99997 9.51148L7.25583 12.2556C6.93 12.5815 6.40328 12.5815 6.07744 12.2556C5.75161 11.9298 5.75161 11.4031 6.07744 11.0772L9.41078 7.74391C9.57328 7.58141 9.78664 7.49977 9.99997 7.49977Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightArrowIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99978 16.75C9.80778 16.75 9.61575 16.6771 9.46975 16.5301C9.17675 16.2371 9.17675 15.762 9.46975 15.469L12.9397 11.999L9.46975 8.52908C9.17675 8.23608 9.17675 7.76104 9.46975 7.46804C9.76275 7.17504 10.2378 7.17504 10.5308 7.46804L14.5308 11.468C14.8238 11.761 14.8238 12.2361 14.5308 12.5291L10.5308 16.5291C10.3838 16.6771 10.1918 16.75 9.99978 16.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LeftArrowIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9998 19.7498C14.8078 19.7498 14.6157 19.6768 14.4697 19.5298L7.46975 12.5298C7.17675 12.2368 7.17675 11.7618 7.46975 11.4688L14.4697 4.46877C14.7628 4.17577 15.2378 4.17577 15.5308 4.46877C15.8238 4.76177 15.8238 5.23681 15.5308 5.52981L9.06081 11.9998L15.5308 18.4698C15.8238 18.7628 15.8238 19.2378 15.5308 19.5308C15.3838 19.6768 15.1918 19.7498 14.9998 19.7498Z"
        fill="#25314C"
      />
    </svg>
  );
};

export const EmptyBrandIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="117"
      height="100"
      viewBox="0 0 117 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.5001 80C79.5756 80 97.4713 62.0914 97.4713 40C97.4713 17.9086 79.5756 0 57.5001 0C35.4245 0 17.5288 17.9086 17.5288 40C17.5288 62.0914 35.4245 80 57.5001 80Z"
        fill="#EAEEF9"
      />
      <path
        d="M51.267 18.8944L50.2393 16.0149C50.0338 15.295 49.3144 14.8837 48.5951 14.8837H30.4055C28.864 14.8837 27.6309 16.0149 27.6309 17.6603V58.282V53.5974C27.6309 52.4929 28.5263 51.5974 29.6309 51.5974H87.4958C88.6004 51.5974 89.4958 50.702 89.4958 49.5974V22.8023C89.4958 21.2597 88.3654 20.0257 86.7212 20.0257H52.8085C52.2946 20.0257 51.5753 19.6143 51.267 18.8944Z"
        fill="url(#paint0_linear_1285_3692)"
      />
      <g filter="url(#filter0_d_1285_3692)">
        <path
          d="M94.5003 31.5437L89.4648 62.9098C89.1565 64.7609 87.5122 66.2007 85.6625 66.2007H30.3745C28.4219 66.2007 26.8804 64.8638 26.5722 62.9098L22.3588 37.1999C22.0505 35.2459 23.4892 33.3948 25.5445 33.3948H56.6825C57.6074 33.3948 58.4295 32.7778 58.7378 31.8522L59.6627 29.0756C59.971 28.15 60.7931 27.533 61.718 27.533H91.4173C93.2671 27.7386 94.8086 29.4869 94.5003 31.5437Z"
          fill="url(#paint1_linear_1285_3692)"
        />
      </g>
      <path
        d="M63.5758 13.879L64.4626 13.4845C64.7582 13.3859 64.7582 12.9915 64.4626 12.8929L63.5758 12.4985C62.4919 12.0054 61.605 11.118 61.1123 10.0333L60.7182 9.14582C60.6197 8.84999 60.2255 8.84999 60.127 9.14582L59.7328 10.0333C59.2402 11.118 58.3533 12.0054 57.2694 12.4985L56.3826 12.8929C56.087 12.9915 56.087 13.3859 56.3826 13.4845L57.2694 13.879C58.3533 14.372 59.2402 15.2595 59.7328 16.3442L60.127 17.2316C60.2255 17.5274 60.6197 17.5274 60.7182 17.2316L61.1123 16.3442C61.5065 15.2595 62.3933 14.372 63.5758 13.879Z"
        fill="#AAB2C5"
      />
      <path
        d="M54.0176 8.25818L54.6088 7.96236C54.8059 7.86375 54.8059 7.66654 54.6088 7.56793L54.0176 7.37071C53.2293 7.07489 52.6381 6.48325 52.3425 5.69439L52.0468 5.10275C51.9483 4.90553 51.7512 4.90553 51.6527 5.10275L51.4556 5.69439C51.0615 6.48325 50.4703 7.07489 49.7805 7.37071L49.0907 7.66654C48.9922 7.66654 48.9922 7.96236 49.0907 7.96236L49.682 8.25818C50.4703 8.554 51.0615 9.14565 51.4556 9.93451L51.7512 10.5262C51.8498 10.7234 52.0468 10.7234 52.1454 10.5262L52.3425 9.93451C52.6381 9.14565 53.2293 8.554 54.0176 8.25818Z"
        fill="#AAB2C5"
      />
      <path
        d="M61.6045 2.53914L62.0972 2.34192C62.1958 2.24332 62.1958 2.14471 62.0972 2.0461L61.6045 1.84889C61.0133 1.65167 60.6192 1.15864 60.3236 0.566992L60.1265 0.0739555C60.028 -0.0246518 59.9294 -0.0246518 59.8309 0.0739555L59.6338 0.566992C59.4367 1.15864 58.9441 1.55307 58.3528 1.84889L58.0572 2.0461C57.8602 2.14471 57.8602 2.34192 58.0572 2.34192L58.5499 2.53914C59.1411 2.73635 59.5353 3.22939 59.8309 3.82104L60.028 4.31407C60.1265 4.41268 60.225 4.41268 60.3236 4.31407L60.5206 3.82104C60.6192 3.22939 61.1119 2.73635 61.6045 2.53914Z"
        fill="#AAB2C5"
      />
      <defs>
        <filter
          id="filter0_d_1285_3692"
          x="0.317139"
          y="16.533"
          width="116.223"
          height="82.6677"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1285_3692"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1285_3692"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1285_3692"
          x1="43.2511"
          y1="12.8082"
          x2="36.4176"
          y2="33.6281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1285_3692"
          x1="58.4049"
          y1="26.6385"
          x2="58.4049"
          y2="66.6175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DedicatedVideoIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 1.5H4.25C2.47667 1.5 1.5 2.47667 1.5 4.25V11.75C1.5 13.5233 2.47667 14.5 4.25 14.5H11.75C13.5233 14.5 14.5 13.5233 14.5 11.75V4.25C14.5 2.47667 13.5233 1.5 11.75 1.5ZM13.5 4.25V5.5H10.5V2.5H11.75C12.9767 2.5 13.5 3.02333 13.5 4.25ZM6.5 5.5V2.5H9.5V5.5H6.5ZM4.25 2.5H5.5V5.5H2.5V4.25C2.5 3.02333 3.02333 2.5 4.25 2.5ZM11.75 13.5H4.25C3.02333 13.5 2.5 12.9767 2.5 11.75V6.5H13.5V11.75C13.5 12.9767 12.9767 13.5 11.75 13.5ZM9.98202 8.74333L7.8833 7.45866C7.5353 7.24533 7.09801 7.23735 6.74268 7.43669C6.38201 7.63869 6.16732 8.0053 6.16732 8.41797V10.9154C6.16732 11.328 6.38201 11.6946 6.74268 11.8966C6.91401 11.9926 7.10403 12.0407 7.29403 12.0407C7.49869 12.0407 7.70263 11.9853 7.8833 11.8747L9.98136 10.5907C10.306 10.392 10.5 10.0467 10.5 9.66667C10.5 9.28667 10.306 8.94133 9.98202 8.74333ZM9.45931 9.7373L7.36068 11.022C7.30601 11.0546 7.2607 11.0407 7.23136 11.0247C7.20203 11.0081 7.16667 10.976 7.16667 10.9154V8.41797C7.16667 8.35797 7.20203 8.32526 7.23136 8.30859C7.24736 8.29926 7.26934 8.29134 7.29468 8.29134C7.31468 8.29134 7.33733 8.29669 7.36133 8.31136L9.45996 9.59603C9.45996 9.59603 9.46003 9.59603 9.46069 9.59603C9.48669 9.61203 9.50065 9.63602 9.50065 9.66602C9.50065 9.69602 9.48598 9.7213 9.45931 9.7373Z"
        fill="#25314C"
      />
    </svg>
  );
};

export const TimeLineDot = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="5"
        height="5"
        rx="2.5"
        stroke="#FB6011"
        strokeWidth="3"
      />
    </svg>
  );
};

export const CoffeeIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7082 15.75C24.7082 13.02 22.4798 10.7917 19.7498 10.7917H5.74984C4.94484 10.7917 4.2915 11.445 4.2915 12.25V21C4.2915 23.8233 5.84317 25.375 8.6665 25.375H15.6665C18.4898 25.375 20.0415 23.8233 20.0415 21V20.6733C22.6432 20.5217 24.7082 18.375 24.7082 15.75ZM20.0415 18.9233V12.565C21.6748 12.7167 22.9582 14.07 22.9582 15.7384C22.9582 17.4067 21.6748 18.7717 20.0415 18.9117V18.9233ZM14.2898 6.26501C13.4148 5.37834 13.4148 3.93167 14.2898 3.05667L14.4648 2.88168C14.8032 2.54335 15.3632 2.54335 15.7015 2.88168C16.0398 3.22001 16.0515 3.78001 15.7015 4.11834L15.5265 4.29334C15.3165 4.50334 15.3165 4.83002 15.5265 5.04002L15.8765 5.39001C16.7515 6.27667 16.7515 7.72334 15.8765 8.59834L15.7015 8.77335C15.5265 8.94835 15.3048 9.03002 15.0832 9.03002C14.8615 9.03002 14.6398 8.94835 14.4648 8.77335C14.1265 8.43502 14.1148 7.87502 14.4648 7.53669L14.6398 7.36168C14.8498 7.15168 14.8498 6.82501 14.6398 6.61501L14.2898 6.26501ZM8.45651 6.26501C7.58151 5.37834 7.58151 3.93167 8.45651 3.05667L8.63151 2.88168C8.96984 2.54335 9.52984 2.54335 9.86817 2.88168C10.2065 3.22001 10.2182 3.78001 9.86817 4.11834L9.69318 4.29334C9.48318 4.50334 9.48318 4.83002 9.69318 5.04002L10.0432 5.39001C10.9182 6.27667 10.9182 7.72334 10.0432 8.59834L9.86817 8.77335C9.69317 8.94835 9.4715 9.03002 9.24984 9.03002C9.02817 9.03002 8.80651 8.94835 8.63151 8.77335C8.29317 8.43502 8.28151 7.87502 8.63151 7.53669L8.8065 7.36168C9.0165 7.15168 9.0165 6.82501 8.8065 6.61501L8.45651 6.26501Z"
        fill="#5C281D"
      />
    </svg>
  );
};

export const BadgeIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4755 11.5267L22.9611 11.0122C22.6333 10.6843 22.4488 10.2387 22.4488 9.77433V9.04983C22.4488 7.11783 20.8833 5.55218 18.9513 5.55218H18.2268C17.7625 5.55218 17.3179 5.36785 16.9889 5.04002L16.4744 4.52551C15.1082 3.15934 12.8939 3.15934 11.5277 4.52551L11.0132 5.04002C10.6853 5.36785 10.2398 5.55218 9.77544 5.55218H9.05097C7.11897 5.55218 5.55325 7.11783 5.55325 9.04983V9.77433C5.55325 10.2387 5.36896 10.6832 5.04112 11.0122L4.52658 11.5267C3.16041 12.8929 3.16041 15.1072 4.52658 16.4733L5.04112 16.9879C5.36896 17.3157 5.55325 17.7614 5.55325 18.2257V18.9502C5.55325 20.8822 7.11897 22.4478 9.05097 22.4478H9.77544C10.2398 22.4478 10.6842 22.6322 11.0132 22.96L11.5277 23.4745C12.8939 24.8407 15.1082 24.8407 16.4744 23.4745L16.9889 22.96C17.3168 22.6322 17.7625 22.4478 18.2268 22.4478H18.9513C20.8833 22.4478 22.4488 20.8822 22.4488 18.9502V18.2257C22.4488 17.7614 22.6333 17.3169 22.9611 16.9879L23.4755 16.4733C24.8417 15.1072 24.8417 12.8929 23.4755 11.5267ZM18.1183 12.285L13.4516 16.9517C13.2813 17.122 13.0572 17.2083 12.8332 17.2083C12.6092 17.2083 12.3852 17.1232 12.2149 16.9517L9.88154 14.6183C9.5397 14.2765 9.5397 13.7223 9.88154 13.3805C10.2234 13.0387 10.7776 13.0387 11.1194 13.3805L12.8344 15.0955L16.8827 11.0472C17.2245 10.7053 17.7787 10.7053 18.1206 11.0472C18.4601 11.389 18.4601 11.9443 18.1183 12.285Z"
        fill="#203C20"
      />
    </svg>
  );
};

export const connectSocialIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.55 35.8835C17.3 36.1335 16.9833 36.2502 16.6667 36.2502C16.35 36.2502 16.0333 36.1335 15.7833 35.8835C14.1833 34.2835 13.0167 33.1169 10.95 29.5669C10.9833 29.5835 11.0333 29.5835 11.0667 29.5835H13.8667C15.3 31.8502 16.2167 32.7669 17.55 34.1169C18.0333 34.6002 18.0333 35.4002 17.55 35.8835ZM33.3 25.9002C33 23.8669 32.05 21.9336 30.5833 20.4836L24.4 14.3002C22.95 12.8335 20.3833 12.8335 18.9333 14.3002C17.65 15.5835 17.4167 17.5669 18.3833 19.1002L24.5833 29.0502L25.6 30.6669C25.9667 31.2502 26.75 31.4169 27.3333 31.0669C27.9167 30.7002 28.1 29.9169 27.7333 29.3336L25.8 26.2502L24.8167 24.6835L20.5 17.7836C20.1667 17.2336 20.2333 16.5336 20.7 16.0669C21.2333 15.5336 22.1 15.5336 22.6333 16.0669L24.95 18.3835L28.8167 22.2502C29.9 23.3336 30.6 24.7502 30.8167 26.2669L32.1 35.1835C32.1833 35.8002 32.7167 36.2502 33.3333 36.2502C33.3833 36.2502 33.45 36.2502 33.5167 36.2335C34.2 36.1335 34.6667 35.5002 34.5667 34.8169L33.3 25.9002Z"
        fill="#F05331"
      />
      <path
        opacity="0.4"
        d="M18.9333 14.3C17.65 15.5833 17.4167 17.5667 18.3833 19.1L24.5833 29.05C24.0333 29.3667 23.2833 29.5833 22.2667 29.5833H11.0667C8.46666 29.5833 7.08333 28.2 7.08333 25.6V7.73336C7.08333 5.13336 8.46666 3.75 11.0667 3.75H22.2667C24.8667 3.75 26.25 5.13336 26.25 7.73336V16.15L24.4 14.3C22.95 12.8333 20.3833 12.8333 18.9333 14.3Z"
        fill="#F05331"
      />
    </svg>
  );
};

export const YouTubeIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1936_12706)">
        <path
          opacity="0.4"
          d="M39.2033 10.3102C38.9772 9.45918 38.5315 8.68252 37.9109 8.05792C37.2902 7.43331 36.5165 6.98266 35.6669 6.75107C32.5397 5.91016 20.0397 5.91016 20.0397 5.91016C20.0397 5.91016 7.53967 5.91016 4.4124 6.75107C3.56289 6.98266 2.7891 7.43331 2.16849 8.05792C1.54787 8.68252 1.10218 9.45918 0.876037 10.3102C0.039673 13.4511 0.0396729 20.0011 0.0396729 20.0011C0.0396729 20.0011 0.039673 26.5511 0.876037 29.692C1.10218 30.5429 1.54787 31.3196 2.16849 31.9442C2.7891 32.5688 3.56289 33.0195 4.4124 33.2511C7.53967 34.092 20.0397 34.092 20.0397 34.092C20.0397 34.092 32.5397 34.092 35.6669 33.2511C36.5165 33.0195 37.2902 32.5688 37.9109 31.9442C38.5315 31.3196 38.9772 30.5429 39.2033 29.692C40.0397 26.5511 40.0397 20.0011 40.0397 20.0011C40.0397 20.0011 40.0397 13.4511 39.2033 10.3102Z"
          fill="#FF0302"
        />
        <path
          d="M16.6961 25.5211C16.3628 25.7108 15.9489 25.47 15.9489 25.0865V14.9105C15.9489 14.527 16.3628 14.2863 16.6961 14.4759L25.6395 19.5639C25.9765 19.7556 25.9765 20.2414 25.6395 20.4331L16.6961 25.5211Z"
          fill="#FF0302"
        />
      </g>
      <defs>
        <clipPath id="clip0_1936_12706">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmailInvitesIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M33.7334 11.666V22.0077C33.7334 22.3527 33.3985 22.5793 33.0685 22.476C32.2652 22.2243 31.3734 22.0827 30.4001 22.0827C25.7501 22.0827 23.0666 25.416 21.8832 27.416C21.2382 28.5093 21.0769 29.8044 21.4002 31.0027C21.4902 31.3344 21.2753 31.666 20.9303 31.666H8.7334C5.40007 31.666 3.7334 29.9993 3.7334 26.666V11.666C3.7334 8.33268 5.40007 6.66602 8.7334 6.66602H28.7334C32.0667 6.66602 33.7334 8.33268 33.7334 11.666Z"
        fill="#1E78FF"
      />
      <path
        d="M18.7334 20.857C18.1334 20.857 17.53 20.6703 17.0183 20.2986L8.83187 14.3436C8.27353 13.9386 8.15014 13.1553 8.5568 12.597C8.9618 12.042 9.74156 11.9136 10.3032 12.322L18.4901 18.2753C18.6367 18.3803 18.8317 18.382 18.9784 18.2753L27.1652 12.322C27.7269 11.9136 28.5066 12.0403 28.9116 12.597C29.3183 13.1553 29.1949 13.937 28.6366 14.3436L20.4501 20.2969C19.9368 20.6719 19.3334 20.857 18.7334 20.857Z"
        fill="#1E78FF"
      />
      <path
        d="M36.7654 28.694C35.857 27.1657 33.8152 24.584 30.4002 24.584C26.9852 24.584 24.945 27.1657 24.035 28.694C23.6317 29.3707 23.6317 30.214 24.035 30.8923C24.9434 32.4207 26.9852 35.0023 30.4002 35.0023C33.8152 35.0023 35.8554 32.4207 36.7654 30.8923C37.167 30.214 37.167 29.3707 36.7654 28.694ZM30.4336 31.8757C29.2852 31.8757 28.3417 30.9423 28.3417 29.7923C28.3417 28.6423 29.2669 27.709 30.4169 27.709H30.4336C31.5836 27.709 32.5169 28.6423 32.5169 29.7923C32.5169 30.9423 31.5836 31.8757 30.4336 31.8757Z"
        fill="#1E78FF"
      />
    </svg>
  );
};

export const ResponseInvitesIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M29.5251 23.7673C28.0834 22.0407 25.8034 20.834 22.4668 20.834H19.1334H15.8001C9.03342 20.834 6.63342 25.784 6.63342 30.034C6.63342 33.834 8.65009 35.834 12.4668 35.834H19.1334H24.5334C24.9167 35.834 25.1367 35.4273 24.96 35.0873C24.4317 34.0573 24.1318 32.894 24.1318 31.6673C24.1318 28.3407 26.2717 25.5307 29.2583 24.5457C29.595 24.4357 29.7501 24.0373 29.5251 23.7673Z"
        fill="#4CAF50"
      />
      <path
        d="M19.1485 17.4993C22.8304 17.4993 25.8151 14.5146 25.8151 10.8327C25.8151 7.15078 22.8304 4.16602 19.1485 4.16602C15.4666 4.16602 12.4818 7.15078 12.4818 10.8327C12.4818 14.5146 15.4666 17.4993 19.1485 17.4993Z"
        fill="#4CAF50"
      />
      <path
        d="M31.3551 35.6946C31.0351 35.6946 30.7151 35.573 30.4717 35.328L28.25 33.1063C27.7617 32.618 27.7617 31.8263 28.25 31.3379C28.7384 30.8496 29.5301 30.8496 30.0184 31.3379L31.3567 32.6762L34.9183 29.1163C35.4067 28.6279 36.1984 28.6279 36.6867 29.1163C37.1751 29.6046 37.1751 30.3963 36.6867 30.8846L32.2417 35.3296C31.9951 35.5713 31.6751 35.6946 31.3551 35.6946Z"
        fill="#4CAF50"
      />
    </svg>
  );
};
export const CreateSubmitIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.7166 28.5329L28.7332 34.5163C28.0832 35.1663 27.0333 35.1663 26.3833 34.5163L22.3499 30.483C22.1832 30.3163 21.9999 30.183 21.7999 30.0663L30.2666 21.5996C30.3832 21.7996 30.5166 21.983 30.6832 22.1496L34.7166 26.1829C35.3666 26.8329 35.3666 27.8829 34.7166 28.5329Z"
        fill="#5A31F0"
      />
      <path
        opacity="0.4"
        d="M30.2666 21.6L21.8 30.0667C21.6166 29.9667 21.4166 29.8833 21.2 29.8333L11.7166 27.4667C9.78329 26.9834 8.31661 25.4 7.98328 23.4333L5.21661 6.91666C5.19994 6.86666 5.19995 6.81666 5.19995 6.76666L14.4666 16.0333C14.5499 15.6167 14.7666 15.2334 15.0833 14.9167L15.1 14.9C15.4333 14.5667 15.8166 14.35 16.2333 14.2667L6.96661 5C7.01661 5 7.06661 5.00002 7.11661 5.01668L23.6333 7.78336C25.5999 8.11669 27.1833 9.58334 27.6666 11.5167L30.0333 21C30.0833 21.2167 30.1666 21.4167 30.2666 21.6Z"
        fill="#5A31F0"
      />
      <path
        d="M18.6383 18.4313C17.6617 19.408 16.0733 19.4129 15.0967 18.4363C14.12 17.4596 14.115 15.883 15.09 14.9063L15.1016 14.8946C16.0783 13.9179 17.6617 13.9179 18.6367 14.8946C19.615 15.8713 19.615 17.4546 18.6383 18.4313Z"
        fill="#5A31F0"
      />
    </svg>
  );
};
export const PublishRewardsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.25 7.51668L26.2 10.9499H15.0001L12.95 7.51668C12.2834 6.41668 13.0833 5 14.3833 5H26.8167C28.1167 5 28.9167 6.41668 28.25 7.51668Z"
        fill="#FF9315"
      />
      <path
        opacity="0.4"
        d="M33.9333 24.9993C33.9333 28.3326 32.2666 34.9993 20.5999 34.9993C8.93327 34.9993 7.2666 28.3326 7.2666 24.9993C7.2666 18.3326 12.2666 13.3326 15 10.9492H26.1999C28.9332 13.3326 33.9333 18.3326 33.9333 24.9993Z"
        fill="#FF9315"
      />
      <path
        d="M24.7667 26.0211C24.7667 24.3061 23.6167 22.8127 21.9633 22.3877L19.855 21.856C19.5884 21.786 19.3617 21.6361 19.1884 21.4111C19.0234 21.1994 18.9333 20.926 18.9333 20.6443C18.9333 19.956 19.475 19.3977 20.1417 19.3977H21.06C21.675 19.3977 22.19 19.8744 22.26 20.5078C22.335 21.1944 22.9434 21.6844 23.64 21.6127C24.3267 21.5377 24.82 20.9177 24.745 20.2327C24.565 18.6044 23.375 17.3276 21.85 16.9909V16.666C21.85 15.976 21.29 15.416 20.6 15.416C19.91 15.416 19.35 15.976 19.35 16.666V16.9877C17.685 17.356 16.4333 18.8526 16.4333 20.6443C16.4333 21.4793 16.7117 22.296 17.2067 22.936C17.7083 23.5943 18.4267 24.0694 19.2367 24.2777L21.345 24.8093C21.8883 24.9493 22.2667 25.4477 22.2667 26.0211C22.2667 26.3544 22.1384 26.6694 21.9034 26.9077C21.675 27.141 21.375 27.2676 21.0583 27.2676H20.14C19.525 27.2676 19.01 26.7909 18.94 26.1576C18.8633 25.4709 18.255 24.9777 17.56 25.0527C16.8733 25.1277 16.38 25.7477 16.455 26.4327C16.635 28.061 17.825 29.3378 19.35 29.6744V29.9993C19.35 30.6893 19.91 31.2493 20.6 31.2493C21.29 31.2493 21.85 30.6893 21.85 29.9993V29.6777C22.54 29.526 23.175 29.181 23.685 28.6627C24.3834 27.9543 24.7667 27.0161 24.7667 26.0211Z"
        fill="#FF9315"
      />
    </svg>
  );
};
export const AhaSupportIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 5.33398C9.37333 5.33398 4 9.33395 4 16.002C4 18.8286 4.97327 21.19 6.59994 22.95C6.39994 24.23 5.6799 25.6966 4.22656 26.87C3.78656 27.2433 4.03995 27.9766 4.61328 27.9899C6.50661 28.0566 9.42655 27.8033 11.2132 25.8966C12.6799 26.4033 14.2933 26.6699 16 26.6699C22.6267 26.6699 28 22.6686 28 16.002C28 9.33395 22.6267 5.33398 16 5.33398ZM21.2334 15.7259C20.5374 19.2846 16 21.334 16 21.334C16 21.334 11.4626 19.2846 10.7666 15.7259C10.3399 13.5419 11.2719 11.346 13.6413 11.334C15.4066 11.326 15.9987 13.0913 15.9987 13.0913C15.9987 13.0913 16.5908 11.3247 18.3561 11.334C20.7321 11.346 21.6601 13.5419 21.2334 15.7259Z"
        fill="#25314C"
      />
    </svg>
  );
};
export const CommunityIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6 8.34603C23.8667 7.55936 22.0133 6.98602 20.0933 6.66602C19.8533 7.07935 19.5867 7.63935 19.4 8.07935C17.3467 7.78601 15.32 7.78601 13.2933 8.07935C13.1067 7.63935 12.8267 7.07935 12.6 6.66602C10.6667 6.98602 8.81335 7.55936 7.09335 8.34603C3.60002 13.4394 2.65335 18.4127 3.13335 23.3193C5.45335 24.986 7.69336 25.9993 9.89336 26.666C10.4267 25.946 10.92 25.1727 11.3333 24.3593C10.5333 24.066 9.77335 23.706 9.05335 23.2793C9.24002 23.146 9.42669 22.9994 9.60002 22.8527C13.9867 24.8394 18.76 24.8394 23.0933 22.8527C23.28 22.9994 23.4534 23.146 23.64 23.2793C22.92 23.706 22.16 24.066 21.36 24.3593C21.7733 25.1727 22.2667 25.946 22.8 26.666C25 25.9993 27.2534 24.986 29.56 23.3193C30.1467 17.6393 28.64 12.706 25.6267 8.34603H25.6ZM11.9067 20.226C10.5867 20.226 9.50668 19.026 9.50668 17.5594C9.50668 16.0927 10.56 14.8927 11.9067 14.8927C13.2533 14.8927 14.3334 16.0927 14.3067 17.5594C14.3067 19.026 13.24 20.226 11.9067 20.226ZM20.76 20.226C19.44 20.226 18.36 19.026 18.36 17.5594C18.36 16.0927 19.4133 14.8927 20.76 14.8927C22.1067 14.8927 23.1867 16.0927 23.16 17.5594C23.16 19.026 22.1067 20.226 20.76 20.226Z"
        fill="#25314C"
      />
    </svg>
  );
};

export const RightIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5295 4.53122L10.5303 7.53048C10.384 7.67673 10.192 7.75021 10 7.75021C9.808 7.75021 9.61598 7.67673 9.46973 7.53048C9.17648 7.23723 9.17648 6.76319 9.46973 6.46994L11.1895 4.75021H1C0.58525 4.75021 0.25 4.41421 0.25 4.00021C0.25 3.58621 0.58525 3.25021 1 3.25021H11.1895L9.46973 1.53048C9.17648 1.23723 9.17648 0.763187 9.46973 0.469937C9.76298 0.176687 10.237 0.176687 10.5303 0.469937L13.5295 3.46921C13.5993 3.53896 13.6541 3.6214 13.6923 3.71365C13.7681 3.89665 13.7681 4.10377 13.6923 4.28677C13.6541 4.37902 13.5993 4.46147 13.5295 4.53122Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CertificationIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00004 0.333984C3.32004 0.333984 0.333374 3.32065 0.333374 7.00065C0.333374 10.6807 3.32004 13.6673 7.00004 13.6673C10.68 13.6673 13.6667 10.6807 13.6667 7.00065C13.6667 3.32065 10.68 0.333984 7.00004 0.333984ZM9.68671 5.80066L6.57336 8.90731C6.48003 9.00731 6.35337 9.054 6.22003 9.054C6.09337 9.054 5.9667 9.00731 5.8667 8.90731L4.31337 7.354C4.12004 7.16067 4.12004 6.84063 4.31337 6.6473C4.50671 6.45397 4.82671 6.45397 5.02004 6.6473L6.22003 7.84733L8.98004 5.09399C9.17338 4.89399 9.49337 4.89399 9.68671 5.09399C9.88004 5.28733 9.88004 5.60066 9.68671 5.80066Z"
        fill="#4CAF50"
      />
    </svg>
  );
};
export const DealsEmptyIcon = ({ className }: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.91683 13.9998H6.86246C7.66186 13.9998 8.39266 14.4515 8.75016 15.1665C9.10767 15.8815 9.83846 16.3332 10.6379 16.3332H17.3625C18.1619 16.3332 18.8927 15.8815 19.2502 15.1665C19.6077 14.4515 20.3385 13.9998 21.1379 13.9998H25.0835M10.4612 4.6665H17.5392C18.7955 4.6665 19.4237 4.6665 19.9783 4.8578C20.4687 5.02696 20.9154 5.30303 21.2861 5.66604C21.7052 6.07653 21.9861 6.6384 22.548 7.76211L25.0756 12.8174C25.2961 13.2584 25.4064 13.4789 25.4841 13.71C25.5532 13.9152 25.603 14.1264 25.633 14.3408C25.6668 14.5823 25.6668 14.8288 25.6668 15.3218V17.7332C25.6668 19.6934 25.6668 20.6734 25.2854 21.4221C24.9498 22.0807 24.4144 22.6161 23.7558 22.9517C23.0071 23.3332 22.027 23.3332 20.0668 23.3332H7.9335C5.97331 23.3332 4.99322 23.3332 4.24453 22.9517C3.58596 22.6161 3.05053 22.0807 2.71497 21.4221C2.3335 20.6734 2.3335 19.6934 2.3335 17.7332V15.3218C2.3335 14.8288 2.3335 14.5823 2.3673 14.3408C2.39732 14.1264 2.44717 13.9152 2.51622 13.71C2.59397 13.4789 2.70421 13.2584 2.9247 12.8174L5.45236 7.76211C6.01422 6.63839 6.29515 6.07653 6.71427 5.66604C7.0849 5.30303 7.5316 5.02696 8.02203 4.8578C8.57663 4.6665 9.2048 4.6665 10.4612 4.6665Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.75 12C19.75 12.414 19.414 12.75 19 12.75H12.75V19C12.75 19.414 12.414 19.75 12 19.75C11.586 19.75 11.25 19.414 11.25 19V12.75H5C4.586 12.75 4.25 12.414 4.25 12C4.25 11.586 4.586 11.25 5 11.25H11.25V5C11.25 4.586 11.586 4.25 12 4.25C12.414 4.25 12.75 4.586 12.75 5V11.25H19C19.414 11.25 19.75 11.586 19.75 12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const YoutubePlatformIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.4424 7.21635C27.2841 6.62067 26.9721 6.07701 26.5377 5.63978C26.1032 5.20256 25.5616 4.8871 24.9669 4.72499C22.7778 4.13635 14.0278 4.13635 14.0278 4.13635C14.0278 4.13635 5.27783 4.13635 3.08874 4.72499C2.49408 4.8871 1.95243 5.20256 1.518 5.63978C1.08357 6.07701 0.771589 6.62067 0.613287 7.21635C0.0278321 9.41499 0.027832 14 0.027832 14C0.027832 14 0.0278321 18.585 0.613287 20.7836C0.771589 21.3793 1.08357 21.923 1.518 22.3602C1.95243 22.7974 2.49408 23.1129 3.08874 23.275C5.27783 23.8636 14.0278 23.8636 14.0278 23.8636C14.0278 23.8636 22.7778 23.8636 24.9669 23.275C25.5616 23.1129 26.1032 22.7974 26.5377 22.3602C26.9721 21.923 27.2841 21.3793 27.4424 20.7836C28.0278 18.585 28.0278 14 28.0278 14C28.0278 14 28.0278 9.41499 27.4424 7.21635Z"
        fill="#FF0302"
      />
      <path
        d="M11.1641 18.1635V9.83667L18.4822 14.0001L11.1641 18.1635Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export const TiktokPlatformIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5394 10.1074C22.34 11.3991 24.5458 12.1591 26.9281 12.1591V7.55842C26.4773 7.55852 26.0276 7.51133 25.5865 7.41754V11.039C23.2043 11.039 20.9988 10.2789 19.1977 8.98734V18.3761C19.1977 23.0728 15.4038 26.8799 10.7241 26.8799C8.97797 26.8799 7.35502 26.3502 6.00684 25.4416C7.54557 27.0205 9.69144 28 12.0655 28C16.7455 28 20.5396 24.1928 20.5396 19.4959V10.1074H20.5394ZM22.1945 5.46587C21.2743 4.45697 20.6701 3.15316 20.5394 1.71174V1.12H19.268C19.588 2.95204 20.6796 4.51722 22.1945 5.46587ZM8.96677 21.8375C8.45265 21.161 8.17482 20.3334 8.17607 19.4825C8.17607 17.3344 9.91137 15.5927 12.0523 15.5927C12.4513 15.5926 12.8479 15.6539 13.2281 15.775V11.0714C12.7837 11.0103 12.3353 10.9844 11.887 10.9939V14.6549C11.5065 14.5338 11.1097 14.4723 10.7106 14.4727C8.5697 14.4727 6.83449 16.2142 6.83449 18.3626C6.83449 19.8817 7.70185 21.1968 8.96677 21.8375Z"
        fill="#FF004F"
      />
      <path
        d="M19.1978 8.98725C20.9988 10.2789 23.2043 11.0389 25.5865 11.0389V7.41745C24.2568 7.1332 23.0796 6.43584 22.1946 5.46587C20.6796 4.51713 19.5881 2.95194 19.268 1.12H15.9283V19.4958C15.9208 21.638 14.1884 23.3726 12.0521 23.3726C10.7932 23.3726 9.67484 22.7704 8.96654 21.8375C7.70171 21.1968 6.83435 19.8816 6.83435 18.3627C6.83435 16.2145 8.56956 14.4728 10.7105 14.4728C11.1206 14.4728 11.516 14.5369 11.8869 14.655V10.994C7.28932 11.0893 3.5918 14.8593 3.5918 19.4958C3.5918 21.8104 4.51257 23.9086 6.00699 25.4417C7.35517 26.3502 8.97812 26.88 10.7242 26.88C15.4041 26.88 19.1979 23.0727 19.1979 18.3761V8.98725H19.1978Z"
        fill="black"
      />
      <path
        d="M25.5863 7.41744V6.43823C24.3872 6.44006 23.2117 6.10306 22.1944 5.46576C23.0949 6.45524 24.2808 7.13751 25.5863 7.41744ZM19.2678 1.11998C19.2373 0.944897 19.2138 0.76866 19.1976 0.59175V0H14.5864V18.3759C14.579 20.5179 12.8467 22.2525 10.7102 22.2525C10.083 22.2525 9.49078 22.1031 8.96632 21.8376C9.67463 22.7703 10.793 23.3725 12.0519 23.3725C14.188 23.3725 15.9207 21.6381 15.9281 19.4958V1.11998H19.2678ZM11.8868 10.994V9.95154C11.5015 9.89869 11.1131 9.87217 10.7241 9.87236C6.0439 9.87226 2.25 13.6796 2.25 18.3759C2.25 21.3203 3.74107 23.9151 6.00686 25.4415C4.51244 23.9085 3.59168 21.8102 3.59168 19.4957C3.59168 14.8593 7.28911 11.0893 11.8868 10.994Z"
        fill="#00F2EA"
      />
    </svg>
  );
};

export const InstagramPlatformIcon = ({ className }: any) => {
  return <img src="/icons/instagram.png" alt="" className={`${className}`} />;
};

export const XPlatformIcon = ({ className, color = 'black' }: any) => {
  return (
    <svg
      className={className}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8805 2.22119H25.8162L17.2178 12.0486L27.3332 25.4215H19.4129L13.2095 17.3109L6.11144 25.4215H2.17334L11.3702 14.91L1.6665 2.22119H9.7878L15.3951 9.63458L21.8805 2.22119ZM20.4992 23.0658H22.68L8.6028 4.45318H6.26254L20.4992 23.0658Z"
        fill={color}
      />
    </svg>
  );
};

export const FaceBookPlatformIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7C14 3.13402 10.866 7.62939e-06 7 7.62939e-06C3.13401 7.62939e-06 0 3.13402 0 7C0 10.2829 2.26002 13.0374 5.30896 13.7939V9.13909H3.86551V7H5.30896V6.07827C5.30896 3.6957 6.38719 2.59138 8.72631 2.59138C9.16977 2.59138 9.93498 2.67832 10.248 2.76529V4.7044C10.0828 4.68701 9.79585 4.6783 9.43933 4.6783C8.29152 4.6783 7.84803 5.11308 7.84803 6.2435V7H10.1345L9.7417 9.13909H7.84803V13.9487C11.314 13.5301 14 10.5789 14 7Z"
        fill="#0866FF"
      />
      <path
        d="M9.74167 9.13909L10.1345 7H7.84803V6.24347C7.84803 5.11306 8.29149 4.6783 9.4393 4.6783C9.79582 4.6783 10.0828 4.68698 10.248 4.70437V2.76529C9.93495 2.67832 9.16974 2.59135 8.72628 2.59135C6.38719 2.59135 5.30893 3.6957 5.30893 6.07827V7H3.86548V9.13909H5.30893V13.7939C5.85054 13.9282 6.41684 14 6.99996 14C7.28708 14 7.56999 13.9823 7.84803 13.9487V9.13909H9.74167Z"
        fill="white"
      />
    </svg>
  );
};

export const LinkedInPlatformIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height="28"
      viewBox="0 0 72 72"
      width="28"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M8,72 L64,72 C68.418278,72 72,68.418278 72,64 L72,8 C72,3.581722 68.418278,-8.11624501e-16 64,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,64 C5.41083001e-16,68.418278 3.581722,72 8,72 Z"
          fill="#007EBB"
        />
        <path
          d="M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};

export const ExchangeIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.37888 9.28457C3.29838 9.20407 3.23437 9.10708 3.19004 8.99974C3.10137 8.78624 3.10137 8.54474 3.19004 8.33124C3.23437 8.22391 3.29838 8.1272 3.37888 8.0467L8.04554 3.38003C8.38738 3.0382 8.94159 3.0382 9.28342 3.38003C9.62525 3.72187 9.62525 4.27607 9.28342 4.61791L6.11012 7.79121H20.3306C20.8136 7.79121 21.2056 8.18321 21.2056 8.66621C21.2056 9.14921 20.8136 9.54121 20.3306 9.54121H6.11012L9.28342 12.7145C9.62525 13.0563 9.62525 13.6105 9.28342 13.9524C9.11309 14.1227 8.88905 14.209 8.66505 14.209C8.44105 14.209 8.21702 14.1239 8.04668 13.9524L3.37888 9.28457ZM25.8045 19.9979C25.7601 19.8906 25.6961 19.7939 25.6156 19.7134L20.9489 15.0467C20.6071 14.7049 20.0529 14.7049 19.7111 15.0467C19.3692 15.3885 19.3692 15.9427 19.7111 16.2846L22.8844 19.4579H8.66391C8.18091 19.4579 7.78891 19.8499 7.78891 20.3329C7.78891 20.8159 8.18091 21.2079 8.66391 21.2079H22.8844L19.7111 24.3812C19.3692 24.723 19.3692 25.2772 19.7111 25.619C19.8814 25.7894 20.1054 25.8757 20.3294 25.8757C20.5534 25.8757 20.7775 25.7905 20.9478 25.619L25.6145 20.9524C25.695 20.8719 25.759 20.7752 25.8033 20.6678C25.8931 20.4532 25.8931 20.2126 25.8045 19.9979Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export const CloseBgIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59994 0.237518C3.99994 0.237518 0.266602 3.97085 0.266602 8.57085C0.266602 13.1709 3.99994 16.9042 8.59994 16.9042C13.1999 16.9042 16.9333 13.1709 16.9333 8.57085C16.9333 3.97085 13.1999 0.237518 8.59994 0.237518ZM11.5416 10.6292C11.7833 10.8708 11.7833 11.2709 11.5416 11.5125C11.4166 11.6375 11.2583 11.6959 11.0999 11.6959C10.9416 11.6959 10.7833 11.6375 10.6583 11.5125L8.59994 9.45418L6.5416 11.5125C6.4166 11.6375 6.25827 11.6959 6.09994 11.6959C5.9416 11.6959 5.78327 11.6375 5.65827 11.5125C5.4166 11.2709 5.4166 10.8708 5.65827 10.6292L7.7166 8.57085L5.65827 6.51254C5.4166 6.27088 5.4166 5.87083 5.65827 5.62916C5.89994 5.38749 6.29993 5.38749 6.5416 5.62916L8.59994 7.68752L10.6583 5.62916C10.8999 5.38749 11.2999 5.38749 11.5416 5.62916C11.7833 5.87083 11.7833 6.27088 11.5416 6.51254L9.48327 8.57085L11.5416 10.6292Z"
        fill="#60646C"
      />
    </svg>
  );
};

export const PlayIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6168 13.9977L8.21247 19.7526C6.34113 20.8978 3.93408 19.5547 3.93408 17.3651V6.17533C3.93408 3.98573 6.34113 2.64279 8.21247 3.78799L17.6168 9.54294C19.2828 10.5631 19.2828 12.9785 17.6168 13.9977Z"
        fill="white"
      />
    </svg>
  );
};

export const UpgradeWarnIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.4149 10.0811L21.9201 4.58626C21.5454 4.2116 21.036 4.00098 20.5054 4.00098H11.4963C10.9656 4.00098 10.4575 4.2116 10.0815 4.58626L4.58675 10.0811C4.21208 10.4557 4.00146 10.9651 4.00146 11.4958V20.5049C4.00146 21.0355 4.21208 21.5436 4.58675 21.9196L10.0815 27.4144C10.4562 27.7891 10.9656 27.9997 11.4963 27.9997H20.5054C21.036 27.9997 21.5441 27.7891 21.9201 27.4144L27.4149 21.9196C27.7895 21.5449 28.0002 21.0355 28.0002 20.5049V11.4958C28.0002 10.9651 27.7895 10.4557 27.4149 10.0811ZM15.0002 10.6663C15.0002 10.1143 15.4482 9.66634 16.0002 9.66634C16.5522 9.66634 17.0002 10.1143 17.0002 10.6663V15.9997C17.0002 16.5517 16.5522 16.9997 16.0002 16.9997C15.4482 16.9997 15.0002 16.5517 15.0002 15.9997V10.6663ZM16.0269 21.333C15.2909 21.333 14.6867 20.7357 14.6867 19.9997C14.6867 19.2637 15.2775 18.6663 16.0135 18.6663H16.0269C16.7642 18.6663 17.3602 19.2637 17.3602 19.9997C17.3602 20.7357 16.7629 21.333 16.0269 21.333Z"
        fill="#f05330"
      />
    </svg>
  );
};

export const BLingIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5122 10.9347L13.5987 10.3881C11.8389 9.88501 10.4875 8.53428 9.98438 6.77376L9.43778 4.86029C9.35147 4.55927 8.84907 4.55927 8.76276 4.86029L8.21616 6.77376C7.71305 8.53428 6.36162 9.88571 4.6018 10.3881L2.68831 10.9347C2.53745 10.9775 2.43359 11.1158 2.43359 11.2722C2.43359 11.4287 2.53745 11.5662 2.68831 11.6097L4.6018 12.1564C6.36162 12.6595 7.71305 14.0102 8.21616 15.7707L8.76276 17.6842C8.80627 17.8351 8.94379 17.9389 9.10026 17.9389C9.25673 17.9389 9.39428 17.8351 9.43778 17.6842L9.98438 15.7707C10.4875 14.0102 11.8389 12.6588 13.5987 12.1564L15.5122 11.6097C15.6631 11.5669 15.7669 11.4287 15.7669 11.2722C15.7669 11.1158 15.6631 10.9782 15.5122 10.9347Z"
        fill="url(#paint0_linear_5177_33232)"
      />
      <path
        d="M17.4676 4.49828L16.7273 4.28682C16.0466 4.0922 15.5238 3.56968 15.3292 2.88864L15.1177 2.14843C15.0843 2.03198 14.89 2.03198 14.8566 2.14843L14.6451 2.88864C14.4505 3.56968 13.9277 4.09247 13.247 4.28682L12.5067 4.49828C12.4484 4.51484 12.4082 4.56831 12.4082 4.62884C12.4082 4.68937 12.4484 4.74257 12.5067 4.7594L13.247 4.97086C13.9277 5.16548 14.4505 5.688 14.6451 6.36904L14.8566 7.10925C14.8734 7.16761 14.9266 7.20778 14.9871 7.20778C15.0477 7.20778 15.1009 7.16761 15.1177 7.10925L15.3292 6.36904C15.5238 5.688 16.0466 5.16521 16.7273 4.97086L17.4676 4.7594C17.5259 4.74284 17.5661 4.68937 17.5661 4.62884C17.5661 4.56831 17.5259 4.51511 17.4676 4.49828Z"
        fill="url(#paint1_linear_5177_33232)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5177_33232"
          x1="9.10026"
          y1="4.63452"
          x2="9.10026"
          y2="17.9389"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB6011" />
          <stop offset="1" stopColor="#FB6011" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5177_33232"
          x1="14.9871"
          y1="2.0611"
          x2="14.9871"
          y2="7.20778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB6011" />
          <stop offset="1" stopColor="#FB6011" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CarrierIngIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 12.6667C12.6667 13.4034 12.0693 14.0001 11.3333 14.0001C10.5973 14.0001 10 13.4034 10 12.6667C10 11.9301 10.5973 11.3334 11.3333 11.3334C12.0693 11.3334 12.6667 11.9301 12.6667 12.6667ZM4.66667 11.3334C3.93067 11.3334 3.33333 11.9301 3.33333 12.6667C3.33333 13.4034 3.93067 14.0001 4.66667 14.0001C5.40267 14.0001 6 13.4034 6 12.6667C6 11.9301 5.40267 11.3334 4.66667 11.3334ZM14.5 9.05343V11.0001C14.5 11.4801 14.2733 11.9001 13.9267 12.1734C13.8867 12.2068 13.8133 12.2401 13.7667 12.2401C13.6867 12.2401 13.6133 12.2001 13.5933 12.1134C13.3533 11.0934 12.4267 10.3334 11.3333 10.3334C10.16 10.3334 9.19403 11.1994 9.02669 12.3261C9.01203 12.4248 8.93333 12.5001 8.83333 12.5001H7.16667C7.06667 12.5001 6.98797 12.4248 6.97331 12.3261C6.80664 11.1994 5.84 10.3334 4.66667 10.3334C3.57333 10.3334 2.64666 11.0934 2.40666 12.1134C2.38666 12.1934 2.30664 12.2467 2.21997 12.2401C2.18664 12.2401 2.10666 12.2001 2.07332 12.1734C1.72666 11.9001 1.5 11.4801 1.5 11.0001V9.36674C1.5 9.25607 1.58937 9.16675 1.70003 9.16675H6.66667C6.94 9.16675 7.16667 8.94008 7.16667 8.66675C7.16667 8.39341 6.94 8.16675 6.66667 8.16675H1.70003C1.58937 8.16675 1.5 8.07742 1.5 7.96676V3.66675C1.5 2.84208 2.17467 2.16675 3 2.16675H8.33333C9.15867 2.16675 9.83333 2.84208 9.83333 3.66675V4.83341H11.3133C13.0066 4.83341 13.3266 5.6334 13.6333 6.40674L14.3267 8.12008C14.3733 8.24674 14.4134 8.38009 14.44 8.50675C14.4534 8.54675 14.4666 8.59343 14.4666 8.6401C14.4866 8.77343 14.5 8.91343 14.5 9.05343ZM13.2667 8.16675L12.7 6.78007C12.42 6.0734 12.3266 5.83341 11.3133 5.83341H9.83333V8.16675H13.2667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MarkerPinIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14.2864C3.14864 15.1031 2 16.2412 2 17.5C2 19.9853 6.47715 22 12 22C17.5228 22 22 19.9853 22 17.5C22 16.2412 20.8514 15.1031 19 14.2864M18 8C18 12.0637 13.5 14 12 17C10.5 14 6 12.0637 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z"
        stroke="#404040"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CarrierDoneIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.31966 7.43334C6.48633 7.50667 6.65967 7.55335 6.83301 7.59335V13.94C6.72634 13.9133 6.61969 13.8733 6.51969 13.8267L2.51969 12.0467C1.79969 11.7267 1.33301 11.0133 1.33301 10.22V5.78002C1.33301 5.60002 1.35966 5.42002 1.40633 5.25335L6.31966 7.43334ZM12.753 4.37334C12.5797 4.20001 12.3797 4.05334 12.1463 3.95334L8.14632 2.17335C7.62632 1.94002 7.03969 1.94002 6.51969 2.17335L2.51969 3.95334C2.28636 4.05334 2.08634 4.20001 1.913 4.37334L6.71965 6.51334C7.10631 6.68667 7.55304 6.68667 7.94637 6.51334L12.753 4.37334ZM8.37231 10.784C8.61765 9.06334 10.1256 7.73001 11.8623 7.66934C12.2863 7.65468 12.6903 7.70869 13.069 7.82602C13.2003 7.86669 13.333 7.77734 13.333 7.64001V5.78002C13.333 5.60002 13.3064 5.42002 13.2597 5.25335L8.34635 7.43334C8.17969 7.50001 8.00634 7.55335 7.83301 7.59335V13.94C7.84567 13.948 7.84565 13.948 7.85832 13.956L8.79435 13.5354C8.90569 13.4854 8.94235 13.35 8.87769 13.246C8.44169 12.5447 8.24165 11.6987 8.37231 10.784ZM14.6663 11.3333C14.6663 12.8067 13.473 14 11.9997 14C10.5263 14 9.33301 12.8067 9.33301 11.3333C9.33301 9.86001 10.5263 8.66668 11.9997 8.66668C13.473 8.66668 14.6663 9.86001 14.6663 11.3333ZM13.0663 10.54C12.9397 10.4133 12.7264 10.4133 12.5997 10.54L11.7196 11.4133L11.3997 11.1C11.273 10.9667 11.0597 10.9667 10.933 11.1C10.7997 11.2267 10.7997 11.44 10.933 11.5667L11.4863 12.1267C11.5463 12.1867 11.633 12.22 11.7196 12.22C11.813 12.22 11.893 12.1867 11.9596 12.1267L13.0663 11.0133C13.1997 10.88 13.1997 10.6733 13.0663 10.54Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AuthorizeErrorIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 4.75H15.25C17.4591 4.75 19.25 6.54086 19.25 8.75V15.25C19.25 17.4591 17.4591 19.25 15.25 19.25H8.75C6.54086 19.25 4.75 17.4591 4.75 15.25V8.75C4.75 6.54086 6.54086 4.75 8.75 4.75Z"
        stroke="#D43710"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 15.25C7.75 15.25 9 12.75 12 12.75C15 12.75 16.25 15.25 16.25 15.25"
        stroke="#D43710"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10C10.5 10.2761 10.2761 10.5 10 10.5C9.72386 10.5 9.5 10.2761 9.5 10C9.5 9.72386 9.72386 9.5 10 9.5C10.2761 9.5 10.5 9.72386 10.5 10Z"
        stroke="#D43710"
      />
      <path
        d="M14.5 10C14.5 10.2761 14.2761 10.5 14 10.5C13.7239 10.5 13.5 10.2761 13.5 10C13.5 9.72386 13.7239 9.5 14 9.5C14.2761 9.5 14.5 9.72386 14.5 10Z"
        stroke="#D43710"
      />
    </svg>
  );
};

export const LinkShareIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1041 2.33325V5.24992C12.1041 5.49142 11.9081 5.68742 11.6666 5.68742C11.4251 5.68742 11.2291 5.49142 11.2291 5.24992V3.38969L6.72577 7.89301C6.6406 7.97817 6.52859 8.02132 6.41659 8.02132C6.30459 8.02132 6.19257 7.97876 6.1074 7.89301C5.93649 7.72209 5.93649 7.44499 6.1074 7.27407L10.6107 2.77075H8.74992C8.50842 2.77075 8.31242 2.57475 8.31242 2.33325C8.31242 2.09175 8.50842 1.89575 8.74992 1.89575H11.6666C11.7238 1.89575 11.7804 1.90748 11.8341 1.92965C11.9408 1.97398 12.026 2.05915 12.0709 2.16648C12.0925 2.21957 12.1041 2.27609 12.1041 2.33325ZM11.6666 7.14575C11.4251 7.14575 11.2291 7.34175 11.2291 7.58325V9.91659C11.2291 10.8365 10.8365 11.2291 9.91659 11.2291H4.08325C3.16334 11.2291 2.77075 10.8365 2.77075 9.91659V4.08325C2.77075 3.16334 3.16334 2.77075 4.08325 2.77075H6.41659C6.65809 2.77075 6.85409 2.57475 6.85409 2.33325C6.85409 2.09175 6.65809 1.89575 6.41659 1.89575H4.08325C2.67275 1.89575 1.89575 2.67275 1.89575 4.08325V9.91659C1.89575 11.3271 2.67275 12.1041 4.08325 12.1041H9.91659C11.3271 12.1041 12.1041 11.3271 12.1041 9.91659V7.58325C12.1041 7.34175 11.9081 7.14575 11.6666 7.14575Z"
        fill="#8B8D98"
      />
    </svg>
  );
};

export const EmailIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 5H6C4 5 3 6 3 8V17C3 19 4 20 6 20H18C20 20 21 19 21 17V8C21 6 20 5 18 5ZM17.9409 9.606L13.0291 13.178C12.7211 13.402 12.36 13.514 12 13.514C11.64 13.514 11.2779 13.402 10.9709 13.179L6.05908 9.606C5.72408 9.363 5.65004 8.893 5.89404 8.558C6.13704 8.224 6.60389 8.14801 6.94189 8.39301L11.854 11.965C11.942 12.028 12.059 12.029 12.147 11.965L17.0591 8.39301C17.3961 8.14801 17.8639 8.224 18.1069 8.558C18.3509 8.894 18.2759 9.363 17.9409 9.606Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DiscordIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.95 6.26001C17.65 5.67001 16.26 5.24 14.82 5C14.64 5.31 14.44 5.73 14.3 6.06C12.76 5.84 11.24 5.84 9.72001 6.06C9.58001 5.73 9.37002 5.31 9.20002 5C7.75002 5.24 6.36001 5.67001 5.07001 6.26001C2.45001 10.08 1.74001 13.81 2.10001 17.49C3.84001 18.74 5.52002 19.5 7.17002 20C7.57002 19.46 7.94 18.88 8.25 18.27C7.65 18.05 7.08001 17.78 6.54001 17.46C6.68001 17.36 6.82002 17.25 6.95002 17.14C10.24 18.63 13.82 18.63 17.07 17.14C17.21 17.25 17.34 17.36 17.48 17.46C16.94 17.78 16.37 18.05 15.77 18.27C16.08 18.88 16.45 19.46 16.85 20C18.5 19.5 20.19 18.74 21.92 17.49C22.36 13.23 21.23 9.53001 18.97 6.26001H18.95ZM8.68 15.17C7.69 15.17 6.88001 14.27 6.88001 13.17C6.88001 12.07 7.67 11.17 8.68 11.17C9.69 11.17 10.5 12.07 10.48 13.17C10.48 14.27 9.68 15.17 8.68 15.17ZM15.32 15.17C14.33 15.17 13.52 14.27 13.52 13.17C13.52 12.07 14.31 11.17 15.32 11.17C16.33 11.17 17.14 12.07 17.12 13.17C17.12 14.27 16.33 15.17 15.32 15.17Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SquareWarnIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6875 2.50012H5.3125C3.4375 2.50012 2.5 3.43762 2.5 5.31262V14.6876C2.5 16.5626 3.4375 17.5001 5.3125 17.5001H14.6875C16.5625 17.5001 17.5 16.5626 17.5 14.6876V5.31262C17.5 3.43762 16.5625 2.50012 14.6875 2.50012ZM10.625 13.7501C10.625 14.0951 10.345 14.3751 10 14.3751C9.655 14.3751 9.375 14.0951 9.375 13.7501V9.94092C9.375 9.59592 9.655 9.31592 10 9.31592C10.345 9.31592 10.625 9.59592 10.625 9.94092V13.7501ZM10.0167 7.91679C9.55668 7.91679 9.17908 7.54346 9.17908 7.08346C9.17908 6.62346 9.54834 6.25012 10.0083 6.25012H10.0167C10.4775 6.25012 10.85 6.62346 10.85 7.08346C10.85 7.54346 10.4767 7.91679 10.0167 7.91679Z"
        fill="#2B7FFF"
      />
    </svg>
  );
};

export const BookMeetingIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 2.25H3C2.586 2.25 2.25 2.586 2.25 3C2.25 3.414 2.586 3.75 3 3.75H4V13C4 15.29 5.21 16.5 7.5 16.5H11.25V18.6L8.57999 20.38C8.23999 20.61 8.15 21.07 8.38 21.42C8.61 21.76 9.07001 21.85 9.42001 21.62L12 19.9L14.58 21.62C14.71 21.71 14.86 21.75 15 21.75C15.24 21.75 15.48 21.63 15.62 21.42C15.85 21.07 15.76 20.61 15.42 20.38L12.75 18.6V16.5H16.5C18.79 16.5 20 15.29 20 13V3.75H21C21.414 3.75 21.75 3.414 21.75 3C21.75 2.586 21.414 2.25 21 2.25ZM14.081 10.246L10.932 12.173C10.305 12.556 9.49899 12.107 9.49899 11.374V7.62695C9.49899 6.89395 10.305 6.444 10.932 6.828L14.081 8.755C14.64 9.096 14.64 9.90397 14.081 10.246Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const MonyIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8806 4.28361L11.4906 3.26693C11.7093 2.90159 11.7146 2.46222 11.5046 2.09155C11.2946 1.72089 10.9153 1.50024 10.4899 1.50024H5.50997C5.08397 1.50024 4.70463 1.72155 4.4953 2.09155C4.28597 2.46222 4.29064 2.90159 4.50997 3.26693L5.11928 4.28361C3.15995 6.09161 2.16663 8.01291 2.16663 10.0002C2.16663 11.0556 2.58729 14.5002 7.99996 14.5002C13.4126 14.5002 13.8333 11.0556 13.8333 10.0002C13.8333 8.01291 12.8406 6.09161 10.8806 4.28361ZM5.3653 2.58423C5.3833 2.5529 5.42597 2.50024 5.50997 2.50024H10.4899C10.5739 2.50024 10.6166 2.55356 10.6346 2.58423C10.6526 2.61556 10.676 2.68028 10.6326 2.75228L9.95662 3.87956H6.04329L5.36729 2.75228C5.32396 2.68028 5.3473 2.61623 5.3653 2.58423ZM7.99996 13.5002C3.63796 13.5002 3.16663 11.0529 3.16663 10.0002C3.16663 8.25491 4.10996 6.53354 5.95662 4.88021H10.0433C11.8906 6.53354 12.8333 8.25491 12.8333 10.0002C12.8333 11.0529 12.362 13.5002 7.99996 13.5002ZM8.54529 8.95557L7.70196 8.74292C7.5953 8.71492 7.50464 8.65494 7.4353 8.56494C7.3693 8.48028 7.33329 8.37089 7.33329 8.25822C7.33329 7.98289 7.54996 7.7596 7.81663 7.7596H8.18396C8.42996 7.7596 8.63596 7.95028 8.66396 8.20361C8.69396 8.47828 8.9373 8.67426 9.21596 8.64559C9.49063 8.61559 9.68796 8.36759 9.65796 8.09359C9.58596 7.44225 9.10996 6.93154 8.49996 6.79688V6.66691C8.49996 6.39091 8.27596 6.16691 7.99996 6.16691C7.72396 6.16691 7.49996 6.39091 7.49996 6.66691V6.79557C6.83396 6.94291 6.33329 7.54155 6.33329 8.25822C6.33329 8.59222 6.44462 8.91889 6.64262 9.17489C6.84329 9.43822 7.13063 9.62826 7.45463 9.71159L8.29795 9.92424C8.51529 9.98024 8.66663 10.1796 8.66663 10.4089C8.66663 10.5423 8.6153 10.6683 8.5213 10.7636C8.42997 10.8569 8.30995 10.9076 8.18329 10.9076H7.81596C7.56996 10.9076 7.36396 10.7169 7.33596 10.4635C7.30529 10.1889 7.06196 9.99157 6.78396 10.0216C6.50929 10.0516 6.31196 10.2996 6.34196 10.5736C6.41396 11.2249 6.88996 11.7356 7.49996 11.8703V12.0002C7.49996 12.2762 7.72396 12.5002 7.99996 12.5002C8.27596 12.5002 8.49996 12.2762 8.49996 12.0002V11.8716C8.77596 11.8109 9.02997 11.6729 9.23397 11.4656C9.51263 11.1829 9.66663 10.8076 9.66663 10.4096C9.66663 9.72292 9.20662 9.12557 8.54529 8.95557Z"
        fill="#25314C"
      />
    </svg>
  );
};

export const LanguageIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.833572C4.048 0.833572 0.833328 4.04891 0.833328 8.00024C0.833328 11.9516 4.048 15.1669 8 15.1669C11.952 15.1669 15.1667 11.9516 15.1667 8.00024C15.1667 4.04891 11.952 0.833572 8 0.833572ZM14.1667 8.00024C14.1667 8.02291 14.1633 8.04491 14.1633 8.06758C13.8647 8.13758 13.5653 8.29023 13.3333 8.52756C13.232 8.4469 13 8.20623 12.6247 7.51357C12.21 6.7489 12.3746 6.39357 12.624 5.85557C12.7086 5.67357 12.792 5.49023 12.8533 5.3009C12.9513 5.0109 12.9353 4.62557 12.8653 4.22357C13.6773 5.2689 14.1667 6.57691 14.1667 8.00024ZM1.83333 8.00024C1.83333 7.67357 1.86599 7.35557 1.91532 7.0429C2.49732 8.7149 3.80333 9.37758 4.53133 9.74491C4.65399 9.80691 4.79931 9.88023 4.87931 9.93023C4.91131 10.1082 4.90601 10.2336 4.89534 10.4516C4.88534 10.6696 4.87265 10.9416 4.89265 11.3649C4.93265 12.1882 5.60201 12.5382 6.09134 12.7936C6.38468 12.9469 6.66264 13.0916 6.80464 13.3016C6.87598 13.4036 6.94199 13.7236 6.91866 14.0656C4.03332 13.5529 1.83333 11.0316 1.83333 8.00024ZM7.91198 14.1622C7.95398 13.6189 7.85397 13.0556 7.62931 12.7349C7.34998 12.3222 6.928 12.1016 6.55533 11.9076C6.05933 11.6482 5.90265 11.5329 5.89265 11.3176C5.87465 10.9389 5.88667 10.6949 5.89534 10.4996C5.90867 10.2182 5.91999 9.97492 5.83333 9.60225C5.74866 9.23892 5.41066 9.06825 4.98266 8.85225C4.07533 8.39492 2.57001 7.62958 2.62601 4.98624C3.68401 3.10691 5.69465 1.83357 8.00065 1.83357C8.26265 1.83357 8.51931 1.85557 8.77331 1.88757C8.66598 2.02823 8.51268 2.14491 8.35534 2.19624C6.97734 2.64758 6.96267 3.87291 6.95267 4.68424C6.94467 5.36491 6.90068 5.48891 6.80135 5.51224C6.71801 5.50624 6.48332 5.37956 6.34399 5.30356C5.98599 5.1089 5.61668 4.90758 5.23201 5.00091C4.91468 5.07558 4.52864 5.37025 4.40531 5.78892C4.34398 5.99692 4.30065 6.40891 4.69999 6.82291C4.94132 7.07291 4.95 7.17091 4.96866 7.36625C4.98266 7.51558 5.00268 7.71956 5.11201 7.97023C5.53268 8.89956 6.79465 8.75623 7.27465 8.70023C8.01999 8.6069 8.15468 8.60291 8.52868 8.99224C8.68068 9.15024 8.76933 9.35156 8.86267 9.5649C9.04067 9.9689 9.28333 10.5222 10.0347 10.6089C10.6213 10.6816 10.9973 10.8662 11.11 11.0176C11.1373 11.0542 11.144 11.0796 11.1367 11.1222C11.1013 11.3316 10.8387 11.5816 10.534 11.8716C10.0287 12.3516 9.35935 12.9956 9.11735 14.0616C8.75468 14.1282 8.382 14.1682 8 14.1682C7.97 14.1669 7.94132 14.1629 7.91198 14.1622ZM10.2927 13.7202C10.526 13.2622 10.8767 12.9236 11.2227 12.5949C11.6393 12.1989 12.032 11.8256 12.1233 11.2869C12.176 10.9742 12.1033 10.6736 11.9127 10.4182C11.494 9.85625 10.634 9.67357 10.1547 9.61423C9.99732 9.59623 9.95533 9.5609 9.77933 9.1609C9.66667 8.90424 9.52598 8.58423 9.25065 8.29823C8.51798 7.53557 7.91399 7.6109 7.15665 7.70623C6.24199 7.81023 6.05998 7.63556 6.02665 7.56223C5.98398 7.4649 5.97664 7.38758 5.96598 7.27091C5.93398 6.93291 5.86798 6.59091 5.42065 6.12758C5.38332 6.08891 5.368 6.06224 5.366 6.0689C5.37667 6.04024 5.43599 5.98491 5.42399 5.97757C5.50465 5.98491 5.73132 6.10824 5.86665 6.18157C6.22199 6.37491 6.58999 6.57357 6.97599 6.49424C7.93465 6.2969 7.94532 5.37157 7.95332 4.69557C7.96466 3.77691 8.03531 3.3529 8.66731 3.14624C9.12731 2.99557 9.58799 2.60891 9.79532 2.10158C10.3347 2.26624 10.84 2.50491 11.3053 2.80224C11.6327 3.30491 12.0313 4.6129 11.9053 4.98756C11.8546 5.14356 11.786 5.28958 11.718 5.43491C11.4393 6.03558 11.0927 6.78356 11.7467 7.99023C12.3113 9.0309 12.7647 9.49892 13.2633 9.55625C13.2907 9.55958 13.322 9.56158 13.3573 9.56158C13.5353 9.56158 13.8 9.50424 14.0433 9.23358C13.6253 11.2796 12.19 12.9569 10.2927 13.7202Z"
        fill="#292524"
      />
    </svg>
  );
};

export const MessageIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1368_286)">
        <path
          d="M5.0786 9.35732C5.0268 9.02351 4.99993 8.68154 4.99993 8.33332C4.99993 4.65142 8.00433 1.66666 11.7105 1.66666C15.4166 1.66666 18.421 4.65142 18.421 8.33332C18.421 9.16505 18.2677 9.9612 17.9876 10.6954C17.9294 10.8479 17.9003 10.9241 17.8871 10.9837C17.874 11.0426 17.869 11.0841 17.8676 11.1445C17.8661 11.2055 17.8744 11.2726 17.8909 11.4069L18.2264 14.1321C18.2627 14.4271 18.2809 14.5746 18.2318 14.6818C18.1888 14.7758 18.1125 14.8504 18.0175 14.8912C17.9092 14.9378 17.7621 14.9163 17.4681 14.8732L14.8137 14.4841C14.6751 14.4638 14.6058 14.4536 14.5427 14.454C14.4802 14.4543 14.437 14.4589 14.3759 14.4718C14.3142 14.4848 14.2353 14.5143 14.0774 14.5734C13.3414 14.8491 12.5436 15 11.7105 15C11.362 15 11.0197 14.9736 10.6855 14.9227M6.35961 18.3333C8.83036 18.3333 10.8333 16.2813 10.8333 13.75C10.8333 11.2187 8.83036 9.16666 6.35961 9.16666C3.88886 9.16666 1.88592 11.2187 1.88592 13.75C1.88592 14.2588 1.96686 14.7483 2.11625 15.2056C2.1794 15.3989 2.21098 15.4956 2.22134 15.5616C2.23216 15.6305 2.23406 15.6693 2.23003 15.7389C2.22617 15.8057 2.20947 15.8811 2.17608 16.0319L1.66663 18.3333L4.16229 17.9925C4.29851 17.9739 4.36662 17.9646 4.4261 17.965C4.48873 17.9654 4.52196 17.9688 4.58338 17.981C4.64171 17.9927 4.72843 18.0233 4.90185 18.0845C5.35879 18.2458 5.84922 18.3333 6.35961 18.3333Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1368_286">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShowImgIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2.70833H5C2.985 2.70833 1.875 3.81833 1.875 5.83333V14.1667C1.875 16.1817 2.985 17.2917 5 17.2917H15C17.015 17.2917 18.125 16.1817 18.125 14.1667V5.83333C18.125 3.81833 17.015 2.70833 15 2.70833ZM5 3.95833H15C16.3142 3.95833 16.875 4.51916 16.875 5.83333V10.9908L13.5333 7.64994C12.9833 7.0991 12.0167 7.0991 11.4667 7.64994L7.5 11.6158L6.86666 10.9833C6.31666 10.4324 5.35001 10.4324 4.80001 10.9833L3.125 12.6583V5.83333C3.125 4.51916 3.68583 3.95833 5 3.95833ZM15 16.0417H5C3.77333 16.0417 3.20997 15.545 3.13914 14.4108L5.68329 11.8667C5.78912 11.7617 5.87663 11.7617 5.98246 11.8667L6.76503 12.6491C7.1542 13.0391 7.84502 13.0383 8.23252 12.6491L12.3491 8.53251C12.455 8.42751 12.5425 8.42751 12.6483 8.53251L16.8734 12.7576V14.1667C16.875 15.4808 16.3142 16.0417 15 16.0417ZM5.625 7.49999C5.625 6.92499 6.09167 6.45833 6.66667 6.45833C7.24167 6.45833 7.70833 6.92499 7.70833 7.49999C7.70833 8.07499 7.24167 8.54166 6.66667 8.54166C6.09167 8.54166 5.625 8.07499 5.625 7.49999Z"
        fill="#0C67E6"
      />
    </svg>
  );
};

export const ScreenshotsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 4.5V8C22 8.552 21.553 9 21 9C20.447 9 20 8.552 20 8V4.5C20 4.051 19.948 4 19.5 4H16C15.447 4 15 3.552 15 3C15 2.448 15.447 2 16 2H19.5C21.042 2 22 2.958 22 4.5ZM8 2H4.5C2.958 2 2 2.958 2 4.5V8C2 8.552 2.447 9 3 9C3.553 9 4 8.552 4 8V4.5C4 4.051 4.052 4 4.5 4H8C8.553 4 9 3.552 9 3C9 2.448 8.553 2 8 2ZM8 20H4.5C4.052 20 4 19.949 4 19.5V16C4 15.448 3.553 15 3 15C2.447 15 2 15.448 2 16V19.5C2 21.042 2.958 22 4.5 22H8C8.553 22 9 21.552 9 21C9 20.448 8.553 20 8 20ZM21 15C20.447 15 20 15.448 20 16V19.5C20 19.949 19.948 20 19.5 20H16C15.447 20 15 20.448 15 21C15 21.552 15.447 22 16 22H19.5C21.042 22 22 21.042 22 19.5V16C22 15.448 21.553 15 21 15Z"
        fill="#25314C"
      />
    </svg>
  );
};

export const UploadIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.35248 4.89752C6.13273 4.67777 6.13273 4.32149 6.35248 4.10174L8.60248 1.85174C8.65423 1.79999 8.71658 1.75875 8.78558 1.73025C8.92283 1.67325 9.07808 1.67325 9.21533 1.73025C9.28433 1.75875 9.3465 1.79999 9.39825 1.85174L11.6483 4.10174C11.868 4.32149 11.868 4.67777 11.6483 4.89752C11.5388 5.00702 11.3947 5.06249 11.2507 5.06249C11.1067 5.06249 10.9627 5.00777 10.8532 4.89752L9.56323 3.60749V12C9.56323 12.3105 9.31123 12.5625 9.00073 12.5625C8.69023 12.5625 8.43823 12.3105 8.43823 12V3.60823L7.14825 4.89825C6.92775 5.11725 6.57223 5.11727 6.35248 4.89752ZM13.5 6.9375C13.1895 6.9375 12.9375 7.1895 12.9375 7.5C12.9375 7.81049 13.1895 8.0625 13.5 8.0625C14.6827 8.0625 15.1875 8.56725 15.1875 9.75V13.5C15.1875 14.6827 14.6827 15.1875 13.5 15.1875H4.5C3.31725 15.1875 2.8125 14.6827 2.8125 13.5V9.75C2.8125 8.56725 3.31725 8.0625 4.5 8.0625C4.8105 8.0625 5.0625 7.81049 5.0625 7.5C5.0625 7.1895 4.8105 6.9375 4.5 6.9375C2.6865 6.9375 1.6875 7.93649 1.6875 9.75V13.5C1.6875 15.3135 2.6865 16.3125 4.5 16.3125H13.5C15.3135 16.3125 16.3125 15.3135 16.3125 13.5V9.75C16.3125 7.93649 15.3135 6.9375 13.5 6.9375Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadIcon2 = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 13.3333L9.99999 10L6.66666 13.3333M9.99999 10V17.5M16.6667 13.9524C17.6846 13.1117 18.3333 11.8399 18.3333 10.4167C18.3333 7.88536 16.2813 5.83333 13.75 5.83333C13.5679 5.83333 13.3975 5.73833 13.3051 5.58145C12.2184 3.73736 10.212 2.5 7.91666 2.5C4.46488 2.5 1.66666 5.29822 1.66666 8.75C1.66666 10.4718 2.36286 12.0309 3.48911 13.1613"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3.5H11.6273C11.0267 3.5 11.0013 3.424 10.8367 2.93066L10.702 2.526C10.4973 1.91267 9.926 1.5 9.27934 1.5H6.72066C6.074 1.5 5.502 1.912 5.298 2.526L5.16334 2.93066C4.99867 3.42466 4.97333 3.5 4.37267 3.5H2C1.724 3.5 1.5 3.724 1.5 4C1.5 4.276 1.724 4.5 2 4.5H2.86533L3.37667 12.166C3.47534 13.6493 4.38467 14.5 5.87134 14.5H10.1293C11.6153 14.5 12.5247 13.6493 12.624 12.166L13.1353 4.5H14C14.276 4.5 14.5 4.276 14.5 4C14.5 3.724 14.276 3.5 14 3.5ZM6.24666 2.842C6.31533 2.63733 6.50533 2.5 6.72066 2.5H9.27934C9.49467 2.5 9.68534 2.63733 9.75334 2.842L9.888 3.24666C9.91733 3.334 9.94667 3.41867 9.97867 3.5H6.02C6.052 3.418 6.08201 3.33333 6.11134 3.24666L6.24666 2.842ZM11.6253 12.0993C11.562 13.0547 11.086 13.5 10.1287 13.5H5.87067C4.91333 13.5 4.438 13.0553 4.374 12.0993L3.86734 4.5H4.372C4.45533 4.5 4.52467 4.49134 4.59933 4.486C4.622 4.48934 4.64267 4.5 4.666 4.5H11.3327C11.3567 4.5 11.3767 4.48934 11.3993 4.486C11.474 4.49134 11.5433 4.5 11.6267 4.5H12.1313L11.6253 12.0993ZM9.83333 7.33333V10.6667C9.83333 10.9427 9.60933 11.1667 9.33333 11.1667C9.05733 11.1667 8.83333 10.9427 8.83333 10.6667V7.33333C8.83333 7.05733 9.05733 6.83333 9.33333 6.83333C9.60933 6.83333 9.83333 7.05733 9.83333 7.33333ZM7.16667 7.33333V10.6667C7.16667 10.9427 6.94267 11.1667 6.66667 11.1667C6.39067 11.1667 6.16667 10.9427 6.16667 10.6667V7.33333C6.16667 7.05733 6.39067 6.83333 6.66667 6.83333C6.94267 6.83333 7.16667 7.05733 7.16667 7.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DealExpiredIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 8.125H2.75004C2.61171 8.125 2.5 8.23671 2.5 8.37504V15C2.5 16.6667 3.33333 17.5 5 17.5H15C16.6667 17.5 17.5 16.6667 17.5 15V8.37504C17.5 8.23671 17.3883 8.125 17.25 8.125ZM12.1084 13.725C12.3525 13.9691 12.3525 14.365 12.1084 14.6092C11.9867 14.7308 11.8267 14.7925 11.6667 14.7925C11.5067 14.7925 11.3466 14.7317 11.225 14.6092L10 13.3842L8.77502 14.6092C8.65336 14.7308 8.49333 14.7925 8.33333 14.7925C8.17333 14.7925 8.01331 14.7317 7.89164 14.6092C7.64748 14.365 7.64748 13.9691 7.89164 13.725L9.11662 12.5L7.89164 11.275C7.64748 11.0309 7.64748 10.635 7.89164 10.3908C8.13581 10.1467 8.53167 10.1467 8.77584 10.3908L10.0008 11.6158L11.2258 10.3908C11.47 10.1467 11.8658 10.1467 12.11 10.3908C12.3542 10.635 12.3542 11.0309 12.11 11.275L10.885 12.5L12.1084 13.725ZM17.5 6.25V6.62496C17.5 6.76329 17.3883 6.875 17.25 6.875H2.75004C2.61171 6.875 2.5 6.76329 2.5 6.62496V6.25C2.5 4.58333 3.33333 3.75 5 3.75H6.04167V2.5C6.04167 2.15833 6.325 1.875 6.66667 1.875C7.00833 1.875 7.29167 2.15833 7.29167 2.5V3.75H12.7083V2.5C12.7083 2.15833 12.9917 1.875 13.3333 1.875C13.675 1.875 13.9583 2.15833 13.9583 2.5V3.75H15C16.6667 3.75 17.5 4.58333 17.5 6.25Z"
        fill="#1C2024"
      />
    </svg>
  );
};

export const PausedIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99984 1.66663C5.39734 1.66663 1.6665 5.39746 1.6665 9.99996C1.6665 14.6025 5.39734 18.3333 9.99984 18.3333C14.6023 18.3333 18.3332 14.6025 18.3332 9.99996C18.3332 5.39746 14.6023 1.66663 9.99984 1.66663ZM8.95817 12.7775C8.95817 13.1483 8.769 13.3333 8.38983 13.3333H7.44318C7.06401 13.3333 6.87484 13.1483 6.87484 12.7775V7.22164C6.87484 6.85164 7.06401 6.66581 7.44318 6.66581H8.38983C8.769 6.66581 8.95817 6.85081 8.95817 7.22164V12.7775ZM13.1248 12.7775C13.1248 13.1483 12.9357 13.3333 12.5565 13.3333H11.6098C11.2307 13.3333 11.0415 13.1483 11.0415 12.7775V7.22164C11.0415 6.85164 11.2307 6.66581 11.6098 6.66581H12.5565C12.9357 6.66581 13.1248 6.85081 13.1248 7.22164V12.7775Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CopyAltIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7188 3.64583H5.61458C4.34467 3.64583 3.64583 4.34467 3.64583 5.61458V10.7188C3.64583 11.9887 4.34467 12.6875 5.61458 12.6875H10.7188C11.9887 12.6875 12.6875 11.9887 12.6875 10.7188V5.61458C12.6875 4.34467 11.9887 3.64583 10.7188 3.64583ZM11.8125 10.7188C11.8125 11.4957 11.4957 11.8125 10.7188 11.8125H5.61458C4.83758 11.8125 4.52083 11.4957 4.52083 10.7188V5.61458C4.52083 4.83758 4.83758 4.52083 5.61458 4.52083H10.7188C11.4957 4.52083 11.8125 4.83758 11.8125 5.61458V10.7188ZM2.1875 3.27833V8.38834C2.1875 9.08717 2.4693 9.25925 2.56205 9.31642C2.76855 9.44242 2.8326 9.71192 2.7066 9.91784C2.62377 10.0526 2.48035 10.1267 2.33276 10.1267C2.25518 10.1267 2.17578 10.1057 2.10461 10.0625C1.57903 9.7405 1.3125 9.17759 1.3125 8.38834V3.27833C1.3125 2.02883 2.02948 1.3125 3.2784 1.3125H8.38826C9.37118 1.3125 9.84083 1.74357 10.0625 2.10465C10.1885 2.31057 10.1237 2.58007 9.91781 2.70607C9.71131 2.83265 9.44297 2.76733 9.31639 2.56141C9.2598 2.46866 9.0871 2.18693 8.38826 2.18693H3.2784C2.50374 2.18751 2.1875 2.50366 2.1875 3.27833Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShieldCheckIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0181 2.5C9.77807 3.611 8 4.5 3 5.5C3 6.637 3 10.2019 3 11.3889C3 18.0559 8.667 21.389 12 22.5C15.333 21.389 21 18.0559 21 11.3889C21 10.1639 21 6.694 21 5.5C16 4.5 14.2221 3.611 12.0181 2.5ZM15.542 11.03L11.542 15.03C11.396 15.176 11.204 15.25 11.012 15.25C10.82 15.25 10.6279 15.177 10.4819 15.03L8.48193 13.03C8.18893 12.737 8.18893 12.262 8.48193 11.969C8.77493 11.676 9.24997 11.676 9.54297 11.969L11.0129 13.439L14.4829 9.96899C14.7759 9.67599 15.2509 9.67599 15.5439 9.96899C15.8369 10.262 15.835 10.737 15.542 11.03Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoCircleIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00016 15.1667C4.04816 15.1667 0.833496 11.952 0.833496 8.00001C0.833496 4.04801 4.04816 0.833344 8.00016 0.833344C11.9522 0.833344 15.1668 4.04801 15.1668 8.00001C15.1668 11.952 11.9522 15.1667 8.00016 15.1667ZM8.00016 1.83334C4.5995 1.83334 1.8335 4.59934 1.8335 8.00001C1.8335 11.4007 4.5995 14.1667 8.00016 14.1667C11.4008 14.1667 14.1668 11.4007 14.1668 8.00001C14.1668 4.59934 11.4008 1.83334 8.00016 1.83334ZM8.50016 11V7.95265C8.50016 7.67665 8.27616 7.45265 8.00016 7.45265C7.72416 7.45265 7.50016 7.67665 7.50016 7.95265V11C7.50016 11.276 7.72416 11.5 8.00016 11.5C8.27616 11.5 8.50016 11.276 8.50016 11ZM8.68018 5.66668C8.68018 5.29868 8.38218 5.00001 8.01351 5.00001H8.00684C7.63884 5.00001 7.34342 5.29868 7.34342 5.66668C7.34342 6.03468 7.64551 6.33334 8.01351 6.33334C8.38151 6.33334 8.68018 6.03468 8.68018 5.66668Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PaypalIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2681_6169)">
        <path
          d="M10.5299 6.07709H17.2999C20.9349 6.07709 22.3029 7.91709 22.0919 10.6241C21.7434 15.0876 19.0449 17.5556 15.4654 17.5556H13.6584C13.1684 17.5556 12.8379 17.8796 12.7044 18.7606L11.9294 23.8776C11.8789 24.2096 11.7044 24.4051 11.4414 24.4286H7.19644C6.79694 24.4286 6.65494 24.1231 6.75944 23.4611L9.35194 7.04809C9.45544 6.39009 9.81544 6.07709 10.5304 6.07709H10.5299Z"
          fill="#009DE2"
        />
        <path
          d="M6.29805 0.428589H13.075C14.984 0.428589 17.2475 0.490589 18.762 1.82609C19.7735 2.71809 20.304 4.13959 20.182 5.66609C19.765 10.8396 16.67 13.7386 12.52 13.7386H9.17755C8.60855 13.7386 8.23155 14.1151 8.07105 15.1361L7.13855 21.0691C7.07855 21.4541 6.91105 21.6811 6.60655 21.7081H2.43205C1.96905 21.7081 1.80455 21.3541 1.92555 20.5866L4.93155 1.55459C5.05155 0.791589 5.46905 0.428589 6.29805 0.428589Z"
          fill="#113984"
        />
        <path
          d="M8.16846 14.5381L9.35196 7.04809C9.45546 6.39009 9.81546 6.07709 10.5305 6.07709H17.3C18.4205 6.07709 19.326 6.25209 20.0355 6.57459C19.3555 11.1796 16.377 13.7386 12.476 13.7386H9.13496C8.69496 13.7386 8.36646 13.9636 8.16896 14.5381H8.16846Z"
          fill="#172C70"
        />
      </g>
      <defs>
        <clipPath id="clip0_2681_6169">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.428589)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TriangleExclamationIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0057 14.2936L12.4999 3.99674C11.4333 2.00174 8.56744 2.00174 7.49995 3.99674L1.99417 14.2936C1.01583 16.1236 2.3442 18.3335 4.42337 18.3335H15.5765C17.6549 18.3335 18.9841 16.1227 18.0057 14.2936ZM9.37495 8.33349C9.37495 7.98849 9.65494 7.70849 9.99994 7.70849C10.3449 7.70849 10.6249 7.98849 10.6249 8.33349V11.6668C10.6249 12.0118 10.3449 12.2918 9.99994 12.2918C9.65494 12.2918 9.37495 12.0118 9.37495 11.6668V8.33349ZM10.0166 15.0002C9.55663 15.0002 9.17902 14.6268 9.17902 14.1668C9.17902 13.7068 9.54829 13.3335 10.0083 13.3335H10.0166C10.4775 13.3335 10.85 13.7068 10.85 14.1668C10.85 14.6268 10.4766 15.0002 10.0166 15.0002Z"
        fill="#FF9315"
      />
    </svg>
  );
};

export const TriangleExclamationIco2 = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99982 7.50001V10.8333M9.99982 14.1667H10.0081M8.84591 3.24311L1.99184 15.082C1.61167 15.7386 1.42159 16.0669 1.44968 16.3364C1.47419 16.5715 1.59733 16.785 1.78846 16.924C2.00759 17.0833 2.38698 17.0833 3.14575 17.0833H16.8539C17.6127 17.0833 17.992 17.0833 18.2112 16.924C18.4023 16.785 18.5254 16.5715 18.55 16.3364C18.578 16.0669 18.388 15.7386 18.0078 15.082L11.1537 3.24311C10.7749 2.58881 10.5855 2.26166 10.3384 2.15178C10.1229 2.05593 9.87678 2.05593 9.66123 2.15178C9.41413 2.26166 9.22472 2.58881 8.84591 3.24311Z"
        stroke="#44403C"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AiReviewNoDataIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.84281 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FlexibleTriangleExclamationIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0057 14.2936L12.4999 3.99674C11.4333 2.00174 8.56744 2.00174 7.49995 3.99674L1.99417 14.2936C1.01583 16.1236 2.3442 18.3335 4.42337 18.3335H15.5765C17.6549 18.3335 18.9841 16.1227 18.0057 14.2936ZM9.37495 8.33349C9.37495 7.98849 9.65494 7.70849 9.99994 7.70849C10.3449 7.70849 10.6249 7.98849 10.6249 8.33349V11.6668C10.6249 12.0118 10.3449 12.2918 9.99994 12.2918C9.65494 12.2918 9.37495 12.0118 9.37495 11.6668V8.33349ZM10.0166 15.0002C9.55663 15.0002 9.17902 14.6268 9.17902 14.1668C9.17902 13.7068 9.54829 13.3335 10.0083 13.3335H10.0166C10.4775 13.3335 10.85 13.7068 10.85 14.1668C10.85 14.6268 10.4766 15.0002 10.0166 15.0002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckLinearIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 12.8665L8.33995 16.4138C9.15171 17.5256 10.8179 17.504 11.6006 16.3715L18.25 6.75"
        stroke="#1E874C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InvitePageEmptyIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="167"
      height="159"
      viewBox="0 0 167 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.7014 113.077C87.9043 113.077 113.199 87.7638 113.199 56.5385C113.199 25.3131 87.9043 0 56.7014 0C25.4985 0 0.203613 25.3131 0.203613 56.5385C0.203613 87.7638 25.4985 113.077 56.7014 113.077Z"
        fill="#EAEEF9"
      />
      <mask
        id="mask0_833_214"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="114"
        height="114"
      >
        <path
          d="M56.7014 113.077C87.9043 113.077 113.199 87.7638 113.199 56.5385C113.199 25.3131 87.9043 0 56.7014 0C25.4985 0 0.203613 25.3131 0.203613 56.5385C0.203613 87.7638 25.4985 113.077 56.7014 113.077Z"
          fill="#F1F3F9"
        />
      </mask>
      <g mask="url(#mask0_833_214)">
        <rect
          x="47.896"
          y="57.0769"
          width="52.7692"
          height="34.4615"
          rx="5"
          fill="white"
        />
        <rect
          x="15.5881"
          y="17.2307"
          width="48.4615"
          height="30.1538"
          rx="5"
          fill="#C2C8D6"
        />
        <path
          d="M65.1869 19.1145C65.1869 15.7984 62.5832 13.1929 59.2695 13.1929H0.451043C-2.15259 13.1929 -4.28284 14.8509 -5.11127 17.1011C-5.34796 17.6933 -5.46631 18.4039 -5.46631 18.996V42.2088C-5.46631 43.9852 -4.63788 45.6433 -3.33606 46.7092C-2.27094 47.5382 -0.969121 48.1304 0.451043 48.1304H53.2338H59.2695C62.5832 48.1304 65.1869 45.5249 65.1869 42.2088V34.6291V19.1145ZM62.8199 42.3272C62.8199 44.2221 61.2814 45.8802 59.2695 45.8802H54.4173C55.7191 43.5115 57.4943 41.3797 59.5062 39.3664C60.5713 38.3005 61.6365 37.353 62.8199 36.524V42.3272Z"
          fill="#D5DDEA"
        />
        <path
          d="M33.9428 27.1679H7.6698C6.48633 27.1679 5.53955 26.2204 5.53955 25.0361C5.53955 23.8518 6.48633 22.9043 7.6698 22.9043H33.9428C35.1263 22.9043 36.0731 23.8518 36.0731 25.0361C36.0731 26.2204 35.1263 27.1679 33.9428 27.1679Z"
          fill="#989FB0"
        />
        <path
          d="M44.7124 38.5375H7.6698C6.48633 38.5375 5.53955 37.59 5.53955 36.4057C5.53955 35.2214 6.48633 34.2739 7.6698 34.2739H44.5941C45.7775 34.2739 46.7243 35.2214 46.7243 36.4057C46.7243 37.59 45.7775 38.5375 44.7124 38.5375Z"
          fill="#989FB0"
        />
        <path
          d="M19.7414 91.2398H-39.077C-42.3907 91.2398 -44.9944 88.6343 -44.9944 85.3182V62.1054C-44.9944 58.7893 -42.3907 56.1838 -39.077 56.1838H19.7414C23.0552 56.1838 25.6588 58.7893 25.6588 62.1054V85.3182C25.6588 88.5158 22.9368 91.2398 19.7414 91.2398Z"
          fill="#D5DDEA"
        />
        <path
          d="M5.06599 81.5285H-31.8583C-33.0417 81.5285 -33.9885 80.581 -33.9885 79.3967C-33.9885 78.2124 -33.0417 77.2649 -31.8583 77.2649H5.06599C6.24946 77.2649 7.19624 78.2124 7.19624 79.3967C7.19624 80.581 6.24946 81.5285 5.06599 81.5285Z"
          fill="#989FB0"
        />
        <path
          d="M95.4834 56.1838H36.6649C33.3512 56.1838 30.7476 58.7893 30.7476 62.1054V85.3182C30.7476 88.6343 33.3512 91.2398 36.6649 91.2398H95.4834C98.7971 91.2398 101.401 88.6343 101.401 85.3182V62.1054C101.401 58.7893 98.7971 56.1838 95.4834 56.1838ZM99.0338 85.3182C99.0338 87.2131 97.4953 88.8711 95.4834 88.8711H64.4765C62.7013 87.6868 61.0444 86.384 59.5059 84.8444C52.4051 77.7385 49.328 67.9086 50.2748 58.5525H95.4834C97.3769 58.5525 99.0338 60.0921 99.0338 62.1054V85.3182Z"
          fill="#D5DDEA"
        />
        <path
          d="M100.454 88.5159C99.5076 90.0555 97.7324 91.1214 95.8389 91.1214C97.3774 90.4108 98.9159 89.5818 100.454 88.5159Z"
          fill="#C2C8D6"
        />
        <path
          d="M70.1574 70.0404H43.8844C42.7009 70.0404 41.7542 69.093 41.7542 67.9086C41.7542 66.7243 42.7009 65.7769 43.8844 65.7769H70.1574C71.3409 65.7769 72.2877 66.7243 72.2877 67.9086C72.1693 69.093 71.2226 70.0404 70.1574 70.0404Z"
          fill="#989FB0"
        />
        <path
          d="M80.8084 81.5285H43.8841C42.7007 81.5285 41.7539 80.581 41.7539 79.3967C41.7539 78.2124 42.7007 77.2649 43.8841 77.2649H80.8084C81.9919 77.2649 82.9387 78.2124 82.9387 79.3967C82.9387 80.581 81.9919 81.5285 80.8084 81.5285Z"
          fill="#989FB0"
        />
      </g>
      <mask
        id="mask1_833_214"
        maskUnits="userSpaceOnUse"
        x="46"
        y="48"
        width="66"
        height="49"
      >
        <path
          d="M46.8191 53.3076L101.204 48.4614L110.358 49.5383L111.434 96.3845H67.8191L50.0499 75.3845L46.8191 53.3076Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask1_833_214)">
        <path
          d="M99.9827 53.8459H32.791C29.0055 53.8459 26.0312 56.8075 26.0312 60.5767V86.9613C26.0312 90.7306 29.0055 93.6921 32.791 93.6921H99.9827C103.768 93.6921 106.742 90.7306 106.742 86.9613V60.5767C106.742 56.8075 103.768 53.8459 99.9827 53.8459ZM104.039 86.9613C104.039 89.1152 102.281 90.9998 99.9827 90.9998H64.5617C62.5338 89.6536 60.6411 88.1729 58.8835 86.4229C50.7719 78.3459 47.2568 67.1729 48.3384 56.5383H99.9827C102.146 56.5383 104.039 58.2883 104.039 60.5767V86.9613Z"
          fill="#C2C8D6"
        />
        <path
          d="M46.7422 55.9228C46.7422 54.8183 47.6376 53.9229 48.7422 53.9229H101.05C104.364 53.9229 107.05 56.6091 107.05 59.9229V91.6921C107.05 92.7967 106.154 93.6921 105.05 93.6921H48.7422C47.6376 93.6921 46.7422 92.7966 46.7422 91.6921V55.9228Z"
          fill="url(#paint0_linear_833_214)"
        />
        <path
          d="M70.9793 68.9229H41.3476C40.0129 68.9229 38.9451 67.9657 38.9451 66.7691C38.9451 65.5725 40.0129 64.6152 41.3476 64.6152H70.9793C72.314 64.6152 73.3818 65.5725 73.3818 66.7691C73.2484 67.9657 72.1806 68.9229 70.9793 68.9229Z"
          fill="#D5DDEA"
        />
        <path
          d="M83.8465 81.846H41.3942C40.0336 81.846 38.9451 80.8888 38.9451 79.6922C38.9451 78.4956 40.0336 77.5383 41.3942 77.5383H83.8465C85.2071 77.5383 86.2956 78.4956 86.2956 79.6922C86.2956 80.8888 85.2071 81.846 83.8465 81.846Z"
          fill="#D5DDEA"
        />
      </g>
      <path
        d="M49.5115 41C49.5115 36.5817 53.0932 33 57.5115 33H65.5115V42C65.5115 45.3137 62.8252 48 59.5115 48H49.5115V41Z"
        fill="url(#paint1_linear_833_214)"
      />
      <g filter="url(#filter0_d_833_214)">
        <path
          d="M142.135 112.43L123.841 93.9405C121.965 92.0442 119.268 91.3331 116.805 91.8072L112.349 87.3034C125.014 71.4218 123.958 48.0734 109.417 33.3769C97.2211 21.0509 79.0443 18.3249 64.2684 25.3176C60.164 27.2139 56.2941 29.9399 52.7761 33.3769C48.4371 37.6436 45.3881 42.74 43.5118 48.1919C42.5736 50.7993 41.87 53.4068 41.5182 56.1327C39.7592 68.3403 43.5118 81.2589 52.7761 90.622C53.0106 90.859 53.1279 90.9775 53.3624 91.2146C61.1022 98.7998 71.07 102.474 81.1552 102.474C90.0677 102.474 98.9801 99.5109 106.251 93.585L110.707 98.0887C110.238 100.578 110.942 103.304 112.818 105.2L130.995 123.689C134.044 126.77 138.969 126.77 142.018 123.689C145.184 120.607 145.184 115.511 142.135 112.43ZM103.671 84.8145C102.264 86.2367 100.739 87.4219 99.2147 88.6071C97.6902 89.6738 96.1657 90.5034 94.6412 91.2146C86.1978 95.2442 76.2299 95.2442 67.7865 91.2146C64.503 89.6738 61.454 87.5405 58.7568 84.8145C51.017 76.9922 48.0853 66.2069 49.9616 56.1327C50.4307 53.4068 51.2516 50.6808 52.5415 48.1919C54.066 44.9919 56.1769 41.9104 58.7568 39.3029C60.5158 37.5251 62.3921 35.9844 64.3857 34.7992C69.5455 31.4806 75.409 29.9399 81.2725 29.9399C89.4813 29.9399 97.5729 33.0214 103.788 39.3029C116.101 51.866 116.101 72.2514 103.671 84.8145Z"
          fill="url(#paint2_linear_833_214)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_833_214"
          x="19.0972"
          y="10.5386"
          width="147.31"
          height="148.461"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_833_214"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_833_214"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_833_214"
          x1="104.658"
          y1="53.9229"
          x2="48.582"
          y2="54.219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_833_214"
          x1="64.8768"
          y1="33"
          x2="49.9994"
          y2="33.0553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_833_214"
          x1="92.7186"
          y1="19.1223"
          x2="92.7186"
          y2="127.126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDFEFF" />
          <stop offset="0.9964" stop-color="#ECF0F5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EmailConfirmedIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="42"
      height="36"
      viewBox="0 0 42 36"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.875 26.5417C22.125 20.7292 26.9791 15.8958 32.7916 15.6458C34.1458 15.5833 35.4585 15.75 36.6669 16.125C37.0835 16.25 37.5 15.9792 37.5 15.5417V6.25C37.5 2.08333 35.4167 0 31.25 0H6.25C2.08333 0 0 2.08333 0 6.25V25C0 29.1667 2.08333 31.25 6.25 31.25H21.7916C22.2083 31.25 22.5 30.8333 22.3541 30.4375C21.9791 29.2083 21.8125 27.9167 21.875 26.5417ZM20.8939 17.0396C20.2522 17.5063 19.5 17.7396 18.75 17.7396C18 17.7396 17.2457 17.5062 16.6061 17.0417L6.37309 9.59791C5.67517 9.09166 5.52092 8.11251 6.02926 7.4146C6.53551 6.71876 7.50811 6.56041 8.21228 7.07083L18.4458 14.5125C18.6292 14.6438 18.8729 14.6458 19.0562 14.5125L29.2898 7.07083C29.9918 6.56041 30.9665 6.71876 31.4728 7.4146C31.9811 8.11251 31.8269 9.08957 31.1289 9.59791L20.8939 17.0396ZM33.3333 18.75C28.7312 18.75 25 22.4813 25 27.0833C25 31.6854 28.7312 35.4167 33.3333 35.4167C37.9354 35.4167 41.6667 31.6854 41.6667 27.0833C41.6667 22.4813 37.9354 18.75 33.3333 18.75ZM36.675 26.0833L33.2021 29.5562C33.0063 29.7521 32.7417 29.8604 32.4646 29.8604C32.1875 29.8604 31.9229 29.75 31.7271 29.5562L29.9917 27.8208C29.5854 27.4146 29.5854 26.7542 29.9917 26.3479C30.3979 25.9417 31.0584 25.9417 31.4646 26.3479L32.4626 27.3479L35.198 24.6125C35.6042 24.2062 36.2647 24.2062 36.6709 24.6125C37.0772 25.0187 37.0813 25.6771 36.675 26.0833Z"
        fill="#FB6011"
      />
    </svg>
  );
};

export const QuestionIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73582 6.43659C4.94282 6.96743 4.79539 7.26314 4.76939 7.34114C4.65455 7.68022 4.33826 7.8947 4.00026 7.8947C3.91468 7.8947 3.82797 7.88164 3.74239 7.85239C3.31664 7.70939 3.08708 7.24902 3.23008 6.82327C3.42616 6.23827 3.93536 5.68685 4.83128 5.0856C5.93686 4.34602 5.79549 3.534 5.74884 3.26604L5.74878 3.26568C5.62528 2.55718 5.02832 1.95381 4.32849 1.83031C3.79441 1.73281 3.27454 1.87257 2.86721 2.21382C2.45771 2.55723 2.22266 3.06292 2.22266 3.60025C2.22266 4.04875 1.85866 4.41275 1.41016 4.41275C0.961656 4.41275 0.597656 4.04875 0.597656 3.60025C0.597656 2.58083 1.04384 1.62213 1.82275 0.968882C2.59409 0.323215 3.60914 0.0535644 4.61123 0.231231C5.98273 0.472814 7.10842 1.60698 7.34892 2.98823C7.58617 4.3554 7.01415 5.57968 5.73582 6.43659Z"
        fill="currentColor"
      />
      <path
        d="M4.02089 9.65512C4.61998 9.65512 5.10423 10.1405 5.10423 10.7385C5.10423 11.3365 4.61889 11.8218 4.02089 11.8218C3.42289 11.8218 2.93201 11.3365 2.93201 10.7385C2.93201 10.1405 3.41205 9.65512 4.01005 9.65512H4.02089Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfluencerMarketingEarningsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2188 1.6875H4.78125C2.78625 1.6875 1.6875 2.78625 1.6875 4.78125V13.2188C1.6875 15.2137 2.78625 16.3125 4.78125 16.3125H13.2188C15.2137 16.3125 16.3125 15.2137 16.3125 13.2188V4.78125C16.3125 2.78625 15.2137 1.6875 13.2188 1.6875ZM15.1875 13.2188C15.1875 14.58 14.58 15.1875 13.2188 15.1875H4.78125C3.40125 15.1875 2.8125 14.5988 2.8125 13.2188V4.78125C2.8125 3.40125 3.40125 2.8125 4.78125 2.8125H13.2188C14.58 2.8125 15.1875 3.42 15.1875 4.78125V13.2188ZM9.73952 8.60403L8.53349 8.30475C8.34749 8.25825 8.18926 8.15396 8.07001 8.00171C7.95751 7.85921 7.89523 7.67626 7.89523 7.48801C7.89523 7.02376 8.27249 6.64655 8.73674 6.64655H9.26175C9.69075 6.64655 10.05 6.96905 10.0988 7.39655C10.1333 7.70555 10.4093 7.92904 10.7205 7.89304C11.0295 7.85854 11.2515 7.58021 11.217 7.27121C11.1157 6.36971 10.4182 5.67448 9.54524 5.54773V5.25C9.54524 4.9395 9.29324 4.6875 8.98274 4.6875C8.67224 4.6875 8.42024 4.9395 8.42024 5.25V5.55304C7.48649 5.70604 6.77023 6.51152 6.77023 7.48727C6.77023 7.92752 6.91798 8.35803 7.18423 8.69403C7.45123 9.03828 7.83225 9.28723 8.25975 9.39523L9.46573 9.69452C9.84148 9.78977 10.104 10.1258 10.104 10.5113C10.104 10.7348 10.0163 10.9455 9.85652 11.1053C9.69677 11.265 9.48598 11.3527 9.26248 11.3527H8.73752C8.30852 11.3527 7.94925 11.0302 7.9005 10.6027C7.866 10.2937 7.58551 10.0687 7.27876 10.1062C6.96976 10.1407 6.74777 10.419 6.78227 10.728C6.88202 11.6182 7.56299 12.309 8.42024 12.4478V12.75C8.42024 13.0605 8.67224 13.3125 8.98274 13.3125C9.29324 13.3125 9.54524 13.0605 9.54524 12.75V12.4515C9.96149 12.3908 10.3478 12.2062 10.6515 11.9025C11.0235 11.5305 11.229 11.037 11.229 10.5127C11.229 9.61048 10.6178 8.82678 9.73952 8.60403Z"
        fill="#71717A"
      />
    </svg>
  );
};

export const AffiliateCommissionsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 15.5625H5C3.1865 15.5625 2.1875 14.5635 2.1875 12.75V9.9375H2.75C3.26675 9.9375 3.6875 9.51675 3.6875 9C3.6875 8.48325 3.26675 8.0625 2.75 8.0625H2.1875V5.25C2.1875 3.4365 3.1865 2.4375 5 2.4375H14C15.8135 2.4375 16.8125 3.4365 16.8125 5.25V8.0625H16.25C15.7332 8.0625 15.3125 8.48325 15.3125 9C15.3125 9.51675 15.7332 9.9375 16.25 9.9375H16.8125V12.75C16.8125 14.5635 15.8135 15.5625 14 15.5625ZM3.3125 10.9845V12.75C3.3125 13.9327 3.81725 14.4375 5 14.4375H14C15.1827 14.4375 15.6875 13.9327 15.6875 12.75V10.9845C14.8228 10.7392 14.1875 9.94275 14.1875 9C14.1875 8.05725 14.8228 7.26075 15.6875 7.0155V5.25C15.6875 4.06725 15.1827 3.5625 14 3.5625H5C3.81725 3.5625 3.3125 4.06725 3.3125 5.25V7.0155C4.17725 7.26075 4.8125 8.05725 4.8125 9C4.8125 9.94275 4.17725 10.7392 3.3125 10.9845ZM8.02252 11.2725L11.7725 7.5225C11.9923 7.30275 11.9923 6.9465 11.7725 6.72675C11.5528 6.507 11.1965 6.507 10.9767 6.72675L7.22675 10.4767C7.007 10.6965 7.007 11.0527 7.22675 11.2725C7.33625 11.382 7.48027 11.4375 7.62427 11.4375C7.76827 11.4375 7.91302 11.3827 8.02252 11.2725ZM8.375 7.125C8.375 6.711 8.04046 6.375 7.62646 6.375H7.61896C7.20646 6.375 6.87427 6.711 6.87427 7.125C6.87427 7.539 7.21323 7.875 7.62573 7.875C8.04048 7.875 8.375 7.539 8.375 7.125ZM12.125 10.875C12.125 10.461 11.7905 10.125 11.3765 10.125H11.369C10.9565 10.125 10.6243 10.461 10.6243 10.875C10.6243 11.289 10.9632 11.625 11.3757 11.625C11.7905 11.625 12.125 11.289 12.125 10.875Z"
        fill="#171717"
      />
    </svg>
  );
};

export const WithdrawalsIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 15.1873H15.5625V14.2498C15.5625 13.4398 15.0593 12.9373 14.25 12.9373H14.0625V8.81231H14.25C15.0593 8.81231 15.5625 8.30981 15.5625 7.49981V5.58049C15.5625 5.08024 15.2842 4.63029 14.8365 4.40679L9.75449 1.86583C9.28124 1.63033 8.71726 1.63033 8.24551 1.86583L3.16351 4.40679C2.71576 4.63029 2.4375 5.08024 2.4375 5.58049V7.49981C2.4375 8.30981 2.94075 8.81231 3.75 8.81231H3.9375V12.9373H3.75C2.94075 12.9373 2.4375 13.4398 2.4375 14.2498V15.1873H2.25C1.9395 15.1873 1.6875 15.4393 1.6875 15.7498C1.6875 16.0603 1.9395 16.3123 2.25 16.3123H15.75C16.0605 16.3123 16.3125 16.0603 16.3125 15.7498C16.3125 15.4393 16.0605 15.1873 15.75 15.1873ZM12.9375 12.9373H11.0625V8.81231H12.9375V12.9373ZM8.0625 12.9373V8.81231H9.9375V12.9373H8.0625ZM3.58804 7.66698C3.58729 7.66698 3.58729 7.66698 3.58804 7.66698C3.58429 7.66098 3.5625 7.61681 3.5625 7.49981V5.58049C3.5625 5.50924 3.6022 5.44484 3.66595 5.41259L8.74796 2.87163C8.90771 2.79213 9.0923 2.79213 9.25205 2.87163L14.334 5.41259C14.3978 5.44409 14.4375 5.50849 14.4375 5.58049V7.49981C14.4375 7.61681 14.4158 7.66034 14.4173 7.66259C14.4113 7.66559 14.367 7.68731 14.25 7.68731H3.75C3.63675 7.68731 3.59179 7.66698 3.58804 7.66698ZM5.0625 8.81231H6.9375V12.9373H5.0625V8.81231ZM3.5625 14.2498C3.5625 14.1328 3.58423 14.0893 3.58273 14.087C3.58873 14.084 3.633 14.0623 3.75 14.0623H14.25C14.3865 14.0623 14.4135 14.0826 14.4128 14.0826C14.4158 14.0894 14.4375 14.1328 14.4375 14.2498V15.1873H3.5625V14.2498ZM8.0625 5.24981C8.0625 4.73231 8.4825 4.31231 9 4.31231C9.5175 4.31231 9.9375 4.73231 9.9375 5.24981C9.9375 5.76731 9.5175 6.18731 9 6.18731C8.4825 6.18731 8.0625 5.76731 8.0625 5.24981Z"
        fill="#71717A"
      />
    </svg>
  );
};
export const DatePickerIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.5H11.1667V2C11.1667 1.724 10.9427 1.5 10.6667 1.5C10.3907 1.5 10.1667 1.724 10.1667 2V2.5H5.83333V2C5.83333 1.724 5.60933 1.5 5.33333 1.5C5.05733 1.5 4.83333 1.724 4.83333 2V2.5H4C2.388 2.5 1.5 3.388 1.5 5V12C1.5 13.612 2.388 14.5 4 14.5H12C13.612 14.5 14.5 13.612 14.5 12V5C14.5 3.388 13.612 2.5 12 2.5ZM4 3.5H4.83333V4C4.83333 4.276 5.05733 4.5 5.33333 4.5C5.60933 4.5 5.83333 4.276 5.83333 4V3.5H10.1667V4C10.1667 4.276 10.3907 4.5 10.6667 4.5C10.9427 4.5 11.1667 4.276 11.1667 4V3.5H12C13.0513 3.5 13.5 3.94867 13.5 5V5.5H2.5V5C2.5 3.94867 2.94867 3.5 4 3.5ZM12 13.5H4C2.94867 13.5 2.5 13.0513 2.5 12V6.5H13.5V12C13.5 13.0513 13.0513 13.5 12 13.5ZM6.01335 8.66667C6.01335 9.03467 5.71535 9.33333 5.34668 9.33333C4.97868 9.33333 4.6766 9.03467 4.6766 8.66667C4.6766 8.29867 4.97201 8 5.34001 8H5.34668C5.71468 8 6.01335 8.29867 6.01335 8.66667ZM8.68001 8.66667C8.68001 9.03467 8.38201 9.33333 8.01335 9.33333C7.64535 9.33333 7.34326 9.03467 7.34326 8.66667C7.34326 8.29867 7.63867 8 8.00667 8H8.01335C8.38135 8 8.68001 8.29867 8.68001 8.66667ZM11.3467 8.66667C11.3467 9.03467 11.0487 9.33333 10.68 9.33333C10.312 9.33333 10.0099 9.03467 10.0099 8.66667C10.0099 8.29867 10.3053 8 10.6733 8H10.68C11.048 8 11.3467 8.29867 11.3467 8.66667ZM6.01335 11.3333C6.01335 11.7013 5.71535 12 5.34668 12C4.97868 12 4.6766 11.7013 4.6766 11.3333C4.6766 10.9653 4.97201 10.6667 5.34001 10.6667H5.34668C5.71468 10.6667 6.01335 10.9653 6.01335 11.3333ZM8.68001 11.3333C8.68001 11.7013 8.38201 12 8.01335 12C7.64535 12 7.34326 11.7013 7.34326 11.3333C7.34326 10.9653 7.63867 10.6667 8.00667 10.6667H8.01335C8.38135 10.6667 8.68001 10.9653 8.68001 11.3333ZM11.3467 11.3333C11.3467 11.7013 11.0487 12 10.68 12C10.312 12 10.0099 11.7013 10.0099 11.3333C10.0099 10.9653 10.3053 10.6667 10.6733 10.6667H10.68C11.048 10.6667 11.3467 10.9653 11.3467 11.3333Z"
        fill="#60646C"
      />
    </svg>
  );
};

export const CheckedIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3332 4L5.99984 11.3333L2.6665 8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TableSortDefaultIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66666 9.99984L7.99999 13.3332L11.3333 9.99984M4.66666 5.99984L7.99999 2.6665L11.3333 5.99984"
        stroke="#71717A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableSortAscIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66675 5.99984L8.00008 2.6665L11.3334 5.99984"
        stroke="#71717A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.3"
        d="M4.66675 10L8.00008 13.3333L11.3334 10"
        stroke="#71717A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TableSortDescIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M4.66675 5.99984L8.00008 2.6665L11.3334 5.99984"
        stroke="#71717A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66675 10L8.00008 13.3333L11.3334 10"
        stroke="#71717A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const WebsiteIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0.9375C4.554 0.9375 0.9375 4.55475 0.9375 9C0.9375 13.4452 4.554 17.0625 9 17.0625C13.446 17.0625 17.0625 13.4452 17.0625 9C17.0625 4.55475 13.446 0.9375 9 0.9375ZM15.909 8.4375H12.8715C12.7732 6.38025 12.1402 4.28401 11.0452 2.37076C13.7025 3.19276 15.6773 5.5725 15.909 8.4375ZM9.54751 2.09024C10.8645 4.04849 11.6317 6.27 11.7465 8.4375H6.25351C6.36751 6.27 7.13549 4.04849 8.45249 2.09024C8.63399 2.07599 8.8155 2.0625 9 2.0625C9.1845 2.0625 9.36676 2.07599 9.54751 2.09024ZM6.95476 2.37076C5.85976 4.28401 5.22676 6.38025 5.12851 8.4375H2.091C2.32275 5.5725 4.29751 3.19276 6.95476 2.37076ZM2.091 9.5625H5.12851C5.22676 11.6198 5.85976 13.716 6.95476 15.6292C4.29751 14.8072 2.32275 12.4275 2.091 9.5625ZM8.45249 15.9098C7.13549 13.9515 6.36826 11.73 6.25351 9.5625H11.7465C11.6325 11.73 10.8645 13.9515 9.54751 15.9098C9.36601 15.924 9.1845 15.9375 9 15.9375C8.8155 15.9375 8.63324 15.924 8.45249 15.9098ZM11.0452 15.6292C12.1402 13.716 12.7732 11.6198 12.8715 9.5625H15.909C15.6773 12.4275 13.7025 14.8072 11.0452 15.6292Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SageIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 4.16675C13.3333 3.33341 11.8517 2.59258 10.0151 1.66675C8.14839 2.59258 6.66667 3.33341 2.5 4.16675C2.5 5.11425 2.5 8.08501 2.5 9.07418C2.5 14.63 7.2225 17.4076 10 18.3334C12.7775 17.4076 17.5 14.63 17.5 9.07418C17.5 8.05335 17.5 5.16175 17.5 4.16675ZM13.5508 9.81596L9.38416 14.4459C9.30332 14.535 9.18993 14.5842 9.0741 14.5842C9.02326 14.5842 8.9733 14.5751 8.92497 14.5568C8.76413 14.4951 8.65743 14.3401 8.65743 14.1676V10.8808H6.76005C6.59588 10.8808 6.44669 10.7842 6.37919 10.6342C6.31252 10.4834 6.33999 10.3083 6.44999 10.1858L10.6167 5.55591C10.7325 5.42758 10.9167 5.38418 11.0758 5.44584C11.2367 5.50751 11.3434 5.66254 11.3434 5.83504V9.12179H13.2408C13.4049 9.12179 13.5541 9.21837 13.6216 9.36837C13.6883 9.51753 13.6608 9.69346 13.5508 9.81596Z"
        fill="#00BC7D"
      />
    </svg>
  );
};
export const FlexibleSageIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 4.16675C13.3333 3.33341 11.8517 2.59258 10.0151 1.66675C8.14839 2.59258 6.66667 3.33341 2.5 4.16675C2.5 5.11425 2.5 8.08501 2.5 9.07418C2.5 14.63 7.2225 17.4076 10 18.3334C12.7775 17.4076 17.5 14.63 17.5 9.07418C17.5 8.05335 17.5 5.16175 17.5 4.16675ZM13.5508 9.81596L9.38416 14.4459C9.30332 14.535 9.18993 14.5842 9.0741 14.5842C9.02326 14.5842 8.9733 14.5751 8.92497 14.5568C8.76413 14.4951 8.65743 14.3401 8.65743 14.1676V10.8808H6.76005C6.59588 10.8808 6.44669 10.7842 6.37919 10.6342C6.31252 10.4834 6.33999 10.3083 6.44999 10.1858L10.6167 5.55591C10.7325 5.42758 10.9167 5.38418 11.0758 5.44584C11.2367 5.50751 11.3434 5.66254 11.3434 5.83504V9.12179H13.2408C13.4049 9.12179 13.5541 9.21837 13.6216 9.36837C13.6883 9.51753 13.6608 9.69346 13.5508 9.81596Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DnaChatBotIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="32"
      height="25"
      viewBox="0 0 32 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5116 0.442363C17.4264 0.418787 18.4496 0.414072 19.1356 0.939807C21.3706 2.65139 24.4566 2.15631 26.6161 3.97163C28.4857 5.54176 29.3792 7.55512 29.2283 9.98576C29.1906 10.5917 29.3297 10.9901 29.7352 11.438C31.4279 13.3123 31.7014 15.8679 30.5014 17.985C29.2896 20.1233 26.9934 21.2007 24.5038 20.7174C23.8484 20.5901 23.3745 20.6136 22.804 21.0403C21.6134 21.9339 20.246 21.9975 18.9046 21.3775C18.4189 21.1535 18.0747 21.1488 17.6056 21.4034C16.2759 22.1272 14.8425 22.3158 13.3926 21.8537C12.7843 21.6604 12.4472 21.7476 11.9922 22.2286C10.3207 23.9944 8.25784 24.4659 5.96629 23.6832C3.80912 22.9453 2.36394 20.9225 2.30029 18.5531C2.28378 17.9024 2.08575 17.4852 1.64017 17.0325C-1.12996 14.2176 -0.274168 9.64391 3.32582 7.98655C3.88221 7.72958 4.25706 7.4726 4.46452 6.8172C5.22837 4.39835 7.21344 2.92487 9.7431 2.88715C10.4268 2.87536 10.9077 2.67969 11.4146 2.25061C12.8598 1.03411 14.6303 0.437647 16.5116 0.442363ZM19.8499 3.12762C18.0959 1.9677 16.1085 1.76495 14.1753 2.50994C12.6052 3.11583 12.5769 3.20306 13.6449 4.42192C13.9608 4.78027 14.1447 5.15748 13.8052 5.57477C13.435 6.02978 13.0012 5.98262 12.5698 5.63371C12.3859 5.48518 12.2091 5.32958 12.0134 5.19991C10.0401 3.8844 7.26766 4.59402 6.24448 6.66867C5.99458 7.17555 5.91914 7.48675 6.67356 7.58812C7.57414 7.70836 8.4488 8.0502 9.09948 8.70325C10.0661 9.66985 10.8441 10.8793 12.5533 10.1744C12.9399 10.014 13.3879 10.429 13.4138 10.9359C13.4397 11.4451 13.1144 11.7469 12.6146 11.7657C11.0822 11.8199 10.2405 12.6168 9.97178 14.0997C9.89162 14.5406 9.56392 14.7881 9.11599 14.7292C8.61618 14.6632 8.36628 14.3119 8.39929 13.8121C8.43701 13.258 8.53367 12.6828 8.88259 12.2561C9.41068 11.6078 9.14192 11.1174 8.72463 10.5964C7.70381 9.32564 5.93093 8.80698 4.36551 9.32564C2.81188 9.83959 1.75805 11.2093 1.66374 12.836C1.54587 14.8329 2.66099 16.3323 4.77101 16.9736C5.28731 17.1315 5.79183 17.2848 5.71403 17.9567C5.65509 18.4777 5.26138 18.7276 4.78515 18.6286C3.68889 18.4022 3.94115 19.0506 4.10853 19.6211C4.61541 21.3492 6.30578 22.4902 8.16825 22.3794C10.1297 22.2639 11.5608 20.8753 11.8555 18.7464C11.938 18.15 12.0464 17.5936 12.7796 17.6502C13.5317 17.7091 13.5317 18.3174 13.5058 18.8926C13.4421 20.2364 13.7321 20.5311 15.1042 20.4486C16.2523 20.3779 17.2307 19.9299 17.9828 19.0411C19.1828 17.6242 18.8975 16.0022 17.2566 15.1205C16.7168 14.8305 16.2523 14.5429 16.5777 13.8757C16.9077 13.1968 17.4806 13.4136 18.004 13.64C20.0527 14.5288 20.8661 16.9005 19.9089 19.1119C19.7957 19.3736 19.2771 19.7225 19.8405 19.9747C20.4299 20.2388 21.0688 20.1751 21.6511 19.8404C22.1651 19.5433 21.7124 19.35 21.5804 19.1189C21.3635 18.7347 21.3588 18.3504 21.6936 18.0462C22.0307 17.7398 22.4103 17.794 22.7663 18.051C23.0515 18.2584 23.3226 18.4918 23.6244 18.6663C25.5788 19.7956 28.0354 19.1001 29.1034 17.1244C30.1501 15.1865 29.4381 12.7724 27.5191 11.7374C26.3592 11.1127 26.2083 11.1763 25.89 12.4164C25.8405 12.605 25.7839 12.796 25.7085 12.9751C25.5104 13.4561 25.1922 13.805 24.6287 13.6211C24.0653 13.4349 23.9827 12.961 24.1549 12.4659C24.6075 11.1669 24.2539 10.1579 23.1105 9.41994C22.6154 9.09932 22.3513 8.69146 22.7238 8.14922C23.0633 7.65649 23.5372 7.75787 23.9733 8.03134C24.2704 8.21759 24.6169 8.39912 24.8008 8.67731C25.2723 9.39401 25.9183 9.60148 26.734 9.75943C27.5851 9.92446 27.67 9.66513 27.611 8.96729C27.4106 6.64746 25.6071 4.64117 23.2566 4.15552C21.1773 3.72644 19.1851 5.30601 19.1309 7.43017C19.1097 8.28596 19.3572 9.05217 19.8877 9.72878C20.2413 10.1791 20.3828 10.66 19.8358 11.0537C19.27 11.4616 18.8739 11.0867 18.5509 10.66C18.3175 10.3488 18.1077 10.0093 17.945 9.6557C16.9077 7.3948 17.5254 5.24235 19.8476 3.12291L19.8499 3.12762Z"
        fill="black"
      />
    </svg>
  );
};
export const BoldIcon = ({ className }: any) => {
  return (
    <svg
      width="14"
      height="15 "
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.73061 6.34254V2.07315C2.73061 1.69572 2.88055 1.33374 3.14744 1.06685C3.41433 0.799961 3.7763 0.650024 4.15374 0.650024H7.71156C8.46644 0.650024 9.19039 0.949897 9.72417 1.48367C10.2579 2.01745 10.5578 2.74141 10.5578 3.49628C10.5578 4.25115 10.2579 4.97511 9.72417 5.50889C9.19039 6.04266 8.46644 6.34254 7.71156 6.34254M2.73061 6.34254H7.71156M2.73061 6.34254V12.035C2.73061 12.4125 2.88055 12.7744 3.14744 13.0413C3.41433 13.3082 3.7763 13.4582 4.15374 13.4582H7.71156C8.17878 13.4582 8.64143 13.3661 9.07308 13.1873C9.50474 13.0085 9.89695 12.7465 10.2273 12.4161C10.5577 12.0857 10.8198 11.6935 10.9986 11.2619C11.1774 10.8302 11.2694 10.3676 11.2694 9.90034C11.2694 9.43312 11.1774 8.97048 10.9986 8.53882C10.8198 8.10717 10.5577 7.71496 10.2273 7.38458C9.89695 7.05421 9.50474 6.79214 9.07308 6.61334C8.64143 6.43455 8.17878 6.34254 7.71156 6.34254"
        stroke="currentColor"
      />
    </svg>
  );
};
export const ItalicIcon = ({ className }: any) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.90008 13.3L9.10009 0.699951M4.90008 0.699951H13.3001M0.700085 13.3H9.10009"
        stroke="currentColor"
      />
    </svg>
  );
};
export const SortIcon = ({ className }: any) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.01679 1.40013H12.9499M5.01679 6.99998H12.9499M5.01679 12.5998H12.9499M1.98331 1.40013C1.98331 1.65785 1.77438 1.86678 1.51666 1.86678C1.25893 1.86678 1.05 1.65785 1.05 1.40013C1.05 1.1424 1.25893 0.933472 1.51666 0.933472C1.77438 0.933472 1.98331 1.1424 1.98331 1.40013ZM1.98331 6.99997C1.98331 7.25766 1.77438 7.46663 1.51666 7.46663C1.25893 7.46663 1.05 7.25766 1.05 6.99997C1.05 6.74229 1.25893 6.53332 1.51666 6.53332C1.77438 6.53332 1.98331 6.74229 1.98331 6.99997ZM1.98331 12.5999C1.98331 12.8576 1.77438 13.0666 1.51666 13.0666C1.25893 13.0666 1.05 12.8576 1.05 12.5999C1.05 12.3422 1.25893 12.1333 1.51666 12.1333C1.77438 12.1333 1.98331 12.3422 1.98331 12.5999Z"
        stroke="currentColor"
      />
    </svg>
  );
};
export const ImageUploadIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4793 4.95004C18.0626 4.39671 17.3934 4.05256 16.4892 3.92506L7.68837 2.69174C6.78421 2.56424 6.0501 2.71007 5.49843 3.12591C4.9451 3.54257 4.60012 4.21173 4.47345 5.11423L4.35087 5.97767H3.88924C2.05341 5.97767 1.04175 6.9885 1.04175 8.82517V16.0485C1.04175 17.8851 2.05341 18.896 3.88924 18.896H12.7792C14.37 18.896 15.3393 18.1342 15.571 16.7376C16.8701 16.6326 17.6976 15.7892 17.9134 14.2901L18.9125 7.14019C19.0417 6.23936 18.8951 5.50254 18.4793 4.95004ZM3.88924 7.22767H12.7792C13.9142 7.22767 14.3776 7.69017 14.3776 8.82517V13.0586L11.525 10.206C10.99 9.67182 10.1217 9.67265 9.58921 10.206L6.11173 13.6836L5.59843 13.1692C5.06343 12.6342 4.1951 12.6359 3.6626 13.1692L2.29175 14.5401V8.82517C2.29175 7.69017 2.75507 7.22767 3.88924 7.22767ZM12.7792 17.646H3.88924C2.84257 17.646 2.37257 17.2451 2.30507 16.2934L4.54588 14.0526C4.59088 14.0085 4.66757 14.0076 4.71423 14.0526L5.41095 14.7492C5.79762 15.1367 6.42844 15.1351 6.81344 14.7492L10.4734 11.0894C10.5201 11.0444 10.5968 11.0452 10.6418 11.0894L14.3776 14.8251V16.0485C14.3776 17.1835 13.9142 17.646 12.7792 17.646ZM17.675 6.96603L16.6759 14.1151C16.5551 14.9534 16.2385 15.3759 15.6276 15.48V8.82517C15.6276 6.9885 14.6159 5.97767 12.7792 5.97767H5.61257L5.71012 5.29021C5.79012 4.72688 5.97091 4.33424 6.25008 4.12424C6.52675 3.91507 6.95257 3.8485 7.51341 3.92933L16.3151 5.16265C16.8784 5.24265 17.27 5.42346 17.48 5.70179C17.69 5.97929 17.755 6.40437 17.675 6.96603ZM4.59755 10.3543C4.59755 9.8943 4.96674 9.52097 5.4259 9.52097H5.43262C5.89178 9.52097 6.26422 9.8943 6.26422 10.3543C6.26422 10.8143 5.89178 11.1876 5.43262 11.1876C4.97428 11.1876 4.59755 10.8143 4.59755 10.3543Z"
        fill="#666F8D"
      />
    </svg>
  );
};
export const VideoUploadIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2499 5.9442C17.8116 5.7342 17.305 5.79163 16.9267 6.09496L14.7917 7.80333V7.43753C14.7917 5.42253 13.6817 4.31253 11.6667 4.31253H4.16669C2.15169 4.31253 1.04169 5.42253 1.04169 7.43753V14.1042C1.04169 16.1192 2.15169 17.2292 4.16669 17.2292H11.6667C13.6817 17.2292 14.7917 16.1192 14.7917 14.1042V13.7384L16.9275 15.4476C17.1542 15.6292 17.4284 15.7224 17.7059 15.7224C17.8901 15.7224 18.0749 15.6817 18.2499 15.5975C18.6858 15.3875 18.9584 14.955 18.9584 14.4708V7.07173C18.9584 6.58673 18.6866 6.15504 18.2499 5.9442ZM13.5417 14.1042C13.5417 15.4184 12.9809 15.9792 11.6667 15.9792H4.16669C2.85252 15.9792 2.29169 15.4184 2.29169 14.1042V7.43753C2.29169 6.12336 2.85252 5.56253 4.16669 5.56253H11.6667C12.9809 5.56253 13.5417 6.12336 13.5417 7.43753V14.1042ZM17.7084 14.4708L14.7917 12.1374V9.4051L17.7084 7.07173V14.4708Z"
        fill="#666F8D"
      />
    </svg>
  );
};
export const BrokenLinkIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50008 3.33317V1.6665M12.5001 16.6665V18.3332M3.33341 7.49984H1.66675M16.6667 12.4998H18.3334M4.09526 4.09502L2.91675 2.9165M15.9049 15.9047L17.0834 17.0832M10.0001 14.7139L8.23231 16.4816C6.93057 17.7834 4.82002 17.7834 3.51827 16.4816C2.21652 15.1799 2.21652 13.0694 3.51827 11.7676L5.28604 9.99984M14.7141 9.99984L16.4819 8.23207C17.7836 6.93032 17.7836 4.81977 16.4819 3.51803C15.1801 2.21628 13.0696 2.21628 11.7678 3.51803L10.0001 5.28579"
        stroke="#A9A29D"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SearchIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.5 23.5L19.2223 19.2222M22.2778 11.8889C22.2778 17.6265 17.6265 22.2778 11.8889 22.2778C6.15126 22.2778 1.5 17.6265 1.5 11.8889C1.5 6.15126 6.15126 1.5 11.8889 1.5C17.6265 1.5 22.2778 6.15126 22.2778 11.8889Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UpdateIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.4998 8.33333C17.4998 8.33333 15.829 6.05685 14.4716 4.69854C13.1143 3.34022 11.2385 2.5 9.1665 2.5C5.02437 2.5 1.6665 5.85786 1.6665 10C1.6665 14.1421 5.02437 17.5 9.1665 17.5C12.5857 17.5 15.4706 15.2119 16.3734 12.0833M12.4998 8.33333H17.4998V3.33333"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GoogleIcon1 = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_936_1058)">
        <path
          d="M23.7663 12.2763C23.7663 11.4605 23.7001 10.6404 23.559 9.83789H12.2402V14.4589H18.722C18.453 15.9492 17.5888 17.2676 16.3233 18.1054V21.1037H20.1903C22.4611 19.0137 23.7663 15.9272 23.7663 12.2763Z"
          fill="#4285F4"
        />
        <path
          d="M12.2401 24.0008C15.4766 24.0008 18.2059 22.9382 20.1945 21.1039L16.3276 18.1055C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3912C3.55371 21.4434 7.7029 24.0008 12.2401 24.0008Z"
          fill="#34A853"
        />
        <path
          d="M5.50277 14.3002C5.00011 12.8099 5.00011 11.196 5.50277 9.70569V6.61475H1.51674C-0.185266 10.0055 -0.185266 14.0004 1.51674 17.3912L5.50277 14.3002Z"
          fill="#FBBC04"
        />
        <path
          d="M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_936_1058">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AppleIcon1 = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="3.6 4.4 15.6 15.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
      className={className}
    >
      <path
        d="M16.06 12.75C16.04 10.51 17.89 9.43 17.97 9.38C16.92 7.84 15.29 7.63 14.73 7.61C13.36 7.47 12.03 8.42 11.34 8.42C10.63 8.42 9.56 7.62 8.41 7.65C6.93 7.67 5.55 8.53 4.79 9.87C3.21 12.6 4.39 16.61 5.91 18.82C6.67 19.9 7.55 21.1 8.7 21.06C9.83 21.01 10.25 20.34 11.6 20.34C12.94 20.34 13.33 21.06 14.51 21.03C15.72 21.01 16.48 19.95 17.21 18.86C18.08 17.62 18.43 16.39 18.44 16.33C18.41 16.32 16.08 15.43 16.06 12.75Z"
        fill="currentColor"
      />
      <path
        d="M13.84 6.16C14.45 5.42 14.87 4.41 14.75 3.39C13.87 3.43 12.76 4 12.13 4.72C11.57 5.36 11.07 6.41 11.21 7.38C12.2 7.45 13.2 6.89 13.84 6.16Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AhaCreatorGlyphIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="8.76 8.81 22.43 22.43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9756 9.11682C26.5346 9.11682 31.1881 13.3713 31.1881 20.0633V30.4337H25.7813L25.4267 27.3315C24.1858 29.5473 21.9256 30.9212 18.7348 30.9212C13.328 30.9212 8.76309 26.6666 8.76309 20.019C8.76312 13.8145 13.4609 9.11684 19.9756 9.11682ZM23.6607 20.019C25.3238 17.1304 22.0949 13.9014 19.2063 15.5646C16.3177 13.9014 13.0888 17.1304 14.7519 20.019C13.0887 22.9075 16.3177 26.1367 19.2063 24.4735C22.0949 26.1367 25.3239 22.9075 23.6607 20.019Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AhaCreatorBlackWhiteIcon = ({ className }: any) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2000_6306)">
        <rect width="40" height="40" rx="9.50732" fill="#5C0004" />
        <rect width="40" height="40" rx="9.50732" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9756 9.11682C26.5346 9.11682 31.1881 13.3713 31.1881 20.0633V30.4337H25.7813L25.4267 27.3315C24.1858 29.5473 21.9256 30.9212 18.7348 30.9212C13.328 30.9212 8.76309 26.6666 8.76309 20.019C8.76312 13.8145 13.4609 9.11684 19.9756 9.11682ZM23.6607 20.019C25.3238 17.1304 22.0949 13.9014 19.2063 15.5646C16.3177 13.9014 13.0888 17.1304 14.7519 20.019C13.0887 22.9075 16.3177 26.1367 19.2063 24.4735C22.0949 26.1367 25.3239 22.9075 23.6607 20.019Z"
          fill="white"
        />
        <rect
          x="-0.0281143"
          y="-0.00402832"
          width="40"
          height="40"
          rx="9.50769"
          fill="#5C0004"
        />
        <rect
          x="-0.0281143"
          y="-0.00402832"
          width="40"
          height="40"
          rx="9.50769"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9757 9.11682C26.5348 9.11682 31.1883 13.3714 31.1883 20.0635V30.434H25.7815L25.4269 27.3317C24.186 29.5476 21.9258 30.9215 18.7348 30.9215C13.328 30.9215 8.76305 26.6669 8.76305 20.0191C8.76308 13.8146 13.4609 9.11684 19.9757 9.11682ZM23.6608 20.0191C25.324 17.1305 22.095 13.9015 19.2064 15.5647C16.3178 13.9015 13.0888 17.1305 14.752 20.0191C13.0887 22.9077 16.3178 26.1369 19.2064 24.4737C22.095 26.1369 25.3241 22.9077 23.6608 20.0191Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_2000_6306">
          <rect width="40" height="40" rx="9.50732" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const RequiredIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 3.33325V16.6666M15 4.99992L5.00001 14.9999M16.6667 9.99992H3.33334M15 14.9999L5.00001 4.99992"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EmailLinkIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.66667 5.8335L8.47077 10.5964C9.02175 10.982 9.29724 11.1749 9.59689 11.2496C9.86158 11.3156 10.1384 11.3156 10.4031 11.2496C10.7028 11.1749 10.9783 10.982 11.5292 10.5964L18.3333 5.8335M5.66667 16.6668H14.3333C15.7335 16.6668 16.4335 16.6668 16.9683 16.3943C17.4387 16.1547 17.8212 15.7722 18.0609 15.3018C18.3333 14.767 18.3333 14.067 18.3333 12.6668V7.3335C18.3333 5.93336 18.3333 5.2333 18.0609 4.69852C17.8212 4.22811 17.4387 3.84566 16.9683 3.60598C16.4335 3.3335 15.7335 3.3335 14.3333 3.3335H5.66667C4.26654 3.3335 3.56647 3.3335 3.0317 3.60598C2.56129 3.84566 2.17884 4.22811 1.93916 4.69852C1.66667 5.2333 1.66667 5.93336 1.66667 7.3335V12.6668C1.66667 14.067 1.66667 14.767 1.93916 15.3018C2.17884 15.7722 2.56129 16.1547 3.0317 16.3943C3.56647 16.6668 4.26654 16.6668 5.66667 16.6668Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MessageDotsIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PhoneIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.98356 7.37779C7.56356 8.58581 8.35422 9.71801 9.35553 10.7193C10.3568 11.7206 11.4891 12.5113 12.6971 13.0913C12.801 13.1412 12.8529 13.1661 12.9187 13.1853C13.1523 13.2534 13.4392 13.2045 13.637 13.0628C13.6927 13.0229 13.7403 12.9753 13.8356 12.88C14.1269 12.5887 14.2726 12.443 14.4191 12.3478C14.9715 11.9886 15.6837 11.9886 16.2361 12.3478C16.3825 12.443 16.5282 12.5887 16.8196 12.88L16.9819 13.0424C17.4248 13.4853 17.6462 13.7067 17.7665 13.9446C18.0058 14.4175 18.0058 14.9761 17.7665 15.449C17.6462 15.6869 17.4248 15.9083 16.9819 16.3512L16.8506 16.4825C16.4092 16.9239 16.1886 17.1446 15.8885 17.3131C15.5556 17.5001 15.0385 17.6346 14.6567 17.6334C14.3126 17.6324 14.0774 17.5657 13.607 17.4322C11.0792 16.7147 8.69387 15.361 6.70388 13.371C4.7139 11.381 3.36017 8.99569 2.6427 6.46786C2.50919 5.99749 2.44244 5.7623 2.44141 5.41818C2.44028 5.03633 2.57475 4.51925 2.76176 4.18633C2.9303 3.88631 3.15098 3.66563 3.59233 3.22428L3.72369 3.09292C4.16656 2.65005 4.388 2.42861 4.62581 2.30833C5.09878 2.0691 5.65734 2.0691 6.1303 2.30832C6.36812 2.42861 6.58955 2.65005 7.03242 3.09291L7.19481 3.25531C7.48615 3.54665 7.63182 3.69231 7.72706 3.8388C8.08622 4.3912 8.08622 5.10336 7.72706 5.65576C7.63182 5.80225 7.48615 5.94791 7.19482 6.23925C7.09955 6.33451 7.05193 6.38214 7.01206 6.43782C6.87038 6.63568 6.82146 6.92256 6.88957 7.15619C6.90873 7.22193 6.93368 7.27389 6.98356 7.37779Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SmsIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.75583 2.53039C6.1535 2.86351 3.33302 5.89404 3.33302 9.58333C3.33302 10.375 3.46289 11.1363 3.70249 11.8472C3.79266 12.1147 3.83774 12.2484 3.84587 12.3512C3.8539 12.4527 3.84783 12.5238 3.82273 12.6225C3.79731 12.7224 3.74118 12.8262 3.62893 13.034L2.26588 15.557C2.07145 15.9168 1.97424 16.0968 1.996 16.2356C2.01495 16.3566 2.08614 16.4631 2.19066 16.5269C2.31066 16.6001 2.5141 16.579 2.92097 16.537L7.18849 16.0958C7.31767 16.0825 7.38235 16.0758 7.44123 16.0781C7.49916 16.0803 7.54005 16.0857 7.59654 16.0987C7.65398 16.112 7.7262 16.1398 7.87064 16.1954C8.66069 16.4998 9.51903 16.6667 10.4163 16.6667C14.1087 16.6667 17.1412 13.8415 17.4701 10.2349M16.7674 3.23223C17.7438 4.20854 17.7438 5.79146 16.7674 6.76777C15.7911 7.74408 14.2082 7.74408 13.2319 6.76777C12.2556 5.79146 12.2556 4.20854 13.2319 3.23223C14.2082 2.25592 15.7911 2.25592 16.7674 3.23223Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GreatJobIcon = ({ className }: any) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.4259 3.74888C13.5803 4.1224 13.8768 4.4193 14.25 4.5743L15.5589 5.11648C15.9325 5.27121 16.2292 5.568 16.384 5.94154C16.5387 6.31509 16.5387 6.73481 16.384 7.10836L15.8422 8.41635C15.6874 8.79007 15.6872 9.21021 15.8427 9.58374L16.3835 10.8913C16.4602 11.0764 16.4997 11.2747 16.4997 11.475C16.4998 11.6752 16.4603 11.8736 16.3837 12.0586C16.3071 12.2436 16.1947 12.4118 16.0531 12.5534C15.9114 12.695 15.7433 12.8073 15.5582 12.8839L14.2503 13.4256C13.8768 13.5801 13.5799 13.8765 13.4249 14.2498L12.8827 15.5588C12.728 15.9323 12.4312 16.2291 12.0577 16.3838C11.6841 16.5386 11.2644 16.5386 10.8909 16.3838L9.58296 15.842C9.20942 15.6877 8.78987 15.688 8.41656 15.8429L7.10767 16.3843C6.73434 16.5387 6.31501 16.5386 5.94178 16.384C5.56854 16.2293 5.27194 15.9329 5.11711 15.5598L4.57479 14.2504C4.42035 13.8769 4.12391 13.58 3.75064 13.425L2.44175 12.8828C2.06838 12.7282 1.77169 12.4316 1.61691 12.0582C1.46213 11.6849 1.46192 11.2654 1.61633 10.8919L2.1581 9.58391C2.31244 9.21035 2.31213 8.79079 2.15722 8.41746L1.61623 7.10759C1.53953 6.92257 1.50003 6.72426 1.5 6.52397C1.49997 6.32369 1.5394 6.12536 1.61604 5.94032C1.69268 5.75529 1.80504 5.58716 1.94668 5.44556C2.08832 5.30396 2.25647 5.19166 2.44152 5.11508L3.74947 4.57329C4.12265 4.41898 4.41936 4.1229 4.57448 3.75004L5.11664 2.44111C5.27136 2.06756 5.56813 1.77078 5.94167 1.61605C6.3152 1.46132 6.7349 1.46132 7.10844 1.61605L8.41638 2.15784C8.78993 2.31218 9.20948 2.31187 9.58279 2.15696L10.8922 1.61689C11.2657 1.46224 11.6853 1.46228 12.0588 1.61697C12.4322 1.77167 12.729 2.06837 12.8837 2.44182L13.426 3.75115L13.4259 3.74888Z"
        fill="#D9D9D9"
      />
      <path
        d="M6.75 9L8.25 10.5L11.625 7.125"
        stroke="#FAFAF9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PotentialEarningsIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22 10H2M11 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H17M11 19L13 21M11 19L13 17M7 19H5.2C4.07989 19 3.51984 19 3.09202 18.782C2.71569 18.5903 2.40973 18.2843 2.21799 17.908C2 17.4802 2 16.9201 2 15.8V8.2C2 7.0799 2 6.51984 2.21799 6.09202C2.40973 5.71569 2.7157 5.40973 3.09202 5.21799C3.51984 5 4.0799 5 5.2 5H13M13 5L11 7M13 5L11 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NoMediaLinkIcon = ({ className }: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.8258 21.4246L13.1759 23.0745C10.8978 25.3526 7.20438 25.3526 4.92632 23.0745C2.64826 20.7965 2.64826 17.103 4.92632 14.8249L6.57623 13.175M21.4255 14.8249L23.0754 13.175C25.3534 10.897 25.3534 7.20349 23.0754 4.92543C20.7973 2.64737 17.1039 2.64737 14.8258 4.92543L13.1759 6.57535M9.91752 18.0833L18.0842 9.91661"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BrandVerifiedIcon = ({ className }: any) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.75 8.62499L8.25 10.125L11.625 6.74999M15 8.99999C15 12.6813 10.9845 15.3588 9.52349 16.2112C9.35745 16.308 9.27443 16.3565 9.15726 16.3816C9.06633 16.4011 8.93367 16.4011 8.84274 16.3816C8.72557 16.3565 8.64255 16.308 8.47651 16.2112C7.01547 15.3588 3 12.6813 3 8.99999V5.4132C3 4.81356 3 4.51374 3.09807 4.25602C3.18471 4.02835 3.32549 3.8252 3.50824 3.66414C3.71512 3.48182 3.99585 3.37655 4.5573 3.16601L8.57865 1.658C8.73457 1.59953 8.81253 1.57029 8.89274 1.5587C8.96388 1.54842 9.03612 1.54842 9.10726 1.5587C9.18747 1.57029 9.26543 1.59953 9.42135 1.658L13.4427 3.16601C14.0042 3.37655 14.2849 3.48182 14.4918 3.66414C14.6745 3.8252 14.8153 4.02835 14.9019 4.25602C15 4.51374 15 4.81356 15 5.4132V8.99999Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftIcon = ({ className, onClick }: any) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3116"
    >
      <path
        d="M597.333333 714.666667a31.744 31.744 0 0 1-22.613333-9.386667l-170.666667-170.666667a32 32 0 0 1 0-45.269333l170.666667-170.666667a32 32 0 1 1 45.269333 45.269334L471.936 512l148.053333 148.053333A32 32 0 0 1 597.333333 714.666667z"
        p-id="3117"
      ></path>
    </svg>
  );
};

export const CopyedAltIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.375 6.25H9.625C7.448 6.25 6.25 7.448 6.25 9.625V18.375C6.25 20.552 7.448 21.75 9.625 21.75H18.375C20.552 21.75 21.75 20.552 21.75 18.375V9.625C21.75 7.448 20.552 6.25 18.375 6.25ZM20.25 18.375C20.25 19.707 19.707 20.25 18.375 20.25H9.625C8.293 20.25 7.75 19.707 7.75 18.375V9.625C7.75 8.293 8.293 7.75 9.625 7.75H18.375C19.707 7.75 20.25 8.293 20.25 9.625V18.375ZM3.75 5.62V14.38C3.75 15.578 4.23309 15.873 4.39209 15.971C4.74609 16.187 4.85589 16.649 4.63989 17.002C4.49789 17.233 4.25202 17.36 3.99902 17.36C3.86602 17.36 3.72991 17.324 3.60791 17.25C2.70691 16.698 2.25 15.733 2.25 14.38V5.62C2.25 3.478 3.47912 2.25 5.62012 2.25H14.3799C16.0649 2.25 16.87 2.98897 17.25 3.60797C17.466 3.96097 17.355 4.42298 17.002 4.63898C16.647 4.85598 16.1869 4.74399 15.9709 4.39099C15.8739 4.23199 15.5779 3.74902 14.3799 3.74902H5.62012C4.29212 3.75002 3.75 4.292 3.75 5.62ZM17.03 11.803C17.323 12.096 17.323 12.571 17.03 12.864L13.697 16.197C13.556 16.338 13.366 16.417 13.167 16.417C12.968 16.417 12.777 16.338 12.637 16.197L10.97 14.53C10.677 14.237 10.677 13.762 10.97 13.469C11.263 13.176 11.738 13.176 12.031 13.469L13.168 14.605L15.9709 11.802C16.2629 11.51 16.737 11.51 17.03 11.803Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CreditScoreIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9488 6.97299C20.2908 6.49899 19.4309 6.48301 18.7569 6.93301L16.4408 8.47699C16.3648 8.52799 16.2898 8.51799 16.2528 8.50699C16.2148 8.49699 16.1468 8.46701 16.1078 8.38501L13.7368 3.354C13.4158 2.673 12.7499 2.25 11.9969 2.25C11.9969 2.25 11.9968 2.25 11.9958 2.25C11.2428 2.25 10.5768 2.67401 10.2558 3.35501L7.89187 8.384C7.85287 8.467 7.78381 8.49599 7.74581 8.50699C7.70881 8.51799 7.63482 8.52799 7.55782 8.47699L5.24185 6.93301C4.56785 6.48401 3.70683 6.49999 3.04983 6.97299C2.39283 7.44699 2.10586 8.258 2.31686 9.03L4.13583 16.062C4.39183 17.055 5.28787 17.749 6.31387 17.749H17.6839C18.7099 17.749 19.6058 17.055 19.8618 16.062L21.6778 9.039C21.8928 8.259 21.6058 7.44699 20.9488 6.97299ZM20.2298 8.655L18.4109 15.688C18.3259 16.019 18.0268 16.25 17.6848 16.25H6.31484C5.97284 16.25 5.67383 16.019 5.58883 15.688L3.76785 8.646C3.69785 8.39 3.85686 8.24301 3.92886 8.19101C3.97286 8.15901 4.06386 8.10699 4.17886 8.10699C4.24886 8.10699 4.32783 8.12701 4.41183 8.18201L6.72787 9.72601C7.14687 10.006 7.66787 10.088 8.14987 9.953C8.63487 9.818 9.03582 9.47901 9.25082 9.02301L11.6148 3.99399C11.7178 3.77499 11.9168 3.75101 11.9978 3.75101C12.0788 3.75101 12.2778 3.77499 12.3808 3.99399L14.7519 9.02499C14.9659 9.47999 15.3668 9.818 15.8518 9.953C16.3368 10.087 16.8548 10.005 17.2738 9.72601L19.5899 8.18201C19.8109 8.03501 20.0008 8.13901 20.0728 8.19101C20.1428 8.24201 20.3018 8.39 20.2298 8.655ZM19.2498 20C19.2498 20.414 18.9138 20.75 18.4998 20.75H5.49984C5.08584 20.75 4.74984 20.414 4.74984 20C4.74984 19.586 5.08584 19.25 5.49984 19.25H18.4998C18.9138 19.25 19.2498 19.586 19.2498 20Z"
        fill="#292524"
      />
    </svg>
  );
};

export const ExitIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 14.1667V15C13.125 17.015 12.015 18.125 10 18.125H5C2.985 18.125 1.875 17.015 1.875 15V5C1.875 2.985 2.985 1.875 5 1.875H10C12.015 1.875 13.125 2.985 13.125 5V5.83333C13.125 6.17833 12.845 6.45833 12.5 6.45833C12.155 6.45833 11.875 6.17833 11.875 5.83333V5C11.875 3.68583 11.3142 3.125 10 3.125H5C3.68583 3.125 3.125 3.68583 3.125 5V15C3.125 16.3142 3.68583 16.875 5 16.875H10C11.3142 16.875 11.875 16.3142 11.875 15V14.1667C11.875 13.8217 12.155 13.5417 12.5 13.5417C12.845 13.5417 13.125 13.8217 13.125 14.1667ZM18.0767 10.2392C18.14 10.0867 18.14 9.91416 18.0767 9.76166C18.045 9.68499 17.9992 9.61583 17.9417 9.55833L15.4417 7.05833C15.1975 6.81417 14.8017 6.81417 14.5575 7.05833C14.3133 7.3025 14.3133 7.69834 14.5575 7.9425L15.9909 9.37584H6.66667C6.32167 9.37584 6.04167 9.65584 6.04167 10.0008C6.04167 10.3458 6.32167 10.6258 6.66667 10.6258H15.9909L14.5575 12.0592C14.3133 12.3033 14.3133 12.6992 14.5575 12.9433C14.6792 13.065 14.8392 13.1267 14.9992 13.1267C15.1592 13.1267 15.3192 13.0658 15.4408 12.9433L17.9408 10.4433C17.9992 10.3842 18.045 10.315 18.0767 10.2392Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HelpCenterIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5299 3.48499C17.5291 3.48499 17.5291 3.48501 17.5283 3.48418C16.1099 2.81168 14.5375 2.57583 12.8542 2.78166C11.6425 2.93083 10.6175 3.62329 10 4.59329C9.38167 3.62412 8.35746 2.93083 7.14579 2.78166C5.45996 2.57583 3.88922 2.81168 2.47172 3.48418C2.47172 3.48418 2.47174 3.48418 2.47091 3.48418C2.10924 3.65584 1.875 4.02827 1.875 4.43327V15.2708C1.875 15.5991 2.02493 15.9 2.28577 16.0975C2.54577 16.295 2.89258 16.3574 3.20841 16.2691C5.63175 15.5808 7.68084 15.8725 9.65251 17.1867C9.66084 17.1925 9.67083 17.1942 9.67916 17.1992C9.68833 17.2042 9.695 17.2125 9.705 17.2175C9.71416 17.2225 9.72492 17.22 9.73409 17.225C9.81826 17.265 9.90752 17.2917 9.99919 17.2917C10.0909 17.2917 10.1799 17.265 10.2641 17.225C10.2732 17.2209 10.2842 17.2225 10.2934 17.2175C10.3025 17.2125 10.3101 17.205 10.3184 17.1992C10.3267 17.1942 10.3367 17.1925 10.3451 17.1867C12.3167 15.8717 14.365 15.58 16.7891 16.2683C17.1058 16.3583 17.4508 16.295 17.7116 16.0975C17.9724 15.9008 18.1226 15.5991 18.1226 15.2708V4.43327C18.1251 4.02994 17.8916 3.65749 17.5299 3.48499ZM5.61076 14.6608C4.80993 14.6608 3.9825 14.7733 3.125 14.9958V4.55829C4.30833 4.02246 5.57757 3.84669 6.99341 4.02169C8.35174 4.18836 9.375 5.34664 9.375 6.71497V15.5741C8.17917 14.965 6.93076 14.6608 5.61076 14.6608ZM16.875 14.9966C14.6017 14.4058 12.5467 14.595 10.625 15.5759V6.7167C10.625 5.34753 11.6491 4.18999 13.0066 4.02332C13.3583 3.97999 13.7009 3.95832 14.035 3.95832C15.0475 3.95832 15.985 4.15752 16.8742 4.56002V14.9966H16.875ZM12.5 6.87498H15C15.345 6.87498 15.625 7.15498 15.625 7.49998C15.625 7.84498 15.345 8.12498 15 8.12498H12.5C12.155 8.12498 11.875 7.84498 11.875 7.49998C11.875 7.15498 12.155 6.87498 12.5 6.87498ZM14.7917 9.99998C14.7917 10.345 14.5117 10.625 14.1667 10.625H12.5C12.155 10.625 11.875 10.345 11.875 9.99998C11.875 9.65498 12.155 9.37498 12.5 9.37498H14.1667C14.5117 9.37498 14.7917 9.65498 14.7917 9.99998Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SettingsIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4789_3042)">
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 9.99996C12.5 8.61925 11.3807 7.49996 10 7.49996C8.61931 7.49996 7.50002 8.61925 7.50002 9.99996C7.50002 11.3807 8.61931 12.5 10 12.5Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6061 12.2727C15.5052 12.5012 15.4752 12.7547 15.5197 13.0004C15.5643 13.2462 15.6814 13.4729 15.8561 13.6515L15.9015 13.6969C16.0424 13.8376 16.1542 14.0048 16.2304 14.1887C16.3067 14.3726 16.3459 14.5698 16.3459 14.7689C16.3459 14.968 16.3067 15.1652 16.2304 15.3491C16.1542 15.533 16.0424 15.7002 15.9015 15.8409C15.7608 15.9817 15.5937 16.0935 15.4098 16.1697C15.2258 16.246 15.0287 16.2852 14.8296 16.2852C14.6305 16.2852 14.4333 16.246 14.2494 16.1697C14.0654 16.0935 13.8983 15.9817 13.7576 15.8409L13.7121 15.7954C13.5336 15.6208 13.3068 15.5036 13.0611 15.459C12.8153 15.4145 12.5619 15.4446 12.3334 15.5454C12.1093 15.6414 11.9182 15.8009 11.7836 16.0042C11.649 16.2074 11.5768 16.4456 11.5758 16.6894V16.8181C11.5758 17.22 11.4161 17.6054 11.132 17.8895C10.8479 18.1737 10.4625 18.3333 10.0606 18.3333C9.65878 18.3333 9.2734 18.1737 8.98925 17.8895C8.70511 17.6054 8.54547 17.22 8.54547 16.8181V16.75C8.53961 16.4992 8.45844 16.256 8.31253 16.052C8.16661 15.848 7.9627 15.6926 7.72729 15.606C7.4988 15.5052 7.24533 15.4751 6.99957 15.5197C6.75382 15.5642 6.52705 15.6814 6.3485 15.856L6.30305 15.9015C6.16233 16.0423 5.99523 16.1541 5.81129 16.2304C5.62736 16.3066 5.4302 16.3458 5.23108 16.3458C5.03197 16.3458 4.8348 16.3066 4.65087 16.2304C4.46693 16.1541 4.29983 16.0423 4.15911 15.9015C4.01824 15.7608 3.90648 15.5937 3.83023 15.4097C3.75398 15.2258 3.71474 15.0286 3.71474 14.8295C3.71474 14.6304 3.75398 14.4332 3.83023 14.2493C3.90648 14.0654 4.01824 13.8983 4.15911 13.7575L4.20457 13.7121C4.37921 13.5335 4.49637 13.3068 4.54093 13.061C4.58549 12.8153 4.55541 12.5618 4.45457 12.3333C4.35853 12.1092 4.19908 11.9181 3.99583 11.7835C3.79258 11.6489 3.5544 11.5767 3.31063 11.5757H3.18184C2.78 11.5757 2.39461 11.4161 2.11046 11.1319C1.82632 10.8478 1.66669 10.4624 1.66669 10.0606C1.66669 9.65872 1.82632 9.27334 2.11046 8.98919C2.39461 8.70505 2.78 8.54541 3.18184 8.54541H3.25002C3.50077 8.53955 3.74396 8.45838 3.94797 8.31247C4.15199 8.16655 4.30738 7.96264 4.39396 7.72723C4.4948 7.49874 4.52489 7.24527 4.48033 6.99951C4.43577 6.75376 4.31861 6.52699 4.14396 6.34844L4.09851 6.30299C3.95763 6.16227 3.84588 5.99517 3.76963 5.81123C3.69338 5.6273 3.65413 5.43013 3.65413 5.23102C3.65413 5.03191 3.69338 4.83474 3.76963 4.65081C3.84588 4.46687 3.95763 4.29977 4.09851 4.15905C4.23922 4.01818 4.40633 3.90642 4.59026 3.83017C4.7742 3.75392 4.97136 3.71468 5.17047 3.71468C5.36959 3.71468 5.56675 3.75392 5.75069 3.83017C5.93462 3.90642 6.10173 4.01818 6.24244 4.15905L6.2879 4.2045C6.46644 4.37915 6.69321 4.49631 6.93897 4.54087C7.18472 4.58543 7.43819 4.55535 7.66669 4.4545H7.72729C7.95136 4.35847 8.14246 4.19902 8.27706 3.99577C8.41166 3.79252 8.4839 3.55434 8.48487 3.31057V3.18178C8.48487 2.77993 8.6445 2.39455 8.92865 2.1104C9.21279 1.82626 9.59818 1.66663 10 1.66663C10.4019 1.66663 10.7872 1.82626 11.0714 2.1104C11.3555 2.39455 11.5152 2.77993 11.5152 3.18178V3.24996C11.5161 3.49374 11.5884 3.73191 11.723 3.93516C11.8576 4.13841 12.0487 4.29787 12.2727 4.3939C12.5012 4.49474 12.7547 4.52483 13.0005 4.48027C13.2462 4.43571 13.473 4.31855 13.6515 4.1439L13.697 4.09844C13.8377 3.95757 14.0048 3.84581 14.1887 3.76957C14.3727 3.69332 14.5698 3.65407 14.769 3.65407C14.9681 3.65407 15.1652 3.69332 15.3492 3.76957C15.5331 3.84581 15.7002 3.95757 15.8409 4.09844C15.9818 4.23916 16.0936 4.40626 16.1698 4.5902C16.2461 4.77414 16.2853 4.9713 16.2853 5.17041C16.2853 5.36953 16.2461 5.56669 16.1698 5.75063C16.0936 5.93456 15.9818 6.10167 15.8409 6.24238L15.7955 6.28784C15.6208 6.46638 15.5037 6.69315 15.4591 6.93891C15.4145 7.18466 15.4446 7.43813 15.5455 7.66663V7.72723C15.6415 7.9513 15.801 8.1424 16.0042 8.277C16.2075 8.4116 16.4456 8.48384 16.6894 8.48481H16.8182C17.22 8.48481 17.6054 8.64444 17.8896 8.92859C18.1737 9.21273 18.3334 9.59812 18.3334 9.99996C18.3334 10.4018 18.1737 10.7872 17.8896 11.0713C17.6054 11.3555 17.22 11.5151 16.8182 11.5151H16.75C16.5062 11.5161 16.2681 11.5883 16.0648 11.7229C15.8616 11.8575 15.7021 12.0486 15.6061 12.2727Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4789_3042">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SupportIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4789_3034)">
        <path
          d="M7.61357 7.61353L4.10746 4.10742M4.10746 15.8925L7.63999 12.36M12.3842 12.3864L15.8904 15.8925M15.8904 4.10742L12.3573 7.64047M18.3334 9.99996C18.3334 14.6023 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6023 1.66669 9.99996C1.66669 5.39759 5.39765 1.66663 10 1.66663C14.6024 1.66663 18.3334 5.39759 18.3334 9.99996ZM13.3334 9.99996C13.3334 11.8409 11.841 13.3333 10 13.3333C8.15907 13.3333 6.66669 11.8409 6.66669 9.99996C6.66669 8.15901 8.15907 6.66663 10 6.66663C11.841 6.66663 13.3334 8.15901 13.3334 9.99996Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4789_3034">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DashboardIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.66667 12.5V14.1667M10 9.16667V14.1667M13.3333 5.83333V14.1667M6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CollaborationsIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4789_3023)">
        <path
          d="M5.83335 7.91664L1.66669 9.99997L9.70188 14.0176C9.8112 14.0722 9.86586 14.0996 9.92319 14.1103C9.97397 14.1198 10.0261 14.1198 10.0769 14.1103C10.1342 14.0996 10.1888 14.0722 10.2982 14.0176L18.3334 9.99997L14.1667 7.91664M5.83335 12.0833L1.66669 14.1666L9.70188 18.1842C9.8112 18.2389 9.86586 18.2662 9.92319 18.277C9.97397 18.2865 10.0261 18.2865 10.0769 18.277C10.1342 18.2662 10.1888 18.2389 10.2982 18.1842L18.3334 14.1666L14.1667 12.0833M1.66669 5.83331L9.70188 1.81571C9.8112 1.76105 9.86586 1.73372 9.92319 1.72297C9.97397 1.71344 10.0261 1.71344 10.0769 1.72297C10.1342 1.73372 10.1888 1.76105 10.2982 1.81571L18.3334 5.83331L10.2982 9.8509C10.1888 9.90556 10.1342 9.93289 10.0769 9.94365C10.0261 9.95317 9.97397 9.95317 9.92319 9.94365C9.86586 9.93289 9.8112 9.90556 9.70188 9.8509L1.66669 5.83331Z"
          stroke="currentColor"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4789_3023">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WalletIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 6.66677V3.75065C13.3333 3.05753 13.3333 2.71097 13.1873 2.498C13.0598 2.31192 12.8622 2.18551 12.6398 2.14767C12.3852 2.10435 12.0706 2.24958 11.4413 2.54003L4.04918 5.95176C3.48792 6.2108 3.20729 6.34032 3.00175 6.5412C2.82005 6.71878 2.68135 6.93556 2.59625 7.17496C2.5 7.44576 2.5 7.75483 2.5 8.37299V12.5001M13.75 12.0834H13.7583M2.5 9.33343L2.5 14.8334C2.5 15.7669 2.5 16.2336 2.68166 16.5901C2.84144 16.9037 3.09641 17.1587 3.41002 17.3184C3.76654 17.5001 4.23325 17.5001 5.16667 17.5001H14.8333C15.7668 17.5001 16.2335 17.5001 16.59 17.3184C16.9036 17.1587 17.1586 16.9037 17.3183 16.5901C17.5 16.2336 17.5 15.7669 17.5 14.8334V9.33343C17.5 8.40001 17.5 7.9333 17.3183 7.57678C17.1586 7.26318 16.9036 7.00821 16.59 6.84842C16.2335 6.66677 15.7668 6.66677 14.8333 6.66677L5.16667 6.66677C4.23325 6.66677 3.76654 6.66677 3.41002 6.84842C3.09641 7.00821 2.84144 7.26318 2.68166 7.57678C2.5 7.9333 2.5 8.40001 2.5 9.33343ZM14.1667 12.0834C14.1667 12.3136 13.9801 12.5001 13.75 12.5001C13.5199 12.5001 13.3333 12.3136 13.3333 12.0834C13.3333 11.8533 13.5199 11.6668 13.75 11.6668C13.9801 11.6668 14.1667 11.8533 14.1667 12.0834Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CollapseIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.5 2.5V17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3 12H15M3 6H21M3 18H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReceiptStarIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59937 1.05234L8.69336 1.73166C8.29536 2.03033 7.73799 1.99034 7.38599 1.63901L6.04004 0.293C5.64937 -0.0976667 5.01598 -0.0976667 4.62598 0.293L3.28003 1.63901C2.92803 1.99101 2.37066 2.03033 1.97266 1.73166L1.06665 1.05234C0.627317 0.723005 0 1.03633 0 1.58566V10.4143C0 10.9637 0.627317 11.277 1.06665 10.9477L1.97266 10.2683C2.37066 9.96967 2.92803 10.0097 3.28003 10.361L4.62598 11.707C5.01664 12.0977 5.65004 12.0977 6.04004 11.707L7.38599 10.361C7.73799 10.009 8.29536 9.96967 8.69336 10.2683L9.59937 10.9477C10.0387 11.277 10.666 10.9637 10.666 10.4143V1.58566C10.666 1.03633 10.0387 0.722338 9.59937 1.05234ZM8.06999 5.65834L7.05005 6.64499C6.97538 6.71699 6.94131 6.821 6.95931 6.923L7.19271 8.273C7.24004 8.547 6.95137 8.75567 6.70337 8.627L5.47933 7.98833C5.38733 7.94033 5.27804 7.94033 5.18604 7.98833L3.96265 8.62633C3.71465 8.75567 3.42532 8.54633 3.47266 8.27233L3.70605 6.923C3.72339 6.821 3.68932 6.71699 3.61532 6.64499L2.59538 5.65834C2.40804 5.477 2.51135 5.16033 2.77002 5.12367L4.18132 4.92034C4.28398 4.90567 4.3727 4.84166 4.4187 4.74899L5.03003 3.52034C5.15403 3.271 5.51199 3.271 5.63599 3.52034L6.24731 4.74899C6.29331 4.84166 6.38203 4.90567 6.4847 4.92034L7.896 5.12367C8.15466 5.161 8.25732 5.477 8.06999 5.65834Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const JoinDrawEmaiIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="12" fill="#F9F9FB" />
      <path
        d="M30 32.75H18C15.582 32.75 14.25 31.418 14.25 29V20C14.25 17.582 15.582 16.25 18 16.25H30C32.418 16.25 33.75 17.582 33.75 20V29C33.75 31.418 32.418 32.75 30 32.75ZM18 17.75C16.423 17.75 15.75 18.423 15.75 20V29C15.75 30.577 16.423 31.25 18 31.25H30C31.577 31.25 32.25 30.577 32.25 29V20C32.25 18.423 31.577 17.75 30 17.75H18ZM25.0291 25.179L29.9409 21.607C30.2759 21.364 30.35 20.894 30.106 20.559C29.863 20.225 29.3951 20.149 29.0581 20.394L24.146 23.966C24.058 24.03 23.941 24.03 23.853 23.966L18.9409 20.394C18.6029 20.149 18.1361 20.226 17.8931 20.559C17.6491 20.894 17.7231 21.363 18.0581 21.607L22.97 25.18C23.278 25.404 23.639 25.515 23.999 25.515C24.359 25.515 24.7221 25.403 25.0291 25.179Z"
        fill="#1C2024"
      />
    </svg>
  );
};

export const JoinDrawClockIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="12" fill="#F9F9FB" />
      <path
        d="M33.5362 17.5253C33.3892 17.6753 33.1943 17.7503 33.0003 17.7503C32.8113 17.7503 32.6214 17.6793 32.4754 17.5363L30.4754 15.5763C30.1804 15.2863 30.1754 14.8113 30.4644 14.5153C30.7554 14.2193 31.2291 14.2143 31.5261 14.5043L33.5261 16.4643C33.8201 16.7543 33.8252 17.2293 33.5362 17.5253ZM17.5303 15.5303C17.8233 15.2373 17.8233 14.7623 17.5303 14.4693C17.2373 14.1763 16.7623 14.1763 16.4693 14.4693L14.4693 16.4693C14.1763 16.7623 14.1763 17.2373 14.4693 17.5303C14.6153 17.6763 14.8073 17.7503 14.9993 17.7503C15.1913 17.7503 15.3833 17.6773 15.5293 17.5303L17.5303 15.5303ZM29.1363 31.0694L30.5313 32.4712C30.8243 32.7652 30.8223 33.2402 30.5293 33.5322C30.3833 33.6782 30.1913 33.7503 30.0003 33.7503C29.8083 33.7503 29.6153 33.6763 29.4693 33.5293L27.8123 31.8643C26.6583 32.4263 25.3683 32.7503 24.0003 32.7503C22.6323 32.7503 21.3433 32.4263 20.1883 31.8643L18.5313 33.5293C18.3853 33.6763 18.1923 33.7503 18.0003 33.7503C17.8093 33.7503 17.6172 33.6772 17.4712 33.5322C17.1782 33.2402 17.1763 32.7652 17.4693 32.4712L18.8643 31.0694C16.6793 29.4774 15.2503 26.9053 15.2503 24.0003C15.2503 19.1753 19.1753 15.2503 24.0003 15.2503C28.8253 15.2503 32.7503 19.1753 32.7503 24.0003C32.7503 26.9053 31.3213 29.4774 29.1363 31.0694ZM24.0003 31.2503C27.9983 31.2503 31.2503 27.9983 31.2503 24.0003C31.2503 20.0023 27.9983 16.7503 24.0003 16.7503C20.0023 16.7503 16.7503 20.0023 16.7503 24.0003C16.7503 27.9983 20.0023 31.2503 24.0003 31.2503ZM24.7503 23.7293V20.0403C24.7503 19.6263 24.4143 19.2903 24.0003 19.2903C23.5863 19.2903 23.2503 19.6263 23.2503 20.0403V24.0403C23.2503 24.2393 23.3292 24.4303 23.4702 24.5703L25.4702 26.5703C25.6162 26.7163 25.8083 26.7903 26.0003 26.7903C26.1923 26.7903 26.3843 26.7173 26.5303 26.5703C26.8233 26.2773 26.8233 25.8023 26.5303 25.5093L24.7503 23.7293Z"
        fill="#1C2024"
      />
    </svg>
  );
};

export const JoinDrawFrontPaymentIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="12" fill="#F9F9FB" />
      <path
        d="M32.692 26.543C32.03 26.168 31.246 26.1779 30.592 26.5699L28.622 27.752C28.313 26.878 27.478 26.25 26.5 26.25H21C20.359 26.25 19.776 26.48 19.308 26.849C18.987 26.485 18.523 26.25 18 26.25H16C15.035 26.25 14.25 27.035 14.25 28V32C14.25 32.965 15.035 33.75 16 33.75H18C18.522 33.75 18.987 33.515 19.308 33.151C19.776 33.52 20.359 33.75 21 33.75H26.597C27.671 33.75 28.725 33.38 29.565 32.709L32.968 29.986C33.465 29.588 33.75 28.994 33.75 28.358C33.75 27.597 33.354 26.918 32.692 26.543ZM18.25 32C18.25 32.138 18.138 32.25 18 32.25H16C15.862 32.25 15.75 32.138 15.75 32V28C15.75 27.862 15.862 27.75 16 27.75H18C18.138 27.75 18.25 27.862 18.25 28V29V31V32ZM32.03 28.8149L28.627 31.537C28.053 31.996 27.332 32.249 26.596 32.249H21C20.311 32.249 19.75 31.688 19.75 30.999V28.999C19.75 28.31 20.311 27.749 21 27.749H26.5C26.914 27.749 27.25 28.085 27.25 28.499C27.25 28.913 26.914 29.249 26.5 29.249H23C22.586 29.249 22.25 29.585 22.25 29.999C22.25 30.413 22.586 30.749 23 30.749H26.5C27.343 30.749 28.08 30.283 28.465 29.595L31.364 27.856C31.626 27.697 31.864 27.798 31.953 27.848C32.042 27.899 32.25 28.05 32.25 28.358C32.25 28.537 32.17 28.7039 32.03 28.8149ZM21.763 19.181C21.434 18.764 21.25 18.2311 21.25 17.6851C21.25 16.4981 22.104 15.51 23.23 15.296V15C23.23 14.586 23.566 14.25 23.98 14.25C24.394 14.25 24.73 14.586 24.73 15V15.2889C25.78 15.4699 26.612 16.322 26.735 17.416C26.781 17.828 26.485 18.199 26.074 18.245C25.671 18.295 25.291 17.996 25.245 17.584C25.191 17.108 24.791 16.75 24.315 16.75H23.685C23.169 16.75 22.75 17.1691 22.75 17.6851C22.75 17.8941 22.819 18.097 22.944 18.255C23.076 18.425 23.253 18.54 23.459 18.592L24.906 18.951C25.993 19.226 26.75 20.198 26.75 21.314C26.75 21.963 26.496 22.574 26.035 23.035C25.675 23.395 25.221 23.624 24.73 23.709V24C24.73 24.414 24.394 24.75 23.98 24.75C23.566 24.75 23.23 24.414 23.23 24V23.708C22.198 23.513 21.386 22.665 21.265 21.584C21.219 21.172 21.515 20.801 21.926 20.755C22.328 20.706 22.709 21.004 22.755 21.416C22.809 21.892 23.209 22.25 23.685 22.25H24.315C24.563 22.25 24.797 22.152 24.974 21.975C25.152 21.797 25.25 21.5629 25.25 21.3149C25.25 20.8859 24.958 20.513 24.541 20.407L23.094 20.048C22.566 19.914 22.094 19.606 21.763 19.181Z"
        fill="#1C2024"
      />
    </svg>
  );
};

export const ScriptIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 3H7C5 3 4 4 4 6V18C4 20 5 21 7 21H17C19 21 20 20 20 18V6C20 4 19 3 17 3ZM13 16.75H8C7.586 16.75 7.25 16.414 7.25 16C7.25 15.586 7.586 15.25 8 15.25H13C13.414 15.25 13.75 15.586 13.75 16C13.75 16.414 13.414 16.75 13 16.75ZM16 12.75H8C7.586 12.75 7.25 12.414 7.25 12C7.25 11.586 7.586 11.25 8 11.25H16C16.414 11.25 16.75 11.586 16.75 12C16.75 12.414 16.414 12.75 16 12.75ZM16 8.75H8C7.586 8.75 7.25 8.414 7.25 8C7.25 7.586 7.586 7.25 8 7.25H16C16.414 7.25 16.75 7.586 16.75 8C16.75 8.414 16.414 8.75 16 8.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DedicatedVideoFilledIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 7.94995V3.30005C9.75 3.13405 9.88405 3 10.05 3H13.95C14.116 3 14.25 3.13405 14.25 3.30005V7.94995C14.25 8.11595 14.116 8.25 13.95 8.25H10.05C9.88405 8.25 9.75 8.11595 9.75 7.94995ZM21 10.05V17.625C21 19.875 19.875 21 17.625 21H6.375C4.125 21 3 19.875 3 17.625V10.05C3 9.88405 3.13405 9.75 3.30005 9.75H20.7C20.866 9.75 21 9.88405 21 10.05ZM14.5811 13.7539L11.432 11.8269C10.805 11.4439 9.99902 11.893 9.99902 12.626V16.373C9.99902 17.106 10.805 17.5561 11.432 17.1721L14.5811 15.2451C15.1401 14.9041 15.1401 14.0959 14.5811 13.7539ZM3.30005 8.25H7.94995C8.11595 8.25 8.25 8.11595 8.25 7.94995V3.30005C8.25 3.13405 8.11595 3 7.94995 3H6.375C4.125 3 3 4.125 3 6.375V7.94995C3 8.11595 3.13405 8.25 3.30005 8.25ZM17.625 3H16.05C15.884 3 15.75 3.13405 15.75 3.30005V7.94995C15.75 8.11595 15.884 8.25 16.05 8.25H20.7C20.866 8.25 21 8.11595 21 7.94995V6.375C21 4.125 19.875 3 17.625 3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BoltIcon = ({ className }: any) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3201 7.85504C15.1226 7.3792 14.6801 7.08337 14.1651 7.08337L11.7842 7.14171L13.2143 3.82837C13.3818 3.44087 13.3426 2.99837 13.1109 2.6467C12.8792 2.2942 12.4884 2.08337 12.0667 2.08337H8.33342C7.63509 2.08337 7.05593 2.52004 6.82926 3.20254L4.64843 8.77087C4.51926 9.1567 4.58175 9.56671 4.82009 9.89671C5.05842 10.2267 5.4276 10.4167 5.8351 10.4167L8.18841 10.3617L5.78424 17.365C5.72174 17.5484 5.79341 17.7509 5.95758 17.8534C6.02591 17.8959 6.10176 17.9167 6.17842 17.9167C6.28592 17.9167 6.39259 17.875 6.47343 17.795L15.0501 9.21754C15.4134 8.85338 15.5167 8.33087 15.3201 7.85504Z"
        fill="#FB6011"
      />
    </svg>
  );
};

export const ProductHonor = ({ className, style }: any) => {
  return (
    <svg
      style={style}
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 3.54167H14.9791C14.8791 2.95083 14.3692 2.5 13.75 2.5H6.25C5.63083 2.5 5.12085 2.95083 5.02085 3.54167H3.33333C2.52917 3.54167 1.875 4.19583 1.875 5V6.37502C1.875 8.73169 3.87248 9.79167 5.29165 9.79167H5.56C6.3 11.2225 7.70998 12.2483 9.37581 12.4567V15.0475C8.12748 15.2417 7.50081 16.0575 7.50081 17.4992H12.5008C12.5008 16.0567 11.8741 15.2417 10.6258 15.0475V12.4567C12.2916 12.2483 13.7008 11.2225 14.4416 9.79167H14.71C16.1283 9.79167 18.1266 8.73169 18.1266 6.37502V5C18.125 4.19583 17.4708 3.54167 16.6667 3.54167ZM3.125 6.37502V5C3.125 4.885 3.21833 4.79167 3.33333 4.79167H5V7.5C5 7.85167 5.03746 8.19418 5.10579 8.52585C4.35829 8.44585 3.125 7.88419 3.125 6.37502ZM12.4159 6.78167L11.5158 7.65498C11.45 7.71914 11.42 7.81085 11.4359 7.90085L11.6416 9.09668C11.6833 9.33918 11.4284 9.52416 11.21 9.40999L10.13 8.84501C10.0492 8.80251 9.95246 8.80251 9.87162 8.84501L8.79252 9.40999C8.57419 9.52416 8.31832 9.33915 8.35999 9.09581L8.56588 7.90166C8.58171 7.81166 8.55165 7.71918 8.48582 7.65584L7.58586 6.78248C7.42086 6.62165 7.51164 6.34165 7.73997 6.30915L8.98499 6.12915C9.07582 6.11582 9.15413 6.05914 9.19413 5.97748L9.73338 4.88917C9.84254 4.66834 10.1584 4.66834 10.2675 4.88917L10.8067 5.97748C10.8475 6.05914 10.9258 6.11582 11.0158 6.12915L12.2608 6.30915C12.49 6.34082 12.5809 6.62083 12.4159 6.78167ZM16.875 6.37502C16.875 7.88419 15.6417 8.44585 14.8942 8.52585C14.9634 8.19501 15 7.85167 15 7.5V4.79167H16.6667C16.7817 4.79167 16.875 4.885 16.875 5V6.37502Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ProductTwoHonor = ({ className, style }: any) => {
  return (
    <svg
      style={style}
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4702_33817)">
        <path
          d="M9.99999 12.5C7.23857 12.5 4.99999 10.2614 4.99999 7.49999V2.87036C4.99999 2.52549 4.99999 2.35305 5.05025 2.21497C5.13449 1.9835 5.31683 1.80116 5.54831 1.71691C5.68638 1.66666 5.85882 1.66666 6.20369 1.66666H13.7963C14.1412 1.66666 14.3136 1.66666 14.4517 1.71691C14.6831 1.80116 14.8655 1.9835 14.9497 2.21497C15 2.35305 15 2.52549 15 2.87036V7.49999C15 10.2614 12.7614 12.5 9.99999 12.5ZM9.99999 12.5V15M15 3.33332H17.0833C17.4716 3.33332 17.6657 3.33332 17.8189 3.39676C18.0231 3.48134 18.1853 3.64356 18.2699 3.84775C18.3333 4.0009 18.3333 4.19504 18.3333 4.58332V4.99999C18.3333 5.77497 18.3333 6.16245 18.2481 6.48037C18.017 7.3431 17.3431 8.01697 16.4804 8.24814C16.1625 8.33332 15.775 8.33332 15 8.33332M4.99999 3.33332H2.91666C2.52837 3.33332 2.33423 3.33332 2.18109 3.39676C1.9769 3.48134 1.81467 3.64356 1.73009 3.84775C1.66666 4.0009 1.66666 4.19504 1.66666 4.58332V4.99999C1.66666 5.77497 1.66666 6.16245 1.75184 6.48037C1.98301 7.3431 2.65688 8.01697 3.51961 8.24814C3.83753 8.33332 4.22501 8.33332 4.99999 8.33332M6.20369 18.3333H13.7963C14.0008 18.3333 14.1667 18.1675 14.1667 17.963C14.1667 16.3266 12.8401 15 11.2037 15H8.79629C7.15989 15 5.83332 16.3266 5.83332 17.963C5.83332 18.1675 5.99914 18.3333 6.20369 18.3333Z"
          stroke="#FB6011"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4702_33817">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const GooglePlayIcon = ({ className, style }: any) => {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2199_821"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="1"
        width="16"
        height="18"
      >
        <path
          d="M18.7802 9.00026C19.5733 9.43664 19.5733 10.5634 18.7802 10.9997L6.09767 17.9787C5.32532 18.4037 4.375 17.8521 4.375 16.9789L4.375 3.02109C4.375 2.14786 5.32532 1.59634 6.09767 2.02134L18.7802 9.00026Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_2199_821)">
        <path
          d="M4.7717 17.8415L12.6827 9.88607L4.90199 2.06165C4.59158 2.26064 4.375 2.60419 4.375 3.02106V16.9789C4.375 17.3346 4.53265 17.6368 4.7717 17.8415Z"
          fill="url(#paint0_linear_2199_821)"
        />
        <path
          d="M18.7802 9.00029C19.5732 9.43667 19.5732 10.5634 18.7802 10.9998L15.5807 12.7604L12.6827 9.88607L15.4329 7.15833L18.7802 9.00029Z"
          fill="url(#paint1_linear_2199_821)"
        />
        <path
          d="M15.5807 12.7604L12.6827 9.88605L4.77167 17.8415C5.11956 18.1394 5.63987 18.2306 6.09766 17.9787L15.5807 12.7604Z"
          fill="url(#paint2_linear_2199_821)"
        />
        <path
          d="M4.90201 2.06166L12.6827 9.88607L15.4329 7.1583L6.09767 2.02134C5.69404 1.79924 5.24181 1.84383 4.90201 2.06166Z"
          fill="url(#paint3_linear_2199_821)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2199_821"
          x1="9.79808"
          y1="6.79611"
          x2="4.41941"
          y2="12.219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00C3FF" />
          <stop offset="1" stop-color="#1BE2FA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2199_821"
          x1="12.6827"
          y1="9.88609"
          x2="19.8366"
          y2="9.88609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFCE00" />
          <stop offset="1" stop-color="#FFEA00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2199_821"
          x1="4.60577"
          y1="18.8126"
          x2="14.1218"
          y2="11.1834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DE2453" />
          <stop offset="1" stop-color="#FE3944" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2199_821"
          x1="5.06731"
          y1="1.18836"
          x2="14.1234"
          y2="8.58529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#11D574" />
          <stop offset="1" stop-color="#01F176" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const AiReviewLoadingIcon = ({ className, style }: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24586 0.744633C7.29788 0.0652691 8.57362 -0.16127 9.79078 0.11475C11.393 0.466942 12.7933 1.71777 13.2263 3.33448C13.3291 3.71838 13.4031 4.33015 13.3181 4.72022C13.5017 4.79472 13.596 4.81331 13.7634 4.93116L13.8494 4.97998C14.0046 5.0534 14.1395 5.11651 14.2556 5.25049L14.3464 5.31592C14.3837 5.33665 14.4169 5.35678 14.447 5.37745C14.5378 5.4397 14.6018 5.50802 14.6736 5.61866L14.7566 5.7085C14.8985 5.79797 15.0098 5.92998 15.074 6.08643L15.114 6.15479C15.2825 6.30654 15.3421 6.39932 15.4011 6.62256L15.4324 6.67725C15.4698 6.72555 15.5026 6.76912 15.53 6.81104C15.6125 6.9368 15.6542 7.04818 15.6785 7.22998C15.7963 7.46608 15.8641 7.59305 15.8709 7.86573C15.9652 8.18459 16.0482 8.90144 15.9675 9.22022L15.9636 9.27393C15.9881 9.5393 15.869 10.3204 15.7146 10.5356L15.6824 10.647C15.6755 10.6973 15.6668 10.7452 15.655 10.7905C15.6198 10.927 15.5597 11.0447 15.4656 11.1646L15.405 11.2749C15.3905 11.3217 15.3743 11.3661 15.3572 11.4087C15.3057 11.5365 15.2386 11.648 15.1345 11.7544L15.0496 11.8784L14.9822 11.9966C14.9597 12.0325 14.9365 12.0655 14.9119 12.0972C14.8625 12.1607 14.8059 12.2189 14.7322 12.2847C14.6883 12.3338 14.6405 12.3851 14.5994 12.436C14.5183 12.5357 14.4217 12.6441 14.3142 12.7153C13.3871 13.4917 12.3151 13.971 11.0877 13.8481C11.0321 13.8421 10.9764 13.8331 10.9216 13.8218C10.8003 13.8291 10.8281 13.8382 10.7693 13.9351C10.7014 14.0469 10.6334 14.161 10.5584 14.2681C10.3586 14.5582 10.1166 14.8161 9.84059 15.0327C8.85929 15.816 7.65681 16.112 6.42457 15.9614C5.19971 15.8022 4.08485 15.1643 3.31617 14.1841C2.63727 13.3007 2.32847 12.2481 2.46461 11.1343C1.81142 10.8081 1.40548 10.5561 0.944104 9.95752C0.20581 8.98442 -0.120095 7.75268 0.0398068 6.53565C0.192553 5.27313 0.832791 4.12324 1.8191 3.33741C2.65989 2.66392 3.7312 2.35954 4.79469 2.4917C4.88937 2.32179 4.96781 2.14416 5.0691 1.9712C5.36801 1.46092 5.75559 1.06696 6.24586 0.744633ZM12.2156 4.04834C11.9845 1.9953 9.78272 0.746193 7.88356 1.23487C7.01541 1.45835 6.20386 2.04235 5.84742 2.87745C5.99817 2.98886 6.11345 3.07856 6.24781 3.20948C6.67873 3.6294 6.95256 4.35434 6.56129 4.896C6.42095 5.08993 6.20929 5.21806 5.97438 5.25147C5.70509 5.29076 5.43655 5.20299 5.22242 5.0376C4.77982 4.69563 4.62666 4.14809 4.59645 3.60889C4.21883 3.58052 3.82398 3.59571 3.46266 3.71631C1.20052 4.4719 0.35503 7.5455 1.91481 9.37452C2.20757 9.71783 2.46324 9.8433 2.82301 10.0806C2.96647 9.89528 3.08587 9.73918 3.25758 9.57959C3.67794 9.18899 4.37142 8.97135 4.86012 9.37256C5.04651 9.52664 5.16455 9.75078 5.18629 9.99366C5.21124 10.2786 5.10478 10.5412 4.92653 10.7583C4.58939 11.1688 4.05592 11.3152 3.54664 11.3481C3.54331 11.5342 3.53579 11.7471 3.5525 11.9312C3.61325 12.6004 3.96458 13.2783 4.4236 13.7593C5.09867 14.4605 6.02276 14.8587 6.98903 14.8647C7.86106 14.8779 8.72248 14.58 9.35328 13.9585C9.51459 13.8021 9.65343 13.6226 9.76442 13.4263L9.62477 13.3306C8.93541 12.8306 8.40006 11.9945 8.7566 11.1235C8.88749 10.8005 9.14058 10.5442 9.45875 10.4106C10.136 10.1314 11.0027 10.5104 11.2937 11.2036C11.4143 11.491 11.3503 11.7779 11.2263 12.0552C11.6526 12.1207 12.0885 12.0669 12.4871 11.8999C13.3653 11.5414 13.8884 10.8652 14.2478 10.0064C14.2702 9.92243 14.2964 9.83605 14.3211 9.75245C14.3926 9.54672 14.3867 9.36889 14.448 9.17041L14.4441 9.12061C14.4531 8.53044 14.4486 8.37731 14.3074 7.79346C14.2853 7.69751 14.1767 7.44618 14.1345 7.34327C13.9809 7.05757 13.9128 6.95552 13.7117 6.69873C13.4223 6.37484 13.1838 6.1991 12.7898 6.02491C12.728 6.10787 12.6518 6.21618 12.5857 6.29248C12.3996 6.48853 12.214 6.64986 11.9656 6.74073L11.8552 6.77588C11.8205 6.78734 11.7971 6.79526 11.7732 6.80127C11.7497 6.80721 11.7257 6.81134 11.6902 6.81495C11.5848 6.84905 11.3908 6.82927 11.283 6.81202C11.2259 6.79929 11.1642 6.78527 11.1101 6.76319C10.8842 6.66902 10.7045 6.48723 10.6111 6.2583C10.319 5.5366 10.962 4.85988 11.5925 4.65284C11.739 4.60477 11.9359 4.59456 12.072 4.53565L12.1502 4.51807C12.178 4.51007 12.2033 4.49874 12.2127 4.47998C12.2727 4.36007 12.2301 4.17825 12.2156 4.04834Z"
        fill="url(#paint0_linear_5335_5647)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5335_5647"
          x1="0.666619"
          y1="3.33333"
          x2="9.3334"
          y2="13.9994"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDE776" />
          <stop offset="0.244561" stopColor="#FCB29E" />
          <stop offset="0.449288" stopColor="#FB6011" />
          <stop offset="0.75098" stopColor="#9B6FF8" />
          <stop offset="0.84556" stopColor="#986FFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const AiReviewShakeIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.0001 2L4.09356 12.6879C3.74475 13.1064 3.57035 13.3157 3.56768 13.4925C3.56537 13.6461 3.63384 13.7923 3.75336 13.8889C3.89085 14 4.16328 14 4.70814 14H12.0001L11.0001 22L19.9067 11.3121C20.2555 10.8936 20.4299 10.6843 20.4325 10.5075C20.4348 10.3539 20.3664 10.2077 20.2468 10.1111C20.1094 10 19.8369 10 19.2921 10H12.0001L13.0001 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AiReviewHeartIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11L11 13L15.5 8.5M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.75009 14.4724 8.97129 18.311 10.948 20.0749C11.3114 20.3991 11.4931 20.5613 11.7058 20.6251C11.8905 20.6805 12.0958 20.6805 12.2805 20.6251C12.4932 20.5613 12.6749 20.3991 13.0383 20.0749C15.015 18.311 19.2362 14.4724 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z"
        stroke="#FB6011"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AiReviewGameIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99989 11H9.99989M7.99989 9V13M14.9999 12H15.0099M17.9999 10H18.0099M10.4488 5H13.5509C16.1758 5 17.4883 5 18.5184 5.49743C19.4254 5.9354 20.179 6.63709 20.6805 7.51059C21.2501 8.5027 21.3436 9.81181 21.5306 12.43L21.7766 15.8745C21.8973 17.5634 20.5597 19 18.8664 19C18.0005 19 17.1794 18.6154 16.6251 17.9502L16.2499 17.5C15.9068 17.0882 15.7351 16.8823 15.5398 16.7159C15.1302 16.3672 14.6344 16.1349 14.1043 16.0436C13.8514 16 13.5834 16 13.0473 16H10.9525C10.4164 16 10.1484 16 9.89553 16.0436C9.36539 16.1349 8.86957 16.3672 8.46 16.7159C8.26463 16.8823 8.09305 17.0882 7.74989 17.5L7.37473 17.9502C6.8204 18.6154 5.99924 19 5.13335 19C3.44013 19 2.1025 17.5634 2.22314 15.8745L2.46918 12.43C2.65619 9.81181 2.7497 8.5027 3.31926 7.51059C3.82074 6.63709 4.57433 5.9354 5.48135 5.49743C6.51151 5 7.82396 5 10.4488 5Z"
        stroke="#FB6011"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TipsIcon2 = ({ className }: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 7V4.66667M8 9.33333H8.00667M4.66667 12V13.557C4.66667 13.9122 4.66667 14.0898 4.73949 14.1811C4.80282 14.2604 4.89885 14.3066 5.00036 14.3065C5.11708 14.3063 5.25578 14.1954 5.53317 13.9735L7.12348 12.7012C7.44834 12.4413 7.61078 12.3114 7.79166 12.219C7.95213 12.137 8.12295 12.0771 8.29948 12.0408C8.49845 12 8.70646 12 9.1225 12H10.8C11.9201 12 12.4802 12 12.908 11.782C13.2843 11.5903 13.5903 11.2843 13.782 10.908C14 10.4802 14 9.9201 14 8.8V5.2C14 4.07989 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V9.33333C2 9.95331 2 10.2633 2.06815 10.5176C2.25308 11.2078 2.79218 11.7469 3.48236 11.9319C3.7367 12 4.04669 12 4.66667 12Z"
        stroke="#fb6011"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NoIssuesIcon = ({ className }: any) => {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_dii_5403_12272)">
        <path
          d="M2 11C2 5.47715 6.47715 1 12 1H40C45.5229 1 50 5.47715 50 11V39C50 44.5229 45.5228 49 40 49H12C6.47715 49 2 44.5228 2 39V11Z"
          fill="white"
        />
        <path
          d="M12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.7533 48.5 2.5 44.2467 2.5 39V11C2.5 5.7533 6.75329 1.5 12 1.5Z"
          stroke="#D7D3D0"
        />
        <path
          d="M18.5 35V30M18.5 20V15M16 17.5H21M16 32.5H21M27 16L25.2658 20.5089C24.9838 21.2421 24.8428 21.6087 24.6235 21.9171C24.4292 22.1904 24.1904 22.4292 23.9171 22.6235C23.6087 22.8428 23.2421 22.9838 22.5089 23.2658L18 25L22.5089 26.7342C23.2421 27.0162 23.6087 27.1572 23.9171 27.3765C24.1904 27.5708 24.4292 27.8096 24.6235 28.0829C24.8428 28.3913 24.9838 28.7579 25.2658 29.4911L27 34L28.7342 29.4911C29.0162 28.7579 29.1572 28.3913 29.3765 28.0829C29.5708 27.8096 29.8096 27.5708 30.0829 27.3765C30.3913 27.1572 30.7579 27.0162 31.4911 26.7342L36 25L31.4911 23.2658C30.7579 22.9838 30.3913 22.8428 30.0829 22.6235C29.8096 22.4292 29.5708 22.1904 29.3765 21.9171C29.1572 21.6087 29.0162 21.2421 28.7342 20.5089L27 16Z"
          stroke="#44403C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_5403_12272"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5403_12272"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5403_12272"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_5403_12272"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_5403_12272"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_5403_12272"
            result="effect3_innerShadow_5403_12272"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const BackIcon = ({ className }: any) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill="white"
      />
      <path
        d="M27 20H13M20 13L13 20L20 27"
        stroke="#44403C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TipsIcon = ({ className }: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 9.33333V7M8 4.66667H8.00667M6.6 12.8L7.57333 14.0978C7.71808 14.2908 7.79045 14.3873 7.87918 14.4218C7.95689 14.452 8.04311 14.452 8.12082 14.4218C8.20955 14.3873 8.28192 14.2908 8.42667 14.0978L9.4 12.8C9.59543 12.5394 9.69315 12.4091 9.81234 12.3097C9.97126 12.177 10.1589 12.0832 10.3603 12.0357C10.5114 12 10.6743 12 11 12C11.9319 12 12.3978 12 12.7654 11.8478C13.2554 11.6448 13.6448 11.2554 13.8478 10.7654C14 10.3978 14 9.93188 14 9V5.2C14 4.07989 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V9C2 9.93188 2 10.3978 2.15224 10.7654C2.35523 11.2554 2.74458 11.6448 3.23463 11.8478C3.60218 12 4.06812 12 5 12C5.32572 12 5.48858 12 5.63967 12.0357C5.84113 12.0832 6.02874 12.177 6.18766 12.3097C6.30685 12.4091 6.40457 12.5394 6.6 12.8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EditIcon = ({ className }: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 20H21M3.00003 20H4.67457C5.16376 20 5.40835 20 5.63852 19.9447C5.84259 19.8957 6.03768 19.8149 6.21663 19.7053C6.41846 19.5816 6.59141 19.4086 6.93732 19.0627L19.5001 6.49998C20.3285 5.67156 20.3285 4.32841 19.5001 3.49998C18.6716 2.67156 17.3285 2.67156 16.5001 3.49998L3.93729 16.0627C3.59139 16.4086 3.41843 16.5816 3.29475 16.7834C3.18509 16.9624 3.10428 17.1574 3.05529 17.3615C3.00003 17.5917 3.00003 17.8363 3.00003 18.3255V20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LightIcon = ({ className }: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.67358 13.6625C5.3103 12.6459 4.42749 11.0208 4.42749 9.18945C4.42749 6.10982 6.92401 3.61328 10.0037 3.61328C13.0833 3.61328 15.5798 6.10982 15.5798 9.18945C15.5798 11.0295 14.6886 12.6614 13.3142 13.677V14.0332C13.3142 14.5024 12.9338 14.8828 12.4646 14.8828H7.52319C7.05395 14.8828 6.67358 14.5024 6.67358 14.0332V13.6625ZM7.69897 15.4297H12.2888C12.758 15.4297 13.1384 15.8101 13.1384 16.2793C13.1384 16.7485 12.758 17.1289 12.2888 17.1289H7.69897C7.22973 17.1289 6.84936 16.7485 6.84936 16.2793C6.84936 15.8101 7.22973 15.4297 7.69897 15.4297ZM8.92944 17.6758H11.0583C11.5276 17.6758 11.908 18.0562 11.908 18.5254C11.908 18.9946 11.5276 19.375 11.0583 19.375H8.92944C8.4602 19.375 8.07983 18.9946 8.07983 18.5254C8.07983 18.0562 8.4602 17.6758 8.92944 17.6758ZM9.99389 0.625C10.4254 0.625 10.7751 0.974785 10.7751 1.40625V1.85547C10.7751 2.28693 10.4254 2.63672 9.99389 2.63672C9.56241 2.63672 9.21264 2.28693 9.21264 1.85547V1.40625C9.21264 0.974785 9.56241 0.625 9.99389 0.625ZM15.7187 2.70867C16.0492 2.98602 16.0924 3.47879 15.815 3.80932L15.5263 4.15344C15.2489 4.48396 14.7561 4.52707 14.4256 4.24973C14.0951 3.97238 14.052 3.47961 14.3293 3.14908L14.6181 2.80496C14.8954 2.47443 15.3882 2.43133 15.7187 2.70867ZM18.7649 7.98469C18.8398 8.40961 18.5561 8.81482 18.1311 8.88975L17.6888 8.96775C17.2638 9.04268 16.8586 8.75895 16.7837 8.33402C16.7088 7.9091 16.9925 7.50391 17.4174 7.42898L17.8598 7.35098C18.2847 7.27605 18.6899 7.55977 18.7649 7.98469ZM17.7069 13.9844C17.4912 14.358 17.0134 14.4861 16.6397 14.2703L16.2507 14.0457C15.877 13.83 15.749 13.3522 15.9647 12.9785C16.1805 12.6048 16.6583 12.4768 17.0319 12.6926L17.421 12.9172C17.7946 13.1329 17.9227 13.6107 17.7069 13.9844ZM2.28085 13.9844C2.0651 13.6107 2.19315 13.1329 2.5668 12.9172L2.95585 12.6926C3.3295 12.4768 3.80731 12.6049 4.02303 12.9785C4.23878 13.3522 4.11075 13.83 3.7371 14.0457L3.34805 14.2703C2.97438 14.4861 2.49657 14.358 2.28085 13.9844ZM1.22294 7.98469C1.29788 7.55979 1.70307 7.27605 2.12799 7.35098L2.57038 7.42898C2.9953 7.50391 3.27903 7.9091 3.20411 8.33402C3.12917 8.75895 2.72397 9.04268 2.29905 8.96775L1.85667 8.88975C1.43174 8.81482 1.14801 8.40961 1.22294 7.98469ZM4.26907 2.70867C4.5996 2.43133 5.09237 2.47443 5.36971 2.80496L5.65846 3.14908C5.93581 3.47961 5.8927 3.97238 5.56217 4.24973C5.23165 4.52707 4.73885 4.48396 4.46151 4.15344L4.17276 3.80932C3.89542 3.47879 3.93854 2.98602 4.26905 2.70867H4.26907Z"
        fill="#FB923C"
      />
    </svg>
  );
};
export const TrashIcon = ({ className }: any) => {
  return (
    <svg
      width="83"
      height="59"
      className={className}
      viewBox="0 0 83 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ddddddii_7100_21678)">
        <path
          d="M7.4632 11.4632C7.4632 9.25406 9.25406 7.4632 11.4632 7.4632H51.4632C53.6723 7.4632 55.4632 9.25406 55.4632 11.4632V27.4632C55.4632 29.6723 53.6723 31.4632 51.4632 31.4632H11.4632C9.25406 31.4632 7.4632 29.6723 7.4632 27.4632V11.4632Z"
          fill="#F4F4F4"
        />
        <g filter="url(#filter1_d_7100_21678)">
          <path d="M19.4632 15.4632V23.4632" stroke="#D4D4D4" />
        </g>
        <g filter="url(#filter2_d_7100_21678)">
          <path d="M31.4632 15.4632V23.4632" stroke="#D4D4D4" />
        </g>
        <g filter="url(#filter3_d_7100_21678)">
          <path d="M43.4632 15.4632V23.4632" stroke="#D4D4D4" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_ddddddii_7100_21678"
          x="-3.8147e-06"
          y="-3.8147e-06"
          width="82.9264"
          height="58.9264"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.5" dy="-0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7100_21678"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3.75"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_7100_21678"
          />
          <feOffset dx="10" dy="10" />
          <feGaussianBlur stdDeviation="10.6066" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.055 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7100_21678"
            result="effect2_dropShadow_7100_21678"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_7100_21678"
          />
          <feOffset dx="5.90083" dy="5.90083" />
          <feGaussianBlur stdDeviation="4.17251" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.192 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_7100_21678"
            result="effect3_dropShadow_7100_21678"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.25"
            operator="erode"
            in="SourceAlpha"
            result="effect4_dropShadow_7100_21678"
          />
          <feOffset dx="2.6583" dy="2.6583" />
          <feGaussianBlur stdDeviation="1.8797" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_7100_21678"
            result="effect4_dropShadow_7100_21678"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.5"
            operator="erode"
            in="SourceAlpha"
            result="effect5_dropShadow_7100_21678"
          />
          <feOffset dx="1.21072" dy="1.21072" />
          <feGaussianBlur stdDeviation="0.85611" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.247 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_7100_21678"
            result="effect5_dropShadow_7100_21678"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect6_dropShadow_7100_21678"
          />
          <feOffset dx="0.444584" dy="0.444584" />
          <feGaussianBlur stdDeviation="0.314368" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_7100_21678"
            result="effect6_dropShadow_7100_21678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_7100_21678"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect7_innerShadow_7100_21678"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect7_innerShadow_7100_21678"
            result="effect8_innerShadow_7100_21678"
          />
        </filter>
        <filter
          id="filter1_d_7100_21678"
          x="17.9632"
          y="15.4632"
          width="2"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7100_21678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7100_21678"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_7100_21678"
          x="29.9632"
          y="15.4632"
          width="2"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7100_21678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7100_21678"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7100_21678"
          x="41.9632"
          y="15.4632"
          width="2"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7100_21678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7100_21678"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ScreeningQuestionsIcon = ({ className }: any) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_21_769)">
        <path
          d="M15 7.125V5.1C15 3.83988 15 3.20982 14.7548 2.72852C14.539 2.30516 14.1948 1.96095 13.7715 1.74524C13.2902 1.5 12.6601 1.5 11.4 1.5H6.6C5.33988 1.5 4.70982 1.5 4.22852 1.74524C3.80516 1.96095 3.46095 2.30516 3.24524 2.72852C3 3.20982 3 3.83988 3 5.1V12.9C3 14.1601 3 14.7902 3.24524 15.2715C3.46095 15.6948 3.80516 16.039 4.22852 16.2548C4.70982 16.5 5.33988 16.5 6.6 16.5H10.5M10.5 8.25H6M7.5 11.25H6M12 5.25H6M12.375 11.2517C12.5071 10.876 12.768 10.5593 13.1113 10.3575C13.4546 10.1557 13.8583 10.082 14.2508 10.1493C14.6433 10.2166 14.9993 10.4207 15.2557 10.7253C15.5122 11.03 15.6525 11.4155 15.6519 11.8138C15.6519 12.9379 13.9657 13.5 13.9657 13.5M13.9874 15.75H13.9949"
          stroke="#1C1917"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_769">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EditIcon2 = ({ className }: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_447_12114)">
        <path
          d="M7.33398 2.66617L4.53398 2.66617C3.41388 2.66617 2.85383 2.66617 2.426 2.88415C2.04968 3.0759 1.74372 3.38186 1.55197 3.75819C1.33398 4.18601 1.33398 4.74606 1.33398 5.86617L1.33398 11.4662C1.33398 12.5863 1.33398 13.1463 1.55197 13.5741C1.74372 13.9505 2.04968 14.2564 2.426 14.4482C2.85383 14.6662 3.41388 14.6662 4.53398 14.6662L10.134 14.6662C11.2541 14.6662 11.8141 14.6662 12.242 14.4482C12.6183 14.2564 12.9243 13.9505 13.116 13.5741C13.334 13.1463 13.334 12.5863 13.334 11.4662V8.66617M5.33397 10.6662H6.45033C6.77645 10.6662 6.93951 10.6662 7.09296 10.6293C7.22901 10.5967 7.35907 10.5428 7.47836 10.4697C7.61292 10.3872 7.72822 10.2719 7.95882 10.0413L14.334 3.66617C14.8863 3.11388 14.8863 2.21845 14.334 1.66617C13.7817 1.11388 12.8863 1.11388 12.334 1.66617L5.95881 8.04133C5.7282 8.27193 5.6129 8.38723 5.53045 8.52179C5.45734 8.64108 5.40347 8.77114 5.37081 8.90719C5.33397 9.06064 5.33397 9.2237 5.33397 9.54982L5.33397 10.6662Z"
          stroke="#A3A3A3"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_447_12114">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CalendarClockIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className}
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 2C5.33333 1.63181 5.03486 1.33333 4.66667 1.33333C4.29848 1.33333 4 1.63181 4 2H2.66664C1.93026 2 1.33333 2.59695 1.33333 3.33333V13.3333C1.33333 14.0697 1.93029 14.6667 2.66667 14.6667H7.83642C7.51492 14.2656 7.25017 13.8171 7.05435 13.3333H2.66667V3.33333H4C4 3.70152 4.29848 4 4.66667 4C5.03486 4 5.33333 3.70152 5.33333 3.33333H10.6667C10.6667 3.70152 10.9651 4 11.3333 4C11.7015 4 12 3.70152 12 3.33333H13.3333V6.16802C13.8064 6.28977 14.254 6.47479 14.6667 6.71351V3.33333C14.6667 2.59695 14.0697 2 13.3334 2H12C12 1.63181 11.7015 1.33333 11.3333 1.33333C10.9651 1.33333 10.6667 1.63181 10.6667 2H5.33333Z"
        fill="#404040"
      />
      <path
        d="M5.33333 8.66667C5.70152 8.66667 6 8.96514 6 9.33333V10C6 10.3682 5.70152 10.6667 5.33333 10.6667H4.66667C4.29848 10.6667 4 10.3682 4 10V9.33333C4 8.96514 4.29848 8.66667 4.66667 8.66667H5.33333Z"
        fill="#404040"
      />
      <path
        d="M4.66667 5.33333C4.29848 5.33333 4 5.63181 4 6V6.66667C4 7.03486 4.29848 7.33333 4.66667 7.33333H5.33333C5.70152 7.33333 6 7.03486 6 6.66667V6C6 5.63181 5.70152 5.33333 5.33333 5.33333H4.66667Z"
        fill="#404040"
      />
      <path
        d="M11.3333 10C11.3333 9.63181 11.6318 9.33333 12 9.33333C12.3682 9.33333 12.6667 9.63181 12.6667 10V10.6667H13.3333C13.7015 10.6667 14 10.9651 14 11.3333C14 11.7015 13.7015 12 13.3333 12H12C11.6318 12 11.3333 11.7015 11.3333 11.3333V10Z"
        fill="#404040"
      />
      <path
        d="M12 15.3333C14.2091 15.3333 16 13.5425 16 11.3333C16 9.12419 14.2091 7.33333 12 7.33333C9.79086 7.33333 8 9.12419 8 11.3333C8 13.5425 9.79086 15.3333 12 15.3333ZM12 14C10.5272 14 9.33333 12.8061 9.33333 11.3333C9.33333 9.86057 10.5272 8.66667 12 8.66667C13.4728 8.66667 14.6667 9.86057 14.6667 11.3333C14.6667 12.8061 13.4728 14 12 14Z"
        fill="#404040"
      />
      <path
        d="M9.33333 6C9.33333 5.63181 9.03486 5.33333 8.66667 5.33333H8C7.63181 5.33333 7.33333 5.63181 7.33333 6V6.66667C7.33333 7.03486 7.63181 7.33333 8 7.33333H8.66667C9.03486 7.33333 9.33333 7.03486 9.33333 6.66667V6Z"
        fill="#404040"
      />
    </svg>
  );
};

export const XCloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className}
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="#525252"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HolidayNoticeDivider = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className}
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="100"
      height="1"
      viewBox="0 0 100 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.3" d="M0 0.5H100" stroke="#FF621D" />
    </svg>
  );
};
